var map = {
	"./App": [
		795,
		9
	],
	"./App.helper": [
		389,
		9
	],
	"./App.helper.ts": [
		389,
		9
	],
	"./App.interface": [
		59,
		9
	],
	"./App.interface.ts": [
		59,
		9
	],
	"./App.scss": [
		1090,
		7
	],
	"./App.tsx": [
		795,
		9
	],
	"./Root": [
		35,
		9
	],
	"./Root.tsx": [
		35,
		9
	],
	"./containers/Account/AccountContainer": [
		993,
		9,
		18,
		110
	],
	"./containers/Account/AccountContainer.tsx": [
		993,
		9,
		18,
		110
	],
	"./containers/ActiveProjectsList/ActiveProjectsList": [
		1757,
		9,
		282
	],
	"./containers/ActiveProjectsList/ActiveProjectsList.scss": [
		2832,
		7,
		557
	],
	"./containers/ActiveProjectsList/ActiveProjectsList.tsx": [
		1757,
		9,
		282
	],
	"./containers/Announcement/AnnouncementContainer": [
		447,
		9
	],
	"./containers/Announcement/AnnouncementContainer.tsx": [
		447,
		9
	],
	"./containers/Archive/ArchiveContainer": [
		446,
		9
	],
	"./containers/Archive/ArchiveContainer.tsx": [
		446,
		9
	],
	"./containers/Archive/ArchiveProjectContainer": [
		328,
		9
	],
	"./containers/Archive/ArchiveProjectContainer.tsx": [
		328,
		9
	],
	"./containers/ArchiveProjectDescription/ArchiveProjectDescription": [
		574,
		9
	],
	"./containers/ArchiveProjectDescription/ArchiveProjectDescription.scss": [
		1109,
		7
	],
	"./containers/ArchiveProjectDescription/ArchiveProjectDescription.tsx": [
		574,
		9
	],
	"./containers/Auth/RequireAuth": [
		1758,
		9,
		351
	],
	"./containers/Auth/RequireAuth.tsx": [
		1758,
		9,
		351
	],
	"./containers/Auth/RequireNoAuth": [
		1759,
		9,
		352
	],
	"./containers/Auth/RequireNoAuth.tsx": [
		1759,
		9,
		352
	],
	"./containers/ChangePassword/ChangePasswordContainer": [
		452,
		9
	],
	"./containers/ChangePassword/ChangePasswordContainer.tsx": [
		452,
		9
	],
	"./containers/CompletedIdeasWrapper/CompletedIdeasWrapper": [
		615,
		9
	],
	"./containers/CompletedIdeasWrapper/CompletedIdeasWrapper.module.scss": [
		472,
		7
	],
	"./containers/CompletedIdeasWrapper/CompletedIdeasWrapper.tsx": [
		615,
		9
	],
	"./containers/ConfirmModalProvider/ConfirmModalProvider": [
		385,
		9
	],
	"./containers/ConfirmModalProvider/ConfirmModalProvider.tsx": [
		385,
		9
	],
	"./containers/Current/CurrentContainer": [
		448,
		9
	],
	"./containers/Current/CurrentContainer.tsx": [
		448,
		9
	],
	"./containers/EventsTrack/EventsTrackContainer": [
		444,
		9
	],
	"./containers/EventsTrack/EventsTrackContainer.tsx": [
		444,
		9
	],
	"./containers/EventsTrack/EventsTrackParentIdContext": [
		132,
		9
	],
	"./containers/EventsTrack/EventsTrackParentIdContext.tsx": [
		132,
		9
	],
	"./containers/EventsTrack/wrappers/EventsTrackWrapper.interface": [
		1760,
		9,
		353
	],
	"./containers/EventsTrack/wrappers/EventsTrackWrapper.interface.ts": [
		1760,
		9,
		353
	],
	"./containers/EventsTrack/wrappers/EventsTrackWrapperBase": [
		368,
		9
	],
	"./containers/EventsTrack/wrappers/EventsTrackWrapperBase.tsx": [
		368,
		9
	],
	"./containers/EventsTrack/wrappers/EventsTrackWrapperClick": [
		22,
		9
	],
	"./containers/EventsTrack/wrappers/EventsTrackWrapperClick.tsx": [
		22,
		9
	],
	"./containers/EventsTrack/wrappers/EventsTrackWrapperScroll": [
		118,
		9
	],
	"./containers/EventsTrack/wrappers/EventsTrackWrapperScroll.tsx": [
		118,
		9
	],
	"./containers/EventsTrack/wrappers/helpers/EventsTrackClickCheckbox": [
		292,
		9
	],
	"./containers/EventsTrack/wrappers/helpers/EventsTrackClickCheckbox.tsx": [
		292,
		9
	],
	"./containers/EventsTrack/wrappers/helpers/EventsTrackClickFileSelectorLabel": [
		294,
		9
	],
	"./containers/EventsTrack/wrappers/helpers/EventsTrackClickFileSelectorLabel.tsx": [
		294,
		9
	],
	"./containers/EventsTrack/wrappers/helpers/EventsTrackClickInput": [
		216,
		9
	],
	"./containers/EventsTrack/wrappers/helpers/EventsTrackClickInput.tsx": [
		216,
		9
	],
	"./containers/EventsTrack/wrappers/helpers/EventsTrackClickModalCloseBtn": [
		231,
		9
	],
	"./containers/EventsTrack/wrappers/helpers/EventsTrackClickModalCloseBtn.tsx": [
		231,
		9
	],
	"./containers/EventsTrack/wrappers/helpers/EventsTrackClickSelectInput": [
		181,
		9
	],
	"./containers/EventsTrack/wrappers/helpers/EventsTrackClickSelectInput.tsx": [
		181,
		9
	],
	"./containers/EventsTrack/wrappers/helpers/EventsTrackClickSelectInputEditable": [
		621,
		9
	],
	"./containers/EventsTrack/wrappers/helpers/EventsTrackClickSelectInputEditable.tsx": [
		621,
		9
	],
	"./containers/EventsTrack/wrappers/helpers/EventsTrackClickSelectItem": [
		182,
		9
	],
	"./containers/EventsTrack/wrappers/helpers/EventsTrackClickSelectItem.tsx": [
		182,
		9
	],
	"./containers/EventsTrack/wrappers/helpers/EventsTrackClickTextarea": [
		293,
		9
	],
	"./containers/EventsTrack/wrappers/helpers/EventsTrackClickTextarea.tsx": [
		293,
		9
	],
	"./containers/Footer/Footer": [
		810,
		9
	],
	"./containers/Footer/Footer.module.scss": [
		340,
		7
	],
	"./containers/Footer/Footer.tsx": [
		810,
		9
	],
	"./containers/Footer/FooterInfo/FooterInfo": [
		707,
		9
	],
	"./containers/Footer/FooterInfo/FooterInfo.module.scss": [
		479,
		7
	],
	"./containers/Footer/FooterInfo/FooterInfo.tsx": [
		707,
		9
	],
	"./containers/Footer/FooterRoute/FooterRoute": [
		709,
		9
	],
	"./containers/Footer/FooterRoute/FooterRoute.module.scss": [
		319,
		7
	],
	"./containers/Footer/FooterRoute/FooterRoute.tsx": [
		709,
		9
	],
	"./containers/Footer/FooterRoutes/FooterRoutes": [
		708,
		9
	],
	"./containers/Footer/FooterRoutes/FooterRoutes.module.scss": [
		982,
		7
	],
	"./containers/Footer/FooterRoutes/FooterRoutes.tsx": [
		708,
		9
	],
	"./containers/Footer/FooterSocial/FooterSocial": [
		710,
		9
	],
	"./containers/Footer/FooterSocial/FooterSocial.module.scss": [
		341,
		7
	],
	"./containers/Footer/FooterSocial/FooterSocial.tsx": [
		710,
		9
	],
	"./containers/Footer/SocialNetworks/FooterSocialNetworks": [
		819,
		9
	],
	"./containers/Footer/SocialNetworks/FooterSocialNetworks.tsx": [
		819,
		9
	],
	"./containers/Footer/SocialNetworks/SocialNetworks.module.scss": [
		845,
		7
	],
	"./containers/Forms/AfterRegistrationForm/AfterRegistrationForm": [
		351,
		9
	],
	"./containers/Forms/AfterRegistrationForm/AfterRegistrationForm.scss": [
		1378,
		7
	],
	"./containers/Forms/AfterRegistrationForm/AfterRegistrationForm.tsx": [
		351,
		9
	],
	"./containers/Forms/AuthForm/AuthForm": [
		167,
		9
	],
	"./containers/Forms/AuthForm/AuthForm.scss": [
		1102,
		7
	],
	"./containers/Forms/AuthForm/AuthForm.tsx": [
		167,
		9
	],
	"./containers/Forms/ChangePasswordForm/ChangePasswordForm": [
		296,
		9
	],
	"./containers/Forms/ChangePasswordForm/ChangePasswordForm.scss": [
		1216,
		7
	],
	"./containers/Forms/ChangePasswordForm/ChangePasswordForm.tsx": [
		296,
		9
	],
	"./containers/Forms/PhotoIdeaForm/PhotoIdeaForm": [
		799,
		9
	],
	"./containers/Forms/PhotoIdeaForm/PhotoIdeaForm.module.scss": [
		270,
		7
	],
	"./containers/Forms/PhotoIdeaForm/PhotoIdeaForm.tsx": [
		799,
		9
	],
	"./containers/Forms/ProposeIdeaForm/ProposeIdeaForm": [
		130,
		9
	],
	"./containers/Forms/ProposeIdeaForm/ProposeIdeaForm.scss": [
		965,
		7
	],
	"./containers/Forms/ProposeIdeaForm/ProposeIdeaForm.tsx": [
		130,
		9
	],
	"./containers/Forms/ProposeIdeaForm/ProposeIdeaSubmittedForm": [
		140,
		9
	],
	"./containers/Forms/ProposeIdeaForm/ProposeIdeaSubmittedForm.tsx": [
		140,
		9
	],
	"./containers/Forms/SendIdeaForm/SendIdeaForm": [
		196,
		9
	],
	"./containers/Forms/SendIdeaForm/SendIdeaForm.scss": [
		1163,
		7
	],
	"./containers/Forms/SendIdeaForm/SendIdeaForm.tsx": [
		196,
		9
	],
	"./containers/Forms/SendRestoreEmailForm/SendRestoreEmailForm": [
		629,
		9
	],
	"./containers/Forms/SendRestoreEmailForm/SendRestoreEmailForm.scss": [
		1217,
		7
	],
	"./containers/Forms/SendRestoreEmailForm/SendRestoreEmailForm.tsx": [
		629,
		9
	],
	"./containers/Forms/SubmitForm/SubmitForm": [
		197,
		9
	],
	"./containers/Forms/SubmitForm/SubmitForm.scss": [
		1155,
		7
	],
	"./containers/Forms/SubmitForm/SubmitForm.tsx": [
		197,
		9
	],
	"./containers/Forms/SupportForm/SupportForm": [
		192,
		9
	],
	"./containers/Forms/SupportForm/SupportForm.scss": [
		1221,
		7
	],
	"./containers/Forms/SupportForm/SupportForm.tsx": [
		192,
		9
	],
	"./containers/Forms/TeamLoginForm/TeamLoginForm": [
		1705,
		9,
		283
	],
	"./containers/Forms/TeamLoginForm/TeamLoginForm.scss": [
		2785,
		7,
		558
	],
	"./containers/Forms/TeamLoginForm/TeamLoginForm.tsx": [
		1705,
		9,
		283
	],
	"./containers/Header/CrossPromo/CrossPromo": [
		567,
		9
	],
	"./containers/Header/CrossPromo/CrossPromo.helper": [
		569,
		9
	],
	"./containers/Header/CrossPromo/CrossPromo.helper.tsx": [
		569,
		9
	],
	"./containers/Header/CrossPromo/CrossPromo.scss": [
		1095,
		7
	],
	"./containers/Header/CrossPromo/CrossPromo.tsx": [
		567,
		9
	],
	"./containers/Header/CrossPromo/CrossPromoPopup/CrossPromoPopup": [
		568,
		9
	],
	"./containers/Header/CrossPromo/CrossPromoPopup/CrossPromoPopup.scss": [
		1096,
		7
	],
	"./containers/Header/CrossPromo/CrossPromoPopup/CrossPromoPopup.tsx": [
		568,
		9
	],
	"./containers/Header/Header": [
		555,
		9
	],
	"./containers/Header/Header.scss": [
		1092,
		7
	],
	"./containers/Header/Header.tsx": [
		555,
		9
	],
	"./containers/Header/HeaderContainer": [
		445,
		9
	],
	"./containers/Header/HeaderContainer.tsx": [
		445,
		9
	],
	"./containers/Header/HeaderLinks": [
		556,
		9
	],
	"./containers/Header/HeaderLinks.tsx": [
		556,
		9
	],
	"./containers/Header/HeaderLoggedIn": [
		559,
		9
	],
	"./containers/Header/HeaderLoggedIn.tsx": [
		559,
		9
	],
	"./containers/Header/HeaderLoggedOut": [
		560,
		9
	],
	"./containers/Header/HeaderLoggedOut.tsx": [
		560,
		9
	],
	"./containers/Header/HeaderMobileLinks": [
		561,
		9
	],
	"./containers/Header/HeaderMobileLinks.tsx": [
		561,
		9
	],
	"./containers/Header/HeaderMobileRoute": [
		562,
		9
	],
	"./containers/Header/HeaderMobileRoute.tsx": [
		562,
		9
	],
	"./containers/Header/HeaderProfile": [
		558,
		9
	],
	"./containers/Header/HeaderProfile.tsx": [
		558,
		9
	],
	"./containers/Header/HeaderRoute": [
		557,
		9
	],
	"./containers/Header/HeaderRoute.tsx": [
		557,
		9
	],
	"./containers/Header/HeaderUserLink": [
		370,
		9
	],
	"./containers/Header/HeaderUserLink.tsx": [
		370,
		9
	],
	"./containers/Header/Logo/Logo": [
		138,
		9
	],
	"./containers/Header/Logo/Logo.scss": [
		1091,
		7
	],
	"./containers/Header/Logo/Logo.tsx": [
		138,
		9
	],
	"./containers/Header/Menu/Menu": [
		1761,
		9,
		284
	],
	"./containers/Header/Menu/Menu.scss": [
		2833,
		7,
		559
	],
	"./containers/Header/Menu/Menu.tsx": [
		1761,
		9,
		284
	],
	"./containers/Header/TopSection/Links/Link": [
		371,
		9
	],
	"./containers/Header/TopSection/Links/Link.module.scss": [
		974,
		7
	],
	"./containers/Header/TopSection/Links/Link.tsx": [
		371,
		9
	],
	"./containers/Header/TopSection/Links/MayorLink": [
		564,
		9
	],
	"./containers/Header/TopSection/Links/MayorLink.module.scss": [
		409,
		7
	],
	"./containers/Header/TopSection/Links/MayorLink.tsx": [
		564,
		9
	],
	"./containers/Header/TopSection/Links/helpers": [
		566,
		9
	],
	"./containers/Header/TopSection/Links/helpers.ts": [
		566,
		9
	],
	"./containers/Header/TopSection/Links/linksData": [
		565,
		9
	],
	"./containers/Header/TopSection/Links/linksData.ts": [
		565,
		9
	],
	"./containers/Header/TopSection/TopSection": [
		563,
		9
	],
	"./containers/Header/TopSection/TopSection.module.scss": [
		246,
		7
	],
	"./containers/Header/TopSection/TopSection.tsx": [
		563,
		9
	],
	"./containers/Header/header.helpers": [
		369,
		9
	],
	"./containers/Header/header.helpers.ts": [
		369,
		9
	],
	"./containers/IdeasList/Ideas.interface": [
		1762,
		9,
		354
	],
	"./containers/IdeasList/Ideas.interface.ts": [
		1762,
		9,
		354
	],
	"./containers/IdeasList/IdeasList": [
		751,
		9
	],
	"./containers/IdeasList/IdeasList.scss": [
		1414,
		7
	],
	"./containers/IdeasList/IdeasList.tsx": [
		751,
		9
	],
	"./containers/IdeasPhotoList/IdeasPhotoList": [
		691,
		9
	],
	"./containers/IdeasPhotoList/IdeasPhotoList.interface": [
		1763,
		9,
		355
	],
	"./containers/IdeasPhotoList/IdeasPhotoList.interface.ts": [
		1763,
		9,
		355
	],
	"./containers/IdeasPhotoList/IdeasPhotoList.module.scss": [
		162,
		7
	],
	"./containers/IdeasPhotoList/IdeasPhotoList.tsx": [
		691,
		9
	],
	"./containers/MayorAppeal/MayorAppealContainer": [
		450,
		9
	],
	"./containers/MayorAppeal/MayorAppealContainer.tsx": [
		450,
		9
	],
	"./containers/Modal/AppModal": [
		37,
		9
	],
	"./containers/Modal/AppModal.scss": [
		1156,
		7
	],
	"./containers/Modal/AppModal.tsx": [
		37,
		9
	],
	"./containers/Modal/CloseButton/CloseButton": [
		289,
		9
	],
	"./containers/Modal/CloseButton/CloseButton.scss": [
		1100,
		7
	],
	"./containers/Modal/CloseButton/CloseButton.tsx": [
		289,
		9
	],
	"./containers/Modals/AppModal/AppModal": [
		383,
		9
	],
	"./containers/Modals/AppModal/AppModal.module.scss": [
		842,
		7
	],
	"./containers/Modals/AppModal/AppModal.tsx": [
		383,
		9
	],
	"./containers/Modals/AppModal/AppModalCloseIcon/AppModalCloseIcon": [
		620,
		9
	],
	"./containers/Modals/AppModal/AppModalCloseIcon/AppModalCloseIcon.module.scss": [
		980,
		7
	],
	"./containers/Modals/AppModal/AppModalCloseIcon/AppModalCloseIcon.tsx": [
		620,
		9
	],
	"./containers/Modals/AppModal/AppModalPhoneHeader/AppModalPhoneHeader": [
		619,
		9
	],
	"./containers/Modals/AppModal/AppModalPhoneHeader/AppModalPhoneHeader.module.scss": [
		841,
		7
	],
	"./containers/Modals/AppModal/AppModalPhoneHeader/AppModalPhoneHeader.tsx": [
		619,
		9
	],
	"./containers/Modals/AuthChildForbidden/AuthChildForbidden": [
		787,
		9
	],
	"./containers/Modals/AuthChildForbidden/AuthChildForbidden.scss": [
		1451,
		7
	],
	"./containers/Modals/AuthChildForbidden/AuthChildForbidden.tsx": [
		787,
		9
	],
	"./containers/Modals/AvatarModal/AvatarModal": [
		533,
		9
	],
	"./containers/Modals/AvatarModal/AvatarModal.scss": [
		1376,
		7
	],
	"./containers/Modals/AvatarModal/AvatarModal.tsx": [
		533,
		9
	],
	"./containers/Modals/CommonViewer/CommonViewer": [
		381,
		9
	],
	"./containers/Modals/CommonViewer/CommonViewer.scss": [
		1190,
		7
	],
	"./containers/Modals/CommonViewer/CommonViewer.tsx": [
		381,
		9
	],
	"./containers/Modals/ConfirmModal/ConfirmModal": [
		384,
		9
	],
	"./containers/Modals/ConfirmModal/ConfirmModal.tsx": [
		384,
		9
	],
	"./containers/Modals/CropAvatarModal/CropAvatarModal": [
		534,
		9
	],
	"./containers/Modals/CropAvatarModal/CropAvatarModal.scss": [
		1377,
		7
	],
	"./containers/Modals/CropAvatarModal/CropAvatarModal.tsx": [
		534,
		9
	],
	"./containers/Modals/ExternalProjectModal/ExternalProjectModal": [
		1764,
		9,
		285
	],
	"./containers/Modals/ExternalProjectModal/ExternalProjectModal.scss": [
		2834,
		7,
		560
	],
	"./containers/Modals/ExternalProjectModal/ExternalProjectModal.tsx": [
		1764,
		9,
		285
	],
	"./containers/Modals/HeaderModal/HeaderModal": [
		571,
		9
	],
	"./containers/Modals/HeaderModal/HeaderModal.scss": [
		1099,
		7
	],
	"./containers/Modals/HeaderModal/HeaderModal.tsx": [
		571,
		9
	],
	"./containers/Modals/IdeaMapModal/IdeaMapModal": [
		1765,
		9,
		248
	],
	"./containers/Modals/IdeaMapModal/IdeaMapModal.scss": [
		2835,
		7,
		561
	],
	"./containers/Modals/IdeaMapModal/IdeaMapModal.tsx": [
		1765,
		9,
		248
	],
	"./containers/Modals/IdeasPhotoBrowser/IdeasPhotoBrowser": [
		618,
		9
	],
	"./containers/Modals/IdeasPhotoBrowser/IdeasPhotoBrowser.module.scss": [
		337,
		7
	],
	"./containers/Modals/IdeasPhotoBrowser/IdeasPhotoBrowser.tsx": [
		618,
		9
	],
	"./containers/Modals/IdeasPhotoViewer/IdeasPhotoViewer": [
		387,
		9
	],
	"./containers/Modals/IdeasPhotoViewer/IdeasPhotoViewer.scss": [
		1332,
		7
	],
	"./containers/Modals/IdeasPhotoViewer/IdeasPhotoViewer.tsx": [
		387,
		9
	],
	"./containers/Modals/InfoModal/InfoModal": [
		789,
		9
	],
	"./containers/Modals/InfoModal/InfoModal.scss": [
		1453,
		7
	],
	"./containers/Modals/InfoModal/InfoModal.tsx": [
		789,
		9
	],
	"./containers/Modals/JobReportsModal/JobReportsModal": [
		695,
		9
	],
	"./containers/Modals/JobReportsModal/JobReportsModal.module.scss": [
		222,
		7
	],
	"./containers/Modals/JobReportsModal/JobReportsModal.tsx": [
		695,
		9
	],
	"./containers/Modals/MaintenanceModal/MaintenanceModal": [
		790,
		9
	],
	"./containers/Modals/MaintenanceModal/MaintenanceModal.scss": [
		1454,
		7
	],
	"./containers/Modals/MaintenanceModal/MaintenanceModal.tsx": [
		790,
		9
	],
	"./containers/Modals/PhotoCardModal/PhotoCardModal": [
		1766,
		9,
		286
	],
	"./containers/Modals/PhotoCardModal/PhotoCardModal.scss": [
		2836,
		7,
		562
	],
	"./containers/Modals/PhotoCardModal/PhotoCardModal.tsx": [
		1766,
		9,
		286
	],
	"./containers/Modals/QrCodeModal/QrCodeModal": [
		570,
		9
	],
	"./containers/Modals/QrCodeModal/QrCodeModal.scss": [
		1097,
		7
	],
	"./containers/Modals/QrCodeModal/QrCodeModal.tsx": [
		570,
		9
	],
	"./containers/Modals/ResendEmailModal/ResendEmailModal": [
		352,
		9
	],
	"./containers/Modals/ResendEmailModal/ResendEmailModal.scss": [
		1379,
		7
	],
	"./containers/Modals/ResendEmailModal/ResendEmailModal.tsx": [
		352,
		9
	],
	"./containers/Modals/SendSuccessModal/SendSuccessModal": [
		592,
		9
	],
	"./containers/Modals/SendSuccessModal/SendSuccessModal.scss": [
		1164,
		7
	],
	"./containers/Modals/SendSuccessModal/SendSuccessModal.tsx": [
		592,
		9
	],
	"./containers/Modals/UserDetailsModal/UserDetailsModal": [
		295,
		9
	],
	"./containers/Modals/UserDetailsModal/UserDetailsModal.scss": [
		1209,
		7
	],
	"./containers/Modals/UserDetailsModal/UserDetailsModal.tsx": [
		295,
		9
	],
	"./containers/Modals/VideoViewer/VideoViewer": [
		379,
		9
	],
	"./containers/Modals/VideoViewer/VideoViewer.interface": [
		1767,
		9,
		356
	],
	"./containers/Modals/VideoViewer/VideoViewer.interface.ts": [
		1767,
		9,
		356
	],
	"./containers/Modals/VideoViewer/VideoViewer.scss": [
		1174,
		7
	],
	"./containers/Modals/VideoViewer/VideoViewer.tsx": [
		379,
		9
	],
	"./containers/Moderation/ModerationPage": [
		625,
		9
	],
	"./containers/Moderation/ModerationPage.scss": [
		1212,
		7
	],
	"./containers/Moderation/ModerationPage.tsx": [
		625,
		9
	],
	"./containers/Navigation/FilterLink": [
		512,
		9
	],
	"./containers/Navigation/FilterLink.tsx": [
		512,
		9
	],
	"./containers/News/NewsContainer": [
		373,
		9
	],
	"./containers/News/NewsContainer.tsx": [
		373,
		9
	],
	"./containers/Photos/PhotosContainer": [
		449,
		9
	],
	"./containers/Photos/PhotosContainer.tsx": [
		449,
		9
	],
	"./containers/Project/GenericProjectContainer": [
		376,
		9
	],
	"./containers/Project/GenericProjectContainer.tsx": [
		376,
		9
	],
	"./containers/Publications/PublicationsContainer": [
		375,
		9
	],
	"./containers/Publications/PublicationsContainer.tsx": [
		375,
		9
	],
	"./containers/RestorePassword/RestorePasswordContainer": [
		454,
		9
	],
	"./containers/RestorePassword/RestorePasswordContainer.tsx": [
		454,
		9
	],
	"./containers/SendRestoreEmail/SendRestoreEmailContainer": [
		455,
		9
	],
	"./containers/SendRestoreEmail/SendRestoreEmailContainer.tsx": [
		455,
		9
	],
	"./containers/SetNewPassword/SetNewPasswordContainer": [
		453,
		9
	],
	"./containers/SetNewPassword/SetNewPasswordContainer.tsx": [
		453,
		9
	],
	"./containers/SphereList/SphereList": [
		597,
		9
	],
	"./containers/SphereList/SphereList.scss": [
		1183,
		7
	],
	"./containers/SphereList/SphereList.tsx": [
		597,
		9
	],
	"./containers/TeamLogin/TeamLoginContainer": [
		994,
		9,
		109
	],
	"./containers/TeamLogin/TeamLoginContainer.tsx": [
		994,
		9,
		109
	],
	"./containers/Toast/Toast": [
		554,
		9
	],
	"./containers/Toast/Toast.scss": [
		1089,
		7
	],
	"./containers/Toast/Toast.tsx": [
		554,
		9
	],
	"./containers/UserRewards/UserRewardModal/UserRewardModal": [
		1704,
		9,
		287
	],
	"./containers/UserRewards/UserRewardModal/UserRewardModal.scss": [
		2784,
		7,
		563
	],
	"./containers/UserRewards/UserRewardModal/UserRewardModal.tsx": [
		1704,
		9,
		287
	],
	"./containers/UserRewards/UserRewardModal/UserRewardModal.types": [
		1768,
		9,
		357
	],
	"./containers/UserRewards/UserRewardModal/UserRewardModal.types.ts": [
		1768,
		9,
		357
	],
	"./containers/UserRewards/UserRewards": [
		1752,
		9,
		249
	],
	"./containers/UserRewards/UserRewards.scss": [
		2808,
		7,
		564
	],
	"./containers/UserRewards/UserRewards.tsx": [
		1752,
		9,
		249
	],
	"./containers/Video/VideoContainer": [
		451,
		9
	],
	"./containers/Video/VideoContainer.tsx": [
		451,
		9
	],
	"./containers/Wrappers": [
		202,
		9
	],
	"./containers/Wrappers/": [
		202,
		9
	],
	"./containers/Wrappers/BrowserSupport/BrowserSupport": [
		531,
		9
	],
	"./containers/Wrappers/BrowserSupport/BrowserSupport.scss": [
		1342,
		7
	],
	"./containers/Wrappers/BrowserSupport/BrowserSupport.tsx": [
		531,
		9
	],
	"./containers/Wrappers/ErrorBoundary/ErrorBoundary": [
		550,
		9
	],
	"./containers/Wrappers/ErrorBoundary/ErrorBoundary.tsx": [
		550,
		9
	],
	"./containers/Wrappers/GlobalControl/GlobalControl": [
		788,
		9
	],
	"./containers/Wrappers/GlobalControl/GlobalControl.scss": [
		1452,
		7
	],
	"./containers/Wrappers/GlobalControl/GlobalControl.tsx": [
		788,
		9
	],
	"./containers/Wrappers/LayoutControl/LayoutControl": [
		528,
		9
	],
	"./containers/Wrappers/LayoutControl/LayoutControl.scss": [
		1340,
		7
	],
	"./containers/Wrappers/LayoutControl/LayoutControl.tsx": [
		528,
		9
	],
	"./containers/Wrappers/PostMessageListener/PostMessage.helper": [
		260,
		9
	],
	"./containers/Wrappers/PostMessageListener/PostMessage.helper.ts": [
		260,
		9
	],
	"./containers/Wrappers/PostMessageListener/PostMessageListener": [
		529,
		9
	],
	"./containers/Wrappers/PostMessageListener/PostMessageListener.tsx": [
		529,
		9
	],
	"./containers/Wrappers/ResourceLoader/ResourceLoader": [
		530,
		9
	],
	"./containers/Wrappers/ResourceLoader/ResourceLoader.tsx": [
		530,
		9
	],
	"./containers/Wrappers/ResourceLoader/config": [
		243,
		9
	],
	"./containers/Wrappers/ResourceLoader/config.ts": [
		243,
		9
	],
	"./containers/Wrappers/SudirSessionContainer/ActiveSessionForm/ActiveSessionForm": [
		712,
		9
	],
	"./containers/Wrappers/SudirSessionContainer/ActiveSessionForm/ActiveSessionForm.scss": [
		1341,
		7
	],
	"./containers/Wrappers/SudirSessionContainer/ActiveSessionForm/ActiveSessionForm.tsx": [
		712,
		9
	],
	"./containers/Wrappers/SudirSessionContainer/SudirSessionContainer": [
		442,
		9
	],
	"./containers/Wrappers/SudirSessionContainer/SudirSessionContainer.scss": [
		2850,
		7,
		565
	],
	"./containers/Wrappers/SudirSessionContainer/SudirSessionContainer.tsx": [
		442,
		9
	],
	"./containers/Wrappers/SudirSessionError/SudirSessionError": [
		794,
		9
	],
	"./containers/Wrappers/SudirSessionError/SudirSessionError.scss": [
		1457,
		7
	],
	"./containers/Wrappers/SudirSessionError/SudirSessionError.tsx": [
		794,
		9
	],
	"./containers/Wrappers/WindowControl/WindowControl": [
		793,
		9
	],
	"./containers/Wrappers/WindowControl/WindowControl.scss": [
		2851,
		7,
		566
	],
	"./containers/Wrappers/WindowControl/WindowControl.tsx": [
		793,
		9
	],
	"./containers/Wrappers/index": [
		202,
		9
	],
	"./containers/Wrappers/index.ts": [
		202,
		9
	],
	"./containers/ideaModeration/ideaModerationPage": [
		626,
		9
	],
	"./containers/ideaModeration/ideaModerationPage.scss": [
		1213,
		7
	],
	"./containers/ideaModeration/ideaModerationPage.tsx": [
		626,
		9
	],
	"./pages/About/AboutPage": [
		612,
		9
	],
	"./pages/About/AboutPage.interface": [
		1769,
		9,
		358
	],
	"./pages/About/AboutPage.interface.ts": [
		1769,
		9,
		358
	],
	"./pages/About/AboutPage.scss": [
		1198,
		7
	],
	"./pages/About/AboutPage.tsx": [
		612,
		9
	],
	"./pages/Account/AccountPage": [
		1753,
		9,
		18
	],
	"./pages/Account/AccountPage.interface": [
		1770,
		9,
		359
	],
	"./pages/Account/AccountPage.interface.ts": [
		1770,
		9,
		359
	],
	"./pages/Account/AccountPage.scss": [
		2831,
		7,
		567
	],
	"./pages/Account/AccountPage.tsx": [
		1753,
		9,
		18
	],
	"./pages/Account/HiddenFIOWarning/HiddenFIOWarning": [
		1730,
		9,
		288
	],
	"./pages/Account/HiddenFIOWarning/HiddenFIOWarning.scss": [
		2807,
		7,
		568
	],
	"./pages/Account/HiddenFIOWarning/HiddenFIOWarning.tsx": [
		1730,
		9,
		288
	],
	"./pages/Account/HiddenFIOWarning/HiddenFIOWarning.types": [
		1771,
		9,
		360
	],
	"./pages/Account/HiddenFIOWarning/HiddenFIOWarning.types.ts": [
		1771,
		9,
		360
	],
	"./pages/Account/IdeaTip/IdeaTip": [
		1731,
		9,
		361
	],
	"./pages/Account/IdeaTip/IdeaTip.tsx": [
		1731,
		9,
		361
	],
	"./pages/Account/Notifications/NotificationCard/NotificationCard": [
		1701,
		9,
		289
	],
	"./pages/Account/Notifications/NotificationCard/NotificationCard.scss": [
		2781,
		7,
		569
	],
	"./pages/Account/Notifications/NotificationCard/NotificationCard.tsx": [
		1701,
		9,
		289
	],
	"./pages/Account/Notifications/Notifications": [
		1751,
		9,
		222
	],
	"./pages/Account/Notifications/Notifications.scss": [
		2804,
		7,
		570
	],
	"./pages/Account/Notifications/Notifications.tsx": [
		1751,
		9,
		222
	],
	"./pages/Account/Notifications/NotificationsLoader/NotificationsLoader": [
		1702,
		9,
		290
	],
	"./pages/Account/Notifications/NotificationsLoader/NotificationsLoader.scss": [
		2782,
		7,
		571
	],
	"./pages/Account/Notifications/NotificationsLoader/NotificationsLoader.tsx": [
		1702,
		9,
		290
	],
	"./pages/Account/ProfileProjects/ProfileProjects": [
		1729,
		9,
		250
	],
	"./pages/Account/ProfileProjects/ProfileProjects.scss": [
		2806,
		7,
		572
	],
	"./pages/Account/ProfileProjects/ProfileProjects.tsx": [
		1729,
		9,
		250
	],
	"./pages/Account/ProfileProjects/ProfileProjectsLoader/ProfileProjectsLoader": [
		1703,
		9,
		291
	],
	"./pages/Account/ProfileProjects/ProfileProjectsLoader/ProfileProjectsLoader.scss": [
		2783,
		7,
		573
	],
	"./pages/Account/ProfileProjects/ProfileProjectsLoader/ProfileProjectsLoader.tsx": [
		1703,
		9,
		291
	],
	"./pages/Account/UserSystems/UserSystems": [
		1728,
		9,
		292
	],
	"./pages/Account/UserSystems/UserSystems.scss": [
		2805,
		7,
		574
	],
	"./pages/Account/UserSystems/UserSystems.tsx": [
		1728,
		9,
		292
	],
	"./pages/Announcement/AnnouncementPage": [
		587,
		9
	],
	"./pages/Announcement/AnnouncementPage.scss": [
		1152,
		7
	],
	"./pages/Announcement/AnnouncementPage.tsx": [
		587,
		9
	],
	"./pages/Archive/ArchivePage": [
		572,
		9
	],
	"./pages/Archive/ArchivePage.scss": [
		1106,
		7
	],
	"./pages/Archive/ArchivePage.tsx": [
		572,
		9
	],
	"./pages/ArchiveProjectPage/ArchiveProjectPage": [
		573,
		9
	],
	"./pages/ArchiveProjectPage/ArchiveProjectPage.scss": [
		1111,
		7
	],
	"./pages/ArchiveProjectPage/ArchiveProjectPage.tsx": [
		573,
		9
	],
	"./pages/Blocked/BlockedPage": [
		628,
		9
	],
	"./pages/Blocked/BlockedPage.scss": [
		1215,
		7
	],
	"./pages/Blocked/BlockedPage.tsx": [
		628,
		9
	],
	"./pages/BookPresentation/BookPresentation": [
		703,
		9
	],
	"./pages/BookPresentation/BookPresentation.interface": [
		205,
		9
	],
	"./pages/BookPresentation/BookPresentation.interface.ts": [
		205,
		9
	],
	"./pages/BookPresentation/BookPresentation.scss": [
		1339,
		7
	],
	"./pages/BookPresentation/BookPresentation.tsx": [
		703,
		9
	],
	"./pages/BookPresentation/constants": [
		1772,
		9,
		362
	],
	"./pages/BookPresentation/constants.ts": [
		1772,
		9,
		362
	],
	"./pages/CrowdBirthday10/CrowdBirthday10": [
		807,
		9
	],
	"./pages/CrowdBirthday10/CrowdBirthday10.constants": [
		93,
		9
	],
	"./pages/CrowdBirthday10/CrowdBirthday10.constants.ts": [
		93,
		9
	],
	"./pages/CrowdBirthday10/CrowdBirthday10.scss": [
		1239,
		7
	],
	"./pages/CrowdBirthday10/CrowdBirthday10.tsx": [
		807,
		9
	],
	"./pages/CrowdBirthday10/components/Button/Button": [
		81,
		9
	],
	"./pages/CrowdBirthday10/components/Button/Button.tsx": [
		81,
		9
	],
	"./pages/CrowdBirthday10/components/Games/ExpertGame/ExpertGame": [
		671,
		9
	],
	"./pages/CrowdBirthday10/components/Games/ExpertGame/ExpertGame.interface": [
		1773,
		9,
		363
	],
	"./pages/CrowdBirthday10/components/Games/ExpertGame/ExpertGame.interface.ts": [
		1773,
		9,
		363
	],
	"./pages/CrowdBirthday10/components/Games/ExpertGame/ExpertGame.scss": [
		1320,
		7
	],
	"./pages/CrowdBirthday10/components/Games/ExpertGame/ExpertGame.tsx": [
		671,
		9
	],
	"./pages/CrowdBirthday10/components/Games/ExpertGame/ExpertGame.utils": [
		297,
		9
	],
	"./pages/CrowdBirthday10/components/Games/ExpertGame/ExpertGame.utils.ts": [
		297,
		9
	],
	"./pages/CrowdBirthday10/components/Games/ExpertGame/SphereCard/SphereCard": [
		672,
		9
	],
	"./pages/CrowdBirthday10/components/Games/ExpertGame/SphereCard/SphereCard.scss": [
		1321,
		7
	],
	"./pages/CrowdBirthday10/components/Games/ExpertGame/SphereCard/SphereCard.tsx": [
		672,
		9
	],
	"./pages/CrowdBirthday10/components/Games/ExpertGame/SphereQuizCard/SphereQuizCard": [
		673,
		9
	],
	"./pages/CrowdBirthday10/components/Games/ExpertGame/SphereQuizCard/SphereQuizCard.scss": [
		1325,
		7
	],
	"./pages/CrowdBirthday10/components/Games/ExpertGame/SphereQuizCard/SphereQuizCard.tsx": [
		673,
		9
	],
	"./pages/CrowdBirthday10/components/Games/ExpertGame/constants": [
		254,
		9
	],
	"./pages/CrowdBirthday10/components/Games/ExpertGame/constants/": [
		254,
		9
	],
	"./pages/CrowdBirthday10/components/Games/ExpertGame/constants/gameData": [
		669,
		9
	],
	"./pages/CrowdBirthday10/components/Games/ExpertGame/constants/gameData.ts": [
		669,
		9
	],
	"./pages/CrowdBirthday10/components/Games/ExpertGame/constants/gameDataMobile": [
		668,
		9
	],
	"./pages/CrowdBirthday10/components/Games/ExpertGame/constants/gameDataMobile.ts": [
		668,
		9
	],
	"./pages/CrowdBirthday10/components/Games/ExpertGame/constants/index": [
		254,
		9
	],
	"./pages/CrowdBirthday10/components/Games/ExpertGame/constants/index.ts": [
		254,
		9
	],
	"./pages/CrowdBirthday10/components/Games/ObjectsGathering/ObjectsGathering": [
		678,
		9
	],
	"./pages/CrowdBirthday10/components/Games/ObjectsGathering/ObjectsGathering.constants": [
		663,
		9
	],
	"./pages/CrowdBirthday10/components/Games/ObjectsGathering/ObjectsGathering.constants.ts": [
		663,
		9
	],
	"./pages/CrowdBirthday10/components/Games/ObjectsGathering/ObjectsGathering.interface": [
		1774,
		9,
		364
	],
	"./pages/CrowdBirthday10/components/Games/ObjectsGathering/ObjectsGathering.interface.ts": [
		1774,
		9,
		364
	],
	"./pages/CrowdBirthday10/components/Games/ObjectsGathering/ObjectsGathering.tsx": [
		678,
		9
	],
	"./pages/CrowdBirthday10/components/Header/Header": [
		803,
		9
	],
	"./pages/CrowdBirthday10/components/Header/Header.scss": [
		1252,
		7
	],
	"./pages/CrowdBirthday10/components/Header/Header.tsx": [
		803,
		9
	],
	"./pages/CrowdBirthday10/components/InfoButton/InfoButton": [
		664,
		9
	],
	"./pages/CrowdBirthday10/components/InfoButton/InfoButton.scss": [
		1254,
		7
	],
	"./pages/CrowdBirthday10/components/InfoButton/InfoButton.tsx": [
		664,
		9
	],
	"./pages/CrowdBirthday10/components/InputWithArrow/InputWithArrow": [
		666,
		9
	],
	"./pages/CrowdBirthday10/components/InputWithArrow/InputWithArrow.tsx": [
		666,
		9
	],
	"./pages/CrowdBirthday10/components/Map/Block/Block": [
		661,
		9
	],
	"./pages/CrowdBirthday10/components/Map/Block/Block.interface": [
		1775,
		9,
		365
	],
	"./pages/CrowdBirthday10/components/Map/Block/Block.interface.ts": [
		1775,
		9,
		365
	],
	"./pages/CrowdBirthday10/components/Map/Block/Block.scss": [
		1250,
		7
	],
	"./pages/CrowdBirthday10/components/Map/Block/Block.tsx": [
		661,
		9
	],
	"./pages/CrowdBirthday10/components/Map/Map": [
		659,
		9
	],
	"./pages/CrowdBirthday10/components/Map/Map.constants": [
		96,
		9
	],
	"./pages/CrowdBirthday10/components/Map/Map.constants.ts": [
		96,
		9
	],
	"./pages/CrowdBirthday10/components/Map/Map.interface": [
		1776,
		9,
		366
	],
	"./pages/CrowdBirthday10/components/Map/Map.interface.ts": [
		1776,
		9,
		366
	],
	"./pages/CrowdBirthday10/components/Map/Map.scss": [
		1248,
		7
	],
	"./pages/CrowdBirthday10/components/Map/Map.tsx": [
		659,
		9
	],
	"./pages/CrowdBirthday10/components/Map/Map.utils": [
		259,
		9
	],
	"./pages/CrowdBirthday10/components/Map/Map.utils.ts": [
		259,
		9
	],
	"./pages/CrowdBirthday10/components/Map/Pin/Pin": [
		670,
		9
	],
	"./pages/CrowdBirthday10/components/Map/Pin/Pin.interface": [
		1777,
		9,
		367
	],
	"./pages/CrowdBirthday10/components/Map/Pin/Pin.interface.ts": [
		1777,
		9,
		367
	],
	"./pages/CrowdBirthday10/components/Map/Pin/Pin.scss": [
		1319,
		7
	],
	"./pages/CrowdBirthday10/components/Map/Pin/Pin.tsx": [
		670,
		9
	],
	"./pages/CrowdBirthday10/components/Map/PinQuestion/PinQuestion": [
		662,
		9
	],
	"./pages/CrowdBirthday10/components/Map/PinQuestion/PinQuestion.interface": [
		1778,
		9,
		368
	],
	"./pages/CrowdBirthday10/components/Map/PinQuestion/PinQuestion.interface.ts": [
		1778,
		9,
		368
	],
	"./pages/CrowdBirthday10/components/Map/PinQuestion/PinQuestion.scss": [
		1251,
		7
	],
	"./pages/CrowdBirthday10/components/Map/PinQuestion/PinQuestion.tsx": [
		662,
		9
	],
	"./pages/CrowdBirthday10/components/Modals/CompletedSphereModal/CompletedSphereModal": [
		676,
		9
	],
	"./pages/CrowdBirthday10/components/Modals/CompletedSphereModal/CompletedSphereModal.tsx": [
		676,
		9
	],
	"./pages/CrowdBirthday10/components/Modals/CorrectAnswerModal/CorrectAnswerModal": [
		674,
		9
	],
	"./pages/CrowdBirthday10/components/Modals/CorrectAnswerModal/CorrectAnswerModal.tsx": [
		674,
		9
	],
	"./pages/CrowdBirthday10/components/Modals/IdeasGroupAllFoundModal/IdeasGroupAllFoundModal": [
		680,
		9
	],
	"./pages/CrowdBirthday10/components/Modals/IdeasGroupAllFoundModal/IdeasGroupAllFoundModal.interface": [
		1779,
		9,
		369
	],
	"./pages/CrowdBirthday10/components/Modals/IdeasGroupAllFoundModal/IdeasGroupAllFoundModal.interface.ts": [
		1779,
		9,
		369
	],
	"./pages/CrowdBirthday10/components/Modals/IdeasGroupAllFoundModal/IdeasGroupAllFoundModal.scss": [
		1328,
		7
	],
	"./pages/CrowdBirthday10/components/Modals/IdeasGroupAllFoundModal/IdeasGroupAllFoundModal.tsx": [
		680,
		9
	],
	"./pages/CrowdBirthday10/components/Modals/IdeasGroupModal/IdeasGroupModal": [
		679,
		9
	],
	"./pages/CrowdBirthday10/components/Modals/IdeasGroupModal/IdeasGroupModal.interface": [
		1780,
		9,
		370
	],
	"./pages/CrowdBirthday10/components/Modals/IdeasGroupModal/IdeasGroupModal.interface.ts": [
		1780,
		9,
		370
	],
	"./pages/CrowdBirthday10/components/Modals/IdeasGroupModal/IdeasGroupModal.scss": [
		1327,
		7
	],
	"./pages/CrowdBirthday10/components/Modals/IdeasGroupModal/IdeasGroupModal.tsx": [
		679,
		9
	],
	"./pages/CrowdBirthday10/components/Modals/ImageModal/ImageModal": [
		681,
		9
	],
	"./pages/CrowdBirthday10/components/Modals/ImageModal/ImageModal.interface": [
		1781,
		9,
		371
	],
	"./pages/CrowdBirthday10/components/Modals/ImageModal/ImageModal.interface.ts": [
		1781,
		9,
		371
	],
	"./pages/CrowdBirthday10/components/Modals/ImageModal/ImageModal.scss": [
		1329,
		7
	],
	"./pages/CrowdBirthday10/components/Modals/ImageModal/ImageModal.tsx": [
		681,
		9
	],
	"./pages/CrowdBirthday10/components/Modals/IncorrectAnswerModal/IncorrectAnswerModal": [
		675,
		9
	],
	"./pages/CrowdBirthday10/components/Modals/IncorrectAnswerModal/IncorrectAnswerModal.tsx": [
		675,
		9
	],
	"./pages/CrowdBirthday10/components/Modals/InstructionModal/InstructionModal": [
		667,
		9
	],
	"./pages/CrowdBirthday10/components/Modals/InstructionModal/InstructionModal.scss": [
		1256,
		7
	],
	"./pages/CrowdBirthday10/components/Modals/InstructionModal/InstructionModal.tsx": [
		667,
		9
	],
	"./pages/CrowdBirthday10/components/Modals/ScreenStub/ScreenStub": [
		657,
		9
	],
	"./pages/CrowdBirthday10/components/Modals/ScreenStub/ScreenStub.scss": [
		1243,
		7
	],
	"./pages/CrowdBirthday10/components/Modals/ScreenStub/ScreenStub.tsx": [
		657,
		9
	],
	"./pages/CrowdBirthday10/components/Modals/WelcomeModal/WelcomeModal": [
		656,
		9
	],
	"./pages/CrowdBirthday10/components/Modals/WelcomeModal/WelcomeModal.scss": [
		1240,
		7
	],
	"./pages/CrowdBirthday10/components/Modals/WelcomeModal/WelcomeModal.tsx": [
		656,
		9
	],
	"./pages/CrowdBirthday10/components/Modals/WinModal/WinModal": [
		677,
		9
	],
	"./pages/CrowdBirthday10/components/Modals/WinModal/WinModal.scss": [
		1326,
		7
	],
	"./pages/CrowdBirthday10/components/Modals/WinModal/WinModal.tsx": [
		677,
		9
	],
	"./pages/CrowdBirthday10/components/ProgressBar/ProgressBar": [
		469,
		9
	],
	"./pages/CrowdBirthday10/components/ProgressBar/ProgressBar.scss": [
		1253,
		7
	],
	"./pages/CrowdBirthday10/components/ProgressBar/ProgressBar.tsx": [
		469,
		9
	],
	"./pages/CrowdBirthday10/components/ScreenLoader/ScreenLoader": [
		658,
		9
	],
	"./pages/CrowdBirthday10/components/ScreenLoader/ScreenLoader.scss": [
		1244,
		7
	],
	"./pages/CrowdBirthday10/components/ScreenLoader/ScreenLoader.tsx": [
		658,
		9
	],
	"./pages/CrowdBirthday10/components/Stats/Stats": [
		665,
		9
	],
	"./pages/CrowdBirthday10/components/Stats/Stats.scss": [
		1255,
		7
	],
	"./pages/CrowdBirthday10/components/Stats/Stats.tsx": [
		665,
		9
	],
	"./pages/CrowdBirthday10/components/ToastContainer/ToastContainer": [
		660,
		9
	],
	"./pages/CrowdBirthday10/components/ToastContainer/ToastContainer.scss": [
		1249,
		7
	],
	"./pages/CrowdBirthday10/components/ToastContainer/ToastContainer.tsx": [
		660,
		9
	],
	"./pages/CrowdBirthday10/constants/images": [
		459,
		9
	],
	"./pages/CrowdBirthday10/constants/images.ts": [
		459,
		9
	],
	"./pages/CrowdBirthday10/services/CrowdBirthday10.service": [
		204,
		9
	],
	"./pages/CrowdBirthday10/services/CrowdBirthday10.service.ts": [
		204,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdayCongrats/BirthdayCongrats": [
		637,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdayCongrats/BirthdayCongrats.helper": [
		1782,
		9,
		233
	],
	"./pages/CrowdBirthday9/Components/BirthdayCongrats/BirthdayCongrats.helper.tsx": [
		1782,
		9,
		233
	],
	"./pages/CrowdBirthday9/Components/BirthdayCongrats/BirthdayCongrats.scss": [
		1223,
		7
	],
	"./pages/CrowdBirthday9/Components/BirthdayCongrats/BirthdayCongrats.tsx": [
		637,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdayCongrats/CongratulationCard/CongratulationCard": [
		638,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdayCongrats/CongratulationCard/CongratulationCard.scss": [
		1222,
		7
	],
	"./pages/CrowdBirthday9/Components/BirthdayCongrats/CongratulationCard/CongratulationCard.tsx": [
		638,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdayCongrats/SendCongratForm/SendCongratForm": [
		639,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdayCongrats/SendCongratForm/SendCongratForm.scss": [
		1224,
		7
	],
	"./pages/CrowdBirthday9/Components/BirthdayCongrats/SendCongratForm/SendCongratForm.tsx": [
		639,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdayFooter/BirthdayFooter": [
		635,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdayFooter/BirthdayFooter.scss": [
		1235,
		7
	],
	"./pages/CrowdBirthday9/Components/BirthdayFooter/BirthdayFooter.tsx": [
		635,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdayGallery/BirthdayGallery": [
		640,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdayGallery/BirthdayGallery.scss": [
		1225,
		7
	],
	"./pages/CrowdBirthday9/Components/BirthdayGallery/BirthdayGallery.tsx": [
		640,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdayGame/BirthdayGame": [
		641,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdayGame/BirthdayGame.scss": [
		1226,
		7
	],
	"./pages/CrowdBirthday9/Components/BirthdayGame/BirthdayGame.tsx": [
		641,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdayGame/Puzzle/Puzzle": [
		643,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdayGame/Puzzle/Puzzle.scss": [
		1227,
		7
	],
	"./pages/CrowdBirthday9/Components/BirthdayGame/Puzzle/Puzzle.tsx": [
		643,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdayGame/PuzzleGame/PuzzleGame": [
		642,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdayGame/PuzzleGame/PuzzleGame.scss": [
		1228,
		7
	],
	"./pages/CrowdBirthday9/Components/BirthdayGame/PuzzleGame/PuzzleGame.tsx": [
		642,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdayHeader/BirthdayHeader": [
		654,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdayHeader/BirthdayHeader.helper": [
		329,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdayHeader/BirthdayHeader.helper.ts": [
		329,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdayHeader/BirthdayHeader.scss": [
		1237,
		7
	],
	"./pages/CrowdBirthday9/Components/BirthdayHeader/BirthdayHeader.tsx": [
		654,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdayHeader/BirthdayHeaderMobile/BirthdayHeaderMobile": [
		655,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdayHeader/BirthdayHeaderMobile/BirthdayHeaderMobile.scss": [
		1236,
		7
	],
	"./pages/CrowdBirthday9/Components/BirthdayHeader/BirthdayHeaderMobile/BirthdayHeaderMobile.tsx": [
		655,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdayMain/BirthdayMain": [
		645,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdayMain/BirthdayMain.scss": [
		1229,
		7
	],
	"./pages/CrowdBirthday9/Components/BirthdayMain/BirthdayMain.tsx": [
		645,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdayMayor/BirthdayMayor": [
		646,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdayMayor/BirthdayMayor.scss": [
		1230,
		7
	],
	"./pages/CrowdBirthday9/Components/BirthdayMayor/BirthdayMayor.tsx": [
		646,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdayModal": [
		357,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdayModal/": [
		357,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdayModal/BirthdayModal": [
		527,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdayModal/BirthdayModal.scss": [
		1233,
		7
	],
	"./pages/CrowdBirthday9/Components/BirthdayModal/BirthdayModal.tsx": [
		527,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdayModal/BirthdayModal.types": [
		1783,
		9,
		372
	],
	"./pages/CrowdBirthday9/Components/BirthdayModal/BirthdayModal.types.ts": [
		1783,
		9,
		372
	],
	"./pages/CrowdBirthday9/Components/BirthdayModal/index": [
		357,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdayModal/index.tsx": [
		357,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdaySpheres/BirthdaySpheres": [
		647,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdaySpheres/BirthdaySpheres.scss": [
		1231,
		7
	],
	"./pages/CrowdBirthday9/Components/BirthdaySpheres/BirthdaySpheres.tsx": [
		647,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdaySpheres/Lines/Line1": [
		648,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdaySpheres/Lines/Line1.tsx": [
		648,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdaySpheres/Lines/Line2": [
		649,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdaySpheres/Lines/Line2.tsx": [
		649,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdaySpheres/Lines/Line3": [
		650,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdaySpheres/Lines/Line3.tsx": [
		650,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdaySpheres/Lines/Line4": [
		651,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdaySpheres/Lines/Line4.tsx": [
		651,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdaySpheres/Lines/Line5": [
		652,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdaySpheres/Lines/Line5.tsx": [
		652,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdaySpheres/SphereBlock": [
		355,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdaySpheres/SphereBlock/": [
		355,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdaySpheres/SphereBlock/SphereBlock": [
		525,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdaySpheres/SphereBlock/SphereBlock.scss": [
		1232,
		7
	],
	"./pages/CrowdBirthday9/Components/BirthdaySpheres/SphereBlock/SphereBlock.tsx": [
		525,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdaySpheres/SphereBlock/SphereBlock.types": [
		1784,
		9,
		373
	],
	"./pages/CrowdBirthday9/Components/BirthdaySpheres/SphereBlock/SphereBlock.types.ts": [
		1784,
		9,
		373
	],
	"./pages/CrowdBirthday9/Components/BirthdaySpheres/SphereBlock/index": [
		355,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdaySpheres/SphereBlock/index.ts": [
		355,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdaySpheres/SphereProjectModal": [
		356,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdaySpheres/SphereProjectModal/": [
		356,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdaySpheres/SphereProjectModal/SphereProjectModal": [
		526,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdaySpheres/SphereProjectModal/SphereProjectModal.scss": [
		1234,
		7
	],
	"./pages/CrowdBirthday9/Components/BirthdaySpheres/SphereProjectModal/SphereProjectModal.tsx": [
		526,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdaySpheres/SphereProjectModal/SphereProjectModal.types": [
		1785,
		9,
		374
	],
	"./pages/CrowdBirthday9/Components/BirthdaySpheres/SphereProjectModal/SphereProjectModal.types.ts": [
		1785,
		9,
		374
	],
	"./pages/CrowdBirthday9/Components/BirthdaySpheres/SphereProjectModal/index": [
		356,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdaySpheres/SphereProjectModal/index.tsx": [
		356,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdaySpheres/spheresData": [
		653,
		9
	],
	"./pages/CrowdBirthday9/Components/BirthdaySpheres/spheresData.ts": [
		653,
		9
	],
	"./pages/CrowdBirthday9/CrowdBirthday9": [
		632,
		9
	],
	"./pages/CrowdBirthday9/CrowdBirthday9.helper": [
		155,
		9
	],
	"./pages/CrowdBirthday9/CrowdBirthday9.helper.tsx": [
		155,
		9
	],
	"./pages/CrowdBirthday9/CrowdBirthday9.scss": [
		1238,
		7
	],
	"./pages/CrowdBirthday9/CrowdBirthday9.tsx": [
		632,
		9
	],
	"./pages/CrowdBirthday9/common.scss": [
		2852,
		7,
		575
	],
	"./pages/Current/CurrentPage": [
		588,
		9
	],
	"./pages/Current/CurrentPage.scss": [
		1153,
		7
	],
	"./pages/Current/CurrentPage.tsx": [
		588,
		9
	],
	"./pages/DiscussionLanding/DiscussionLanding.constants": [
		66,
		9
	],
	"./pages/DiscussionLanding/DiscussionLanding.constants.ts": [
		66,
		9
	],
	"./pages/DiscussionLanding/DiscussionLanding.context": [
		390,
		9
	],
	"./pages/DiscussionLanding/DiscussionLanding.context.ts": [
		390,
		9
	],
	"./pages/DiscussionLanding/DiscussionLanding.interface": [
		1786,
		9,
		375
	],
	"./pages/DiscussionLanding/DiscussionLanding.interface.ts": [
		1786,
		9,
		375
	],
	"./pages/DiscussionLanding/DiscussionLandingPage": [
		801,
		9
	],
	"./pages/DiscussionLanding/DiscussionLandingPage.scss": [
		1404,
		7
	],
	"./pages/DiscussionLanding/DiscussionLandingPage.tsx": [
		801,
		9
	],
	"./pages/DiscussionLanding/components/Activities/Activities": [
		785,
		9
	],
	"./pages/DiscussionLanding/components/Activities/Activities.scss": [
		1450,
		7
	],
	"./pages/DiscussionLanding/components/Activities/Activities.tsx": [
		785,
		9
	],
	"./pages/DiscussionLanding/components/Activities/Activity.interface": [
		1787,
		9,
		376
	],
	"./pages/DiscussionLanding/components/Activities/Activity.interface.ts": [
		1787,
		9,
		376
	],
	"./pages/DiscussionLanding/components/Activities/ActivityCard/ActivityCard": [
		786,
		9
	],
	"./pages/DiscussionLanding/components/Activities/ActivityCard/ActivityCard.scss": [
		1449,
		7
	],
	"./pages/DiscussionLanding/components/Activities/ActivityCard/ActivityCard.tsx": [
		786,
		9
	],
	"./pages/DiscussionLanding/components/Button/Button": [
		131,
		9
	],
	"./pages/DiscussionLanding/components/Button/Button.scss": [
		1408,
		7
	],
	"./pages/DiscussionLanding/components/Button/Button.tsx": [
		131,
		9
	],
	"./pages/DiscussionLanding/components/DiscussionEventRegistrationModal/DiscussionEventRegistrationModal": [
		391,
		9
	],
	"./pages/DiscussionLanding/components/DiscussionEventRegistrationModal/DiscussionEventRegistrationModal.scss": [
		1410,
		7
	],
	"./pages/DiscussionLanding/components/DiscussionEventRegistrationModal/DiscussionEventRegistrationModal.tsx": [
		391,
		9
	],
	"./pages/DiscussionLanding/components/DiscussionEventRegistrationModal/DiscussionEventRegistrationSuccessModal/DiscussionEventRegistrationSuccessModal": [
		392,
		9
	],
	"./pages/DiscussionLanding/components/DiscussionEventRegistrationModal/DiscussionEventRegistrationSuccessModal/DiscussionEventRegistrationSuccessModal.scss": [
		1411,
		7
	],
	"./pages/DiscussionLanding/components/DiscussionEventRegistrationModal/DiscussionEventRegistrationSuccessModal/DiscussionEventRegistrationSuccessModal.tsx": [
		392,
		9
	],
	"./pages/DiscussionLanding/components/Discussions/AllComments/AllComments": [
		775,
		9
	],
	"./pages/DiscussionLanding/components/Discussions/AllComments/AllComments.scss": [
		1441,
		7
	],
	"./pages/DiscussionLanding/components/Discussions/AllComments/AllComments.tsx": [
		775,
		9
	],
	"./pages/DiscussionLanding/components/Discussions/Comment/Comment": [
		394,
		9
	],
	"./pages/DiscussionLanding/components/Discussions/Comment/Comment.scss": [
		1436,
		7
	],
	"./pages/DiscussionLanding/components/Discussions/Comment/Comment.tsx": [
		394,
		9
	],
	"./pages/DiscussionLanding/components/Discussions/Comment/LikeCounter/LikeCounter": [
		772,
		9
	],
	"./pages/DiscussionLanding/components/Discussions/Comment/LikeCounter/LikeCounter.scss": [
		1437,
		7
	],
	"./pages/DiscussionLanding/components/Discussions/Comment/LikeCounter/LikeCounter.tsx": [
		772,
		9
	],
	"./pages/DiscussionLanding/components/Discussions/Comment/UsersLikePopup/UsersLikePopup": [
		773,
		9
	],
	"./pages/DiscussionLanding/components/Discussions/Comment/UsersLikePopup/UsersLikePopup.scss": [
		1438,
		7
	],
	"./pages/DiscussionLanding/components/Discussions/Comment/UsersLikePopup/UsersLikePopup.tsx": [
		773,
		9
	],
	"./pages/DiscussionLanding/components/Discussions/Discussion.interface": [
		143,
		9
	],
	"./pages/DiscussionLanding/components/Discussions/Discussion.interface.ts": [
		143,
		9
	],
	"./pages/DiscussionLanding/components/Discussions/DiscussionCard/DiscussionCard": [
		770,
		9
	],
	"./pages/DiscussionLanding/components/Discussions/DiscussionCard/DiscussionCard.scss": [
		1435,
		7
	],
	"./pages/DiscussionLanding/components/Discussions/DiscussionCard/DiscussionCard.tsx": [
		770,
		9
	],
	"./pages/DiscussionLanding/components/Discussions/Discussions": [
		769,
		9
	],
	"./pages/DiscussionLanding/components/Discussions/Discussions.scss": [
		1434,
		7
	],
	"./pages/DiscussionLanding/components/Discussions/Discussions.tsx": [
		769,
		9
	],
	"./pages/DiscussionLanding/components/Discussions/TopComments/TopComments": [
		771,
		9
	],
	"./pages/DiscussionLanding/components/Discussions/TopComments/TopComments.scss": [
		1440,
		7
	],
	"./pages/DiscussionLanding/components/Discussions/TopComments/TopComments.tsx": [
		771,
		9
	],
	"./pages/DiscussionLanding/components/Experts/Experts": [
		778,
		9
	],
	"./pages/DiscussionLanding/components/Experts/Experts.scss": [
		1444,
		7
	],
	"./pages/DiscussionLanding/components/Experts/Experts.tsx": [
		778,
		9
	],
	"./pages/DiscussionLanding/components/Gallery/Gallery": [
		750,
		9
	],
	"./pages/DiscussionLanding/components/Gallery/Gallery.scss": [
		1412,
		7
	],
	"./pages/DiscussionLanding/components/Gallery/Gallery.tsx": [
		750,
		9
	],
	"./pages/DiscussionLanding/components/GenerationModal/GenerationContainer/GenerationFormContainer": [
		757,
		9
	],
	"./pages/DiscussionLanding/components/GenerationModal/GenerationContainer/GenerationFormContainer.scss": [
		2853,
		7,
		576
	],
	"./pages/DiscussionLanding/components/GenerationModal/GenerationContainer/GenerationFormContainer.tsx": [
		757,
		9
	],
	"./pages/DiscussionLanding/components/GenerationModal/GenerationForm/GenerationForm": [
		800,
		9
	],
	"./pages/DiscussionLanding/components/GenerationModal/GenerationForm/GenerationForm.scss": [
		1419,
		7
	],
	"./pages/DiscussionLanding/components/GenerationModal/GenerationForm/GenerationForm.tsx": [
		800,
		9
	],
	"./pages/DiscussionLanding/components/GenerationModal/GenerationModal": [
		756,
		9
	],
	"./pages/DiscussionLanding/components/GenerationModal/GenerationModal.scss": [
		1418,
		7
	],
	"./pages/DiscussionLanding/components/GenerationModal/GenerationModal.tsx": [
		756,
		9
	],
	"./pages/DiscussionLanding/components/GenerationModal/RejectReason/RejectReason": [
		821,
		9
	],
	"./pages/DiscussionLanding/components/GenerationModal/RejectReason/RejectReason.scss": [
		1422,
		7
	],
	"./pages/DiscussionLanding/components/GenerationModal/RejectReason/RejectReason.tsx": [
		821,
		9
	],
	"./pages/DiscussionLanding/components/MediaPlatform/MediaPlatform": [
		760,
		9
	],
	"./pages/DiscussionLanding/components/MediaPlatform/MediaPlatform.scss": [
		1425,
		7
	],
	"./pages/DiscussionLanding/components/MediaPlatform/MediaPlatform.tsx": [
		760,
		9
	],
	"./pages/DiscussionLanding/components/MediaPlatform/NewsAndPublications/NewsAndPublications": [
		761,
		9
	],
	"./pages/DiscussionLanding/components/MediaPlatform/NewsAndPublications/NewsAndPublications.scss": [
		1426,
		7
	],
	"./pages/DiscussionLanding/components/MediaPlatform/NewsAndPublications/NewsAndPublications.tsx": [
		761,
		9
	],
	"./pages/DiscussionLanding/components/MediaPlatform/NewsAndPublications/NewsCard/NewsCard": [
		762,
		9
	],
	"./pages/DiscussionLanding/components/MediaPlatform/NewsAndPublications/NewsCard/NewsCard.scss": [
		1427,
		7
	],
	"./pages/DiscussionLanding/components/MediaPlatform/NewsAndPublications/NewsCard/NewsCard.tsx": [
		762,
		9
	],
	"./pages/DiscussionLanding/components/MediaPlatform/NewsAndPublicationsModal/NewsAndPublicationsModal": [
		763,
		9
	],
	"./pages/DiscussionLanding/components/MediaPlatform/NewsAndPublicationsModal/NewsAndPublicationsModal.scss": [
		1428,
		7
	],
	"./pages/DiscussionLanding/components/MediaPlatform/NewsAndPublicationsModal/NewsAndPublicationsModal.tsx": [
		763,
		9
	],
	"./pages/DiscussionLanding/components/NodeSelectorModal/NodeSelectorModal": [
		755,
		9
	],
	"./pages/DiscussionLanding/components/NodeSelectorModal/NodeSelectorModal.interface": [
		1788,
		9,
		377
	],
	"./pages/DiscussionLanding/components/NodeSelectorModal/NodeSelectorModal.interface.ts": [
		1788,
		9,
		377
	],
	"./pages/DiscussionLanding/components/NodeSelectorModal/NodeSelectorModal.scss": [
		1417,
		7
	],
	"./pages/DiscussionLanding/components/NodeSelectorModal/NodeSelectorModal.tsx": [
		755,
		9
	],
	"./pages/DiscussionLanding/components/NodeWithStageSelectorModal/NodeWithStageSelectorModal": [
		759,
		9
	],
	"./pages/DiscussionLanding/components/NodeWithStageSelectorModal/NodeWithStageSelectorModal.scss": [
		1424,
		7
	],
	"./pages/DiscussionLanding/components/NodeWithStageSelectorModal/NodeWithStageSelectorModal.tsx": [
		759,
		9
	],
	"./pages/DiscussionLanding/components/OnlineTranslations/OnlineTranslations": [
		466,
		9
	],
	"./pages/DiscussionLanding/components/OnlineTranslations/OnlineTranslations.scss": [
		1446,
		7
	],
	"./pages/DiscussionLanding/components/OnlineTranslations/OnlineTranslations.tsx": [
		466,
		9
	],
	"./pages/DiscussionLanding/components/OnlineTranslations/OnlineTranslations.types": [
		1789,
		9,
		378
	],
	"./pages/DiscussionLanding/components/OnlineTranslations/OnlineTranslations.types.ts": [
		1789,
		9,
		378
	],
	"./pages/DiscussionLanding/components/OnlineTranslations/OnlineTranslationsCard/OnlineTranslationsCard": [
		781,
		9
	],
	"./pages/DiscussionLanding/components/OnlineTranslations/OnlineTranslationsCard/OnlineTranslationsCard.scss": [
		1447,
		7
	],
	"./pages/DiscussionLanding/components/OnlineTranslations/OnlineTranslationsCard/OnlineTranslationsCard.tsx": [
		781,
		9
	],
	"./pages/DiscussionLanding/components/PhotoReport/PhotoReport": [
		766,
		9
	],
	"./pages/DiscussionLanding/components/PhotoReport/PhotoReport.scss": [
		1431,
		7
	],
	"./pages/DiscussionLanding/components/PhotoReport/PhotoReport.tsx": [
		766,
		9
	],
	"./pages/DiscussionLanding/components/PhotoReport/PhotoReportCard/PhotoReportCard": [
		767,
		9
	],
	"./pages/DiscussionLanding/components/PhotoReport/PhotoReportCard/PhotoReportCard.scss": [
		1432,
		7
	],
	"./pages/DiscussionLanding/components/PhotoReport/PhotoReportCard/PhotoReportCard.tsx": [
		767,
		9
	],
	"./pages/DiscussionLanding/components/PhotoReportModal/PhotoReportModal": [
		768,
		9
	],
	"./pages/DiscussionLanding/components/PhotoReportModal/PhotoReportModal.scss": [
		1433,
		7
	],
	"./pages/DiscussionLanding/components/PhotoReportModal/PhotoReportModal.tsx": [
		768,
		9
	],
	"./pages/DiscussionLanding/components/Popup/Popup": [
		774,
		9
	],
	"./pages/DiscussionLanding/components/Popup/Popup.interface": [
		1790,
		9,
		379
	],
	"./pages/DiscussionLanding/components/Popup/Popup.interface.ts": [
		1790,
		9,
		379
	],
	"./pages/DiscussionLanding/components/Popup/Popup.scss": [
		1439,
		7
	],
	"./pages/DiscussionLanding/components/Popup/Popup.tsx": [
		774,
		9
	],
	"./pages/DiscussionLanding/components/ProposeIdea/ProposeIdea": [
		783,
		9
	],
	"./pages/DiscussionLanding/components/ProposeIdea/ProposeIdea.module.scss": [
		150,
		7
	],
	"./pages/DiscussionLanding/components/ProposeIdea/ProposeIdea.tsx": [
		783,
		9
	],
	"./pages/DiscussionLanding/components/Rating/Rating": [
		776,
		9
	],
	"./pages/DiscussionLanding/components/Rating/Rating.scss": [
		1442,
		7
	],
	"./pages/DiscussionLanding/components/Rating/Rating.tsx": [
		776,
		9
	],
	"./pages/DiscussionLanding/components/Rating/RatingCard/RatingCard": [
		777,
		9
	],
	"./pages/DiscussionLanding/components/Rating/RatingCard/RatingCard.scss": [
		1443,
		7
	],
	"./pages/DiscussionLanding/components/Rating/RatingCard/RatingCard.tsx": [
		777,
		9
	],
	"./pages/DiscussionLanding/components/Reviews/ReviewCard/ReviewCard": [
		765,
		9
	],
	"./pages/DiscussionLanding/components/Reviews/ReviewCard/ReviewCard.scss": [
		1430,
		7
	],
	"./pages/DiscussionLanding/components/Reviews/ReviewCard/ReviewCard.tsx": [
		765,
		9
	],
	"./pages/DiscussionLanding/components/Reviews/Reviews": [
		764,
		9
	],
	"./pages/DiscussionLanding/components/Reviews/Reviews.scss": [
		1429,
		7
	],
	"./pages/DiscussionLanding/components/Reviews/Reviews.tsx": [
		764,
		9
	],
	"./pages/DiscussionLanding/components/ScreenLoader/ScreenLoader": [
		782,
		9
	],
	"./pages/DiscussionLanding/components/ScreenLoader/ScreenLoader.scss": [
		1448,
		7
	],
	"./pages/DiscussionLanding/components/ScreenLoader/ScreenLoader.tsx": [
		782,
		9
	],
	"./pages/DiscussionLanding/components/Sign/Sign": [
		779,
		9
	],
	"./pages/DiscussionLanding/components/Sign/Sign.scss": [
		1445,
		7
	],
	"./pages/DiscussionLanding/components/Sign/Sign.tsx": [
		779,
		9
	],
	"./pages/DiscussionLanding/components/StreamsAndOnlineMeetings/StreamCard/StreamCard": [
		749,
		9
	],
	"./pages/DiscussionLanding/components/StreamsAndOnlineMeetings/StreamCard/StreamCard.scss": [
		1407,
		7
	],
	"./pages/DiscussionLanding/components/StreamsAndOnlineMeetings/StreamCard/StreamCard.tsx": [
		749,
		9
	],
	"./pages/DiscussionLanding/components/StreamsAndOnlineMeetings/StreamsAndOnlineMeetings": [
		748,
		9
	],
	"./pages/DiscussionLanding/components/StreamsAndOnlineMeetings/StreamsAndOnlineMeetings.interface": [
		1791,
		9,
		380
	],
	"./pages/DiscussionLanding/components/StreamsAndOnlineMeetings/StreamsAndOnlineMeetings.interface.ts": [
		1791,
		9,
		380
	],
	"./pages/DiscussionLanding/components/StreamsAndOnlineMeetings/StreamsAndOnlineMeetings.scss": [
		1406,
		7
	],
	"./pages/DiscussionLanding/components/StreamsAndOnlineMeetings/StreamsAndOnlineMeetings.tsx": [
		748,
		9
	],
	"./pages/DiscussionLanding/components/ThematicProjects/ThematicProjectCard/ThematicProjectCard": [
		754,
		9
	],
	"./pages/DiscussionLanding/components/ThematicProjects/ThematicProjectCard/ThematicProjectCard.interface": [
		158,
		9
	],
	"./pages/DiscussionLanding/components/ThematicProjects/ThematicProjectCard/ThematicProjectCard.interface.ts": [
		158,
		9
	],
	"./pages/DiscussionLanding/components/ThematicProjects/ThematicProjectCard/ThematicProjectCard.scss": [
		1416,
		7
	],
	"./pages/DiscussionLanding/components/ThematicProjects/ThematicProjectCard/ThematicProjectCard.tsx": [
		754,
		9
	],
	"./pages/DiscussionLanding/components/ThematicProjects/ThematicProjects": [
		753,
		9
	],
	"./pages/DiscussionLanding/components/ThematicProjects/ThematicProjects.scss": [
		1415,
		7
	],
	"./pages/DiscussionLanding/components/ThematicProjects/ThematicProjects.tsx": [
		753,
		9
	],
	"./pages/DiscussionLanding/components/Welcome/Welcome": [
		747,
		9
	],
	"./pages/DiscussionLanding/components/Welcome/Welcome.scss": [
		1405,
		7
	],
	"./pages/DiscussionLanding/components/Welcome/Welcome.tsx": [
		747,
		9
	],
	"./pages/DiscussionLanding/hooks/useConnectToProject": [
		780,
		9
	],
	"./pages/DiscussionLanding/hooks/useConnectToProject.tsx": [
		780,
		9
	],
	"./pages/DiscussionLanding/hooks/useDiscussionLandingContext": [
		75,
		9
	],
	"./pages/DiscussionLanding/hooks/useDiscussionLandingContext.ts": [
		75,
		9
	],
	"./pages/DiscussionLanding/hooks/useMpRoutes": [
		746,
		9
	],
	"./pages/DiscussionLanding/hooks/useMpRoutes.tsx": [
		746,
		9
	],
	"./pages/DiscussionLanding/mixins.scss": [
		2854,
		7,
		577
	],
	"./pages/DiscussionLanding/mocks/activities": [
		1792,
		9,
		381
	],
	"./pages/DiscussionLanding/mocks/activities.ts": [
		1792,
		9,
		381
	],
	"./pages/DiscussionLanding/mocks/assets/discussion-waiting.svg": [
		2855,
		9,
		715
	],
	"./pages/DiscussionLanding/mocks/assets/welcome.png": [
		2856,
		9,
		718
	],
	"./pages/DiscussionLanding/mocks/comments": [
		1793,
		9,
		382
	],
	"./pages/DiscussionLanding/mocks/comments.ts": [
		1793,
		9,
		382
	],
	"./pages/DiscussionLanding/mocks/discussions": [
		1794,
		9,
		383
	],
	"./pages/DiscussionLanding/mocks/discussions.ts": [
		1794,
		9,
		383
	],
	"./pages/DiscussionLanding/mocks/proposeIdea": [
		784,
		9
	],
	"./pages/DiscussionLanding/mocks/proposeIdea.ts": [
		784,
		9
	],
	"./pages/DiscussionLanding/mocks/streams": [
		1795,
		9,
		384
	],
	"./pages/DiscussionLanding/mocks/streams.ts": [
		1795,
		9,
		384
	],
	"./pages/DiscussionLanding/routing/routes": [
		48,
		9
	],
	"./pages/DiscussionLanding/routing/routes.tsx": [
		48,
		9
	],
	"./pages/FailedEmailConfirmation/FailedEmailConfirmation": [
		594,
		9
	],
	"./pages/FailedEmailConfirmation/FailedEmailConfirmation.scss": [
		1175,
		7
	],
	"./pages/FailedEmailConfirmation/FailedEmailConfirmation.tsx": [
		594,
		9
	],
	"./pages/GenericProject/GenericProjectListPage.scss": [
		964,
		7
	],
	"./pages/GenericProject/GenericProjectPage": [
		586,
		9
	],
	"./pages/GenericProject/GenericProjectPage.scss": [
		958,
		7
	],
	"./pages/GenericProject/GenericProjectPage.tsx": [
		586,
		9
	],
	"./pages/Ideas/IdeasFilter/IdeasFilter": [
		813,
		9
	],
	"./pages/Ideas/IdeasFilter/IdeasFilter.module.scss": [
		186,
		7
	],
	"./pages/Ideas/IdeasFilter/IdeasFilter.tsx": [
		813,
		9
	],
	"./pages/Ideas/IdeasPage": [
		613,
		9
	],
	"./pages/Ideas/IdeasPage.module.scss": [
		146,
		7
	],
	"./pages/Ideas/IdeasPage.tsx": [
		613,
		9
	],
	"./pages/Ideas/mock": [
		889,
		9,
		76
	],
	"./pages/Ideas/mock/": [
		889,
		9,
		76
	],
	"./pages/Ideas/mock/index": [
		889,
		9,
		76
	],
	"./pages/Ideas/mock/index.ts": [
		889,
		9,
		76
	],
	"./pages/LeisureLanding/LeisureLandingRoot": [
		738,
		9
	],
	"./pages/LeisureLanding/LeisureLandingRoot.scss": [
		1403,
		7
	],
	"./pages/LeisureLanding/LeisureLandingRoot.tsx": [
		738,
		9
	],
	"./pages/LeisureLanding/components/BasketballGame/BasketballGame": [
		547,
		9
	],
	"./pages/LeisureLanding/components/BasketballGame/BasketballGame.helper": [
		84,
		9
	],
	"./pages/LeisureLanding/components/BasketballGame/BasketballGame.helper.ts": [
		84,
		9
	],
	"./pages/LeisureLanding/components/BasketballGame/BasketballGame.scss": [
		1400,
		7
	],
	"./pages/LeisureLanding/components/BasketballGame/BasketballGame.tsx": [
		547,
		9
	],
	"./pages/LeisureLanding/components/BasketballGame/Game/Game": [
		744,
		9
	],
	"./pages/LeisureLanding/components/BasketballGame/Game/Game.scss": [
		1399,
		7
	],
	"./pages/LeisureLanding/components/BasketballGame/Game/Game.tsx": [
		744,
		9
	],
	"./pages/LeisureLanding/components/Button": [
		180,
		9
	],
	"./pages/LeisureLanding/components/Button/": [
		180,
		9
	],
	"./pages/LeisureLanding/components/Button/Button": [
		543,
		9
	],
	"./pages/LeisureLanding/components/Button/Button.scss": [
		1394,
		7
	],
	"./pages/LeisureLanding/components/Button/Button.tsx": [
		543,
		9
	],
	"./pages/LeisureLanding/components/Button/index": [
		180,
		9
	],
	"./pages/LeisureLanding/components/Button/index.tsx": [
		180,
		9
	],
	"./pages/LeisureLanding/components/Character": [
		362,
		9
	],
	"./pages/LeisureLanding/components/Character/": [
		362,
		9
	],
	"./pages/LeisureLanding/components/Character/Character": [
		541,
		9
	],
	"./pages/LeisureLanding/components/Character/Character.scss": [
		1392,
		7
	],
	"./pages/LeisureLanding/components/Character/Character.tsx": [
		541,
		9
	],
	"./pages/LeisureLanding/components/Character/Character.types": [
		1796,
		9,
		385
	],
	"./pages/LeisureLanding/components/Character/Character.types.ts": [
		1796,
		9,
		385
	],
	"./pages/LeisureLanding/components/Character/index": [
		362,
		9
	],
	"./pages/LeisureLanding/components/Character/index.tsx": [
		362,
		9
	],
	"./pages/LeisureLanding/components/CircleCounterList/CircleCounter/CircleCounter": [
		741,
		9
	],
	"./pages/LeisureLanding/components/CircleCounterList/CircleCounter/CircleCounter.helper": [
		1797,
		9,
		386
	],
	"./pages/LeisureLanding/components/CircleCounterList/CircleCounter/CircleCounter.helper.ts": [
		1797,
		9,
		386
	],
	"./pages/LeisureLanding/components/CircleCounterList/CircleCounter/CircleCounter.scss": [
		1383,
		7
	],
	"./pages/LeisureLanding/components/CircleCounterList/CircleCounter/CircleCounter.tsx": [
		741,
		9
	],
	"./pages/LeisureLanding/components/CircleCounterList/CircleCounterList": [
		740,
		9
	],
	"./pages/LeisureLanding/components/CircleCounterList/CircleCounterList.data": [
		742,
		9
	],
	"./pages/LeisureLanding/components/CircleCounterList/CircleCounterList.data.tsx": [
		742,
		9
	],
	"./pages/LeisureLanding/components/CircleCounterList/CircleCounterList.scss": [
		1384,
		7
	],
	"./pages/LeisureLanding/components/CircleCounterList/CircleCounterList.tsx": [
		740,
		9
	],
	"./pages/LeisureLanding/components/EventsSlider": [
		366,
		9
	],
	"./pages/LeisureLanding/components/EventsSlider/": [
		366,
		9
	],
	"./pages/LeisureLanding/components/EventsSlider/EventsSlider": [
		548,
		9
	],
	"./pages/LeisureLanding/components/EventsSlider/EventsSlider.scss": [
		1401,
		7
	],
	"./pages/LeisureLanding/components/EventsSlider/EventsSlider.tsx": [
		548,
		9
	],
	"./pages/LeisureLanding/components/EventsSlider/EventsSlider.types": [
		1798,
		9,
		387
	],
	"./pages/LeisureLanding/components/EventsSlider/EventsSlider.types.ts": [
		1798,
		9,
		387
	],
	"./pages/LeisureLanding/components/EventsSlider/index": [
		366,
		9
	],
	"./pages/LeisureLanding/components/EventsSlider/index.tsx": [
		366,
		9
	],
	"./pages/LeisureLanding/components/FinalModal": [
		364,
		9
	],
	"./pages/LeisureLanding/components/FinalModal/": [
		364,
		9
	],
	"./pages/LeisureLanding/components/FinalModal/FinalModal": [
		544,
		9
	],
	"./pages/LeisureLanding/components/FinalModal/FinalModal.scss": [
		1395,
		7
	],
	"./pages/LeisureLanding/components/FinalModal/FinalModal.tsx": [
		544,
		9
	],
	"./pages/LeisureLanding/components/FinalModal/FinalModal.types": [
		1799,
		9,
		388
	],
	"./pages/LeisureLanding/components/FinalModal/FinalModal.types.ts": [
		1799,
		9,
		388
	],
	"./pages/LeisureLanding/components/FinalModal/index": [
		364,
		9
	],
	"./pages/LeisureLanding/components/FinalModal/index.tsx": [
		364,
		9
	],
	"./pages/LeisureLanding/components/FinishInformersModal": [
		890,
		9,
		55
	],
	"./pages/LeisureLanding/components/FinishInformersModal/": [
		890,
		9,
		55
	],
	"./pages/LeisureLanding/components/FinishInformersModal/FinishInformersModal": [
		1714,
		9,
		293
	],
	"./pages/LeisureLanding/components/FinishInformersModal/FinishInformersModal.scss": [
		2810,
		7,
		578
	],
	"./pages/LeisureLanding/components/FinishInformersModal/FinishInformersModal.tsx": [
		1714,
		9,
		293
	],
	"./pages/LeisureLanding/components/FinishInformersModal/index": [
		890,
		9,
		55
	],
	"./pages/LeisureLanding/components/FinishInformersModal/index.tsx": [
		890,
		9,
		55
	],
	"./pages/LeisureLanding/components/Floating": [
		361,
		9
	],
	"./pages/LeisureLanding/components/Floating/": [
		361,
		9
	],
	"./pages/LeisureLanding/components/Floating/Floating": [
		540,
		9
	],
	"./pages/LeisureLanding/components/Floating/Floating.scss": [
		1391,
		7
	],
	"./pages/LeisureLanding/components/Floating/Floating.tsx": [
		540,
		9
	],
	"./pages/LeisureLanding/components/Floating/Floating.types": [
		1800,
		9,
		389
	],
	"./pages/LeisureLanding/components/Floating/Floating.types.ts": [
		1800,
		9,
		389
	],
	"./pages/LeisureLanding/components/Floating/index": [
		361,
		9
	],
	"./pages/LeisureLanding/components/Floating/index.tsx": [
		361,
		9
	],
	"./pages/LeisureLanding/components/Footer": [
		358,
		9
	],
	"./pages/LeisureLanding/components/Footer/": [
		358,
		9
	],
	"./pages/LeisureLanding/components/Footer/Footer": [
		537,
		9
	],
	"./pages/LeisureLanding/components/Footer/Footer.scss": [
		1388,
		7
	],
	"./pages/LeisureLanding/components/Footer/Footer.tsx": [
		537,
		9
	],
	"./pages/LeisureLanding/components/Footer/Footer.types": [
		1801,
		9,
		390
	],
	"./pages/LeisureLanding/components/Footer/Footer.types.ts": [
		1801,
		9,
		390
	],
	"./pages/LeisureLanding/components/Footer/FooterProgress": [
		359,
		9
	],
	"./pages/LeisureLanding/components/Footer/FooterProgress/": [
		359,
		9
	],
	"./pages/LeisureLanding/components/Footer/FooterProgress/FooterProgress": [
		538,
		9
	],
	"./pages/LeisureLanding/components/Footer/FooterProgress/FooterProgress.scss": [
		1389,
		7
	],
	"./pages/LeisureLanding/components/Footer/FooterProgress/FooterProgress.tsx": [
		538,
		9
	],
	"./pages/LeisureLanding/components/Footer/FooterProgress/FooterProgress.types": [
		1802,
		9,
		391
	],
	"./pages/LeisureLanding/components/Footer/FooterProgress/FooterProgress.types.ts": [
		1802,
		9,
		391
	],
	"./pages/LeisureLanding/components/Footer/FooterProgress/index": [
		359,
		9
	],
	"./pages/LeisureLanding/components/Footer/FooterProgress/index.tsx": [
		359,
		9
	],
	"./pages/LeisureLanding/components/Footer/index": [
		358,
		9
	],
	"./pages/LeisureLanding/components/Footer/index.tsx": [
		358,
		9
	],
	"./pages/LeisureLanding/components/IdeaSentModal": [
		327,
		9
	],
	"./pages/LeisureLanding/components/IdeaSentModal/": [
		327,
		9
	],
	"./pages/LeisureLanding/components/IdeaSentModal/IdeaSentModal": [
		545,
		9
	],
	"./pages/LeisureLanding/components/IdeaSentModal/IdeaSentModal.scss": [
		1396,
		7
	],
	"./pages/LeisureLanding/components/IdeaSentModal/IdeaSentModal.tsx": [
		545,
		9
	],
	"./pages/LeisureLanding/components/IdeaSentModal/IdeaSentModal.types": [
		1803,
		9,
		392
	],
	"./pages/LeisureLanding/components/IdeaSentModal/IdeaSentModal.types.ts": [
		1803,
		9,
		392
	],
	"./pages/LeisureLanding/components/IdeaSentModal/index": [
		327,
		9
	],
	"./pages/LeisureLanding/components/IdeaSentModal/index.tsx": [
		327,
		9
	],
	"./pages/LeisureLanding/components/Informer": [
		891,
		9,
		77
	],
	"./pages/LeisureLanding/components/Informer/": [
		891,
		9,
		77
	],
	"./pages/LeisureLanding/components/Informer/Informer": [
		487,
		9
	],
	"./pages/LeisureLanding/components/Informer/Informer.scss": [
		1385,
		7
	],
	"./pages/LeisureLanding/components/Informer/Informer.tsx": [
		487,
		9
	],
	"./pages/LeisureLanding/components/Informer/Informer.types": [
		1804,
		9,
		393
	],
	"./pages/LeisureLanding/components/Informer/Informer.types.ts": [
		1804,
		9,
		393
	],
	"./pages/LeisureLanding/components/Informer/index": [
		891,
		9,
		77
	],
	"./pages/LeisureLanding/components/Informer/index.tsx": [
		891,
		9,
		77
	],
	"./pages/LeisureLanding/components/LeisureHeader/CircleButton/CircleButton": [
		1733,
		9,
		267
	],
	"./pages/LeisureLanding/components/LeisureHeader/CircleButton/CircleButton.scss": [
		2811,
		7,
		579
	],
	"./pages/LeisureLanding/components/LeisureHeader/CircleButton/CircleButton.tsx": [
		1733,
		9,
		267
	],
	"./pages/LeisureLanding/components/LeisureHeader/CircleButtonList/CircleButtonList": [
		1805,
		9,
		234
	],
	"./pages/LeisureLanding/components/LeisureHeader/CircleButtonList/CircleButtonList.scss": [
		2837,
		7,
		580
	],
	"./pages/LeisureLanding/components/LeisureHeader/CircleButtonList/CircleButtonList.tsx": [
		1805,
		9,
		234
	],
	"./pages/LeisureLanding/components/LeisureHeader/LeisureHeader": [
		743,
		9
	],
	"./pages/LeisureLanding/components/LeisureHeader/LeisureHeader.data": [
		331,
		9
	],
	"./pages/LeisureLanding/components/LeisureHeader/LeisureHeader.data.ts": [
		331,
		9
	],
	"./pages/LeisureLanding/components/LeisureHeader/LeisureHeader.scss": [
		1398,
		7
	],
	"./pages/LeisureLanding/components/LeisureHeader/LeisureHeader.tsx": [
		743,
		9
	],
	"./pages/LeisureLanding/components/Loading": [
		365,
		9
	],
	"./pages/LeisureLanding/components/Loading/": [
		365,
		9
	],
	"./pages/LeisureLanding/components/Loading/Loading": [
		546,
		9
	],
	"./pages/LeisureLanding/components/Loading/Loading.scss": [
		1397,
		7
	],
	"./pages/LeisureLanding/components/Loading/Loading.tsx": [
		546,
		9
	],
	"./pages/LeisureLanding/components/Loading/Loading.types": [
		1806,
		9,
		394
	],
	"./pages/LeisureLanding/components/Loading/Loading.types.ts": [
		1806,
		9,
		394
	],
	"./pages/LeisureLanding/components/Loading/index": [
		365,
		9
	],
	"./pages/LeisureLanding/components/Loading/index.tsx": [
		365,
		9
	],
	"./pages/LeisureLanding/components/Modal": [
		153,
		9
	],
	"./pages/LeisureLanding/components/Modal/": [
		153,
		9
	],
	"./pages/LeisureLanding/components/Modal/Modal": [
		536,
		9
	],
	"./pages/LeisureLanding/components/Modal/Modal.scss": [
		1387,
		7
	],
	"./pages/LeisureLanding/components/Modal/Modal.tsx": [
		536,
		9
	],
	"./pages/LeisureLanding/components/Modal/Modal.types": [
		1807,
		9,
		395
	],
	"./pages/LeisureLanding/components/Modal/Modal.types.ts": [
		1807,
		9,
		395
	],
	"./pages/LeisureLanding/components/Modal/index": [
		153,
		9
	],
	"./pages/LeisureLanding/components/Modal/index.tsx": [
		153,
		9
	],
	"./pages/LeisureLanding/components/Popup": [
		363,
		9
	],
	"./pages/LeisureLanding/components/Popup/": [
		363,
		9
	],
	"./pages/LeisureLanding/components/Popup/Popup": [
		542,
		9
	],
	"./pages/LeisureLanding/components/Popup/Popup.scss": [
		1393,
		7
	],
	"./pages/LeisureLanding/components/Popup/Popup.tsx": [
		542,
		9
	],
	"./pages/LeisureLanding/components/Popup/Popup.types": [
		1808,
		9,
		396
	],
	"./pages/LeisureLanding/components/Popup/Popup.types.ts": [
		1808,
		9,
		396
	],
	"./pages/LeisureLanding/components/Popup/index": [
		363,
		9
	],
	"./pages/LeisureLanding/components/Popup/index.tsx": [
		363,
		9
	],
	"./pages/LeisureLanding/components/ScreenStub": [
		367,
		9
	],
	"./pages/LeisureLanding/components/ScreenStub/": [
		367,
		9
	],
	"./pages/LeisureLanding/components/ScreenStub/ScreenStub": [
		549,
		9
	],
	"./pages/LeisureLanding/components/ScreenStub/ScreenStub.scss": [
		1402,
		7
	],
	"./pages/LeisureLanding/components/ScreenStub/ScreenStub.tsx": [
		549,
		9
	],
	"./pages/LeisureLanding/components/ScreenStub/index": [
		367,
		9
	],
	"./pages/LeisureLanding/components/ScreenStub/index.tsx": [
		367,
		9
	],
	"./pages/LeisureLanding/components/Tooltip": [
		418,
		9
	],
	"./pages/LeisureLanding/components/Tooltip/": [
		418,
		9
	],
	"./pages/LeisureLanding/components/Tooltip/Tooltip": [
		535,
		9
	],
	"./pages/LeisureLanding/components/Tooltip/Tooltip.scss": [
		1386,
		7
	],
	"./pages/LeisureLanding/components/Tooltip/Tooltip.tsx": [
		535,
		9
	],
	"./pages/LeisureLanding/components/Tooltip/index": [
		418,
		9
	],
	"./pages/LeisureLanding/components/Tooltip/index.tsx": [
		418,
		9
	],
	"./pages/LeisureLanding/components/Train": [
		360,
		9
	],
	"./pages/LeisureLanding/components/Train/": [
		360,
		9
	],
	"./pages/LeisureLanding/components/Train/Train": [
		539,
		9
	],
	"./pages/LeisureLanding/components/Train/Train.scss": [
		1390,
		7
	],
	"./pages/LeisureLanding/components/Train/Train.tsx": [
		539,
		9
	],
	"./pages/LeisureLanding/components/Train/Train.types": [
		1809,
		9,
		397
	],
	"./pages/LeisureLanding/components/Train/Train.types.ts": [
		1809,
		9,
		397
	],
	"./pages/LeisureLanding/components/Train/index": [
		360,
		9
	],
	"./pages/LeisureLanding/components/Train/index.tsx": [
		360,
		9
	],
	"./pages/LeisureLanding/pages/LeisureLanding/LeisureLanding": [
		739,
		9
	],
	"./pages/LeisureLanding/pages/LeisureLanding/LeisureLanding.scss": [
		1382,
		7
	],
	"./pages/LeisureLanding/pages/LeisureLanding/LeisureLanding.tsx": [
		739,
		9
	],
	"./pages/LeisureLanding/pages/LeisureLanding/leisureLandingEventsSlides": [
		745,
		9
	],
	"./pages/LeisureLanding/pages/LeisureLanding/leisureLandingEventsSlides.ts": [
		745,
		9
	],
	"./pages/LeisureLanding/pages/LeisureLanding/leisureLandingInfoItems": [
		330,
		9
	],
	"./pages/LeisureLanding/pages/LeisureLanding/leisureLandingInfoItems.ts": [
		330,
		9
	],
	"./pages/LeisureLanding/pages/LeisureLanding/leisureLandingObjects": [
		309,
		9
	],
	"./pages/LeisureLanding/pages/LeisureLanding/leisureLandingObjects.ts": [
		309,
		9
	],
	"./pages/LeisureLanding/pages/LeisureLanding/leisureLandingPoints": [
		206,
		9
	],
	"./pages/LeisureLanding/pages/LeisureLanding/leisureLandingPoints.ts": [
		206,
		9
	],
	"./pages/LeisureLanding/pages/TestPage/TestPage": [
		1810,
		9,
		294
	],
	"./pages/LeisureLanding/pages/TestPage/TestPage.scss": [
		2838,
		7,
		581
	],
	"./pages/LeisureLanding/pages/TestPage/TestPage.tsx": [
		1810,
		9,
		294
	],
	"./pages/LeisureLanding/services/city-api": [
		144,
		9
	],
	"./pages/LeisureLanding/services/city-api.tsx": [
		144,
		9
	],
	"./pages/LeisureLanding/utils/constants": [
		89,
		9
	],
	"./pages/LeisureLanding/utils/constants.ts": [
		89,
		9
	],
	"./pages/License/LicensePage": [
		627,
		9
	],
	"./pages/License/LicensePage.scss": [
		1214,
		7
	],
	"./pages/License/LicensePage.tsx": [
		627,
		9
	],
	"./pages/Main/AboutSection/AboutSection": [
		699,
		9
	],
	"./pages/Main/AboutSection/AboutSection.module.scss": [
		478,
		7
	],
	"./pages/Main/AboutSection/AboutSection.tsx": [
		699,
		9
	],
	"./pages/Main/AboutSection/AboutStatistic/AboutStatistic": [
		814,
		9
	],
	"./pages/Main/AboutSection/AboutStatistic/AboutStatistic.module.scss": [
		223,
		7
	],
	"./pages/Main/AboutSection/AboutStatistic/AboutStatistic.tsx": [
		814,
		9
	],
	"./pages/Main/AboutSection/helpers": [
		700,
		9
	],
	"./pages/Main/AboutSection/helpers.ts": [
		700,
		9
	],
	"./pages/Main/BannerDirections/BannerDirections": [
		809,
		9
	],
	"./pages/Main/BannerDirections/BannerDirections.interface": [
		403,
		9
	],
	"./pages/Main/BannerDirections/BannerDirections.interface.ts": [
		403,
		9
	],
	"./pages/Main/BannerDirections/BannerDirections.module.scss": [
		318,
		7
	],
	"./pages/Main/BannerDirections/BannerDirections.tsx": [
		809,
		9
	],
	"./pages/Main/BannerDirections/BannerDirections.utils": [
		73,
		9
	],
	"./pages/Main/BannerDirections/BannerDirections.utils.ts": [
		73,
		9
	],
	"./pages/Main/BannerLine/BannerLine": [
		686,
		9
	],
	"./pages/Main/BannerLine/BannerLine.module.scss": [
		475,
		7
	],
	"./pages/Main/BannerLine/BannerLine.tsx": [
		686,
		9
	],
	"./pages/Main/BannersSection/BannersSection": [
		682,
		9
	],
	"./pages/Main/BannersSection/BannersSection.helper": [
		1811,
		9,
		398
	],
	"./pages/Main/BannersSection/BannersSection.helper.ts": [
		1811,
		9,
		398
	],
	"./pages/Main/BannersSection/BannersSection.module.scss": [
		115,
		7
	],
	"./pages/Main/BannersSection/BannersSection.tsx": [
		682,
		9
	],
	"./pages/Main/ExternalLinks/ExternalLinks": [
		687,
		9
	],
	"./pages/Main/ExternalLinks/ExternalLinks.helper": [
		386,
		9
	],
	"./pages/Main/ExternalLinks/ExternalLinks.helper.ts": [
		386,
		9
	],
	"./pages/Main/ExternalLinks/ExternalLinks.module.scss": [
		338,
		7
	],
	"./pages/Main/ExternalLinks/ExternalLinks.tsx": [
		687,
		9
	],
	"./pages/Main/ExternalLinks/ExternalPopup/ExternalPopup": [
		688,
		9
	],
	"./pages/Main/ExternalLinks/ExternalPopup/ExternalPopup.scss": [
		1330,
		7
	],
	"./pages/Main/ExternalLinks/ExternalPopup/ExternalPopup.tsx": [
		688,
		9
	],
	"./pages/Main/IdeasSection/IdeasSection": [
		690,
		9
	],
	"./pages/Main/IdeasSection/IdeasSection.tsx": [
		690,
		9
	],
	"./pages/Main/MainPage": [
		797,
		9
	],
	"./pages/Main/MainPage.module.scss": [
		247,
		7
	],
	"./pages/Main/MainPage.tsx": [
		797,
		9
	],
	"./pages/Main/NewsSection/NewsCard/NewsCard": [
		460,
		9
	],
	"./pages/Main/NewsSection/NewsCard/NewsCard.module.scss": [
		981,
		7
	],
	"./pages/Main/NewsSection/NewsCard/NewsCard.tsx": [
		460,
		9
	],
	"./pages/Main/NewsSection/NewsCard/TagsCard/TagsCard": [
		697,
		9
	],
	"./pages/Main/NewsSection/NewsCard/TagsCard/TagsCard.interface": [
		1812,
		9,
		399
	],
	"./pages/Main/NewsSection/NewsCard/TagsCard/TagsCard.interface.ts": [
		1812,
		9,
		399
	],
	"./pages/Main/NewsSection/NewsCard/TagsCard/TagsCard.module.scss": [
		210,
		7
	],
	"./pages/Main/NewsSection/NewsCard/TagsCard/TagsCard.tsx": [
		697,
		9
	],
	"./pages/Main/NewsSection/NewsCard/TagsCard/VideoPreview/VideoPreview": [
		698,
		9
	],
	"./pages/Main/NewsSection/NewsCard/TagsCard/VideoPreview/VideoPreview.module.scss": [
		477,
		7
	],
	"./pages/Main/NewsSection/NewsCard/TagsCard/VideoPreview/VideoPreview.tsx": [
		698,
		9
	],
	"./pages/Main/NewsSection/NewsSection": [
		696,
		9
	],
	"./pages/Main/NewsSection/NewsSection.module.scss": [
		317,
		7
	],
	"./pages/Main/NewsSection/NewsSection.tsx": [
		696,
		9
	],
	"./pages/Main/ProposeIdeaSection/ProposeIdeaSection": [
		701,
		9
	],
	"./pages/Main/ProposeIdeaSection/ProposeIdeaSection.module.scss": [
		187,
		7
	],
	"./pages/Main/ProposeIdeaSection/ProposeIdeaSection.tsx": [
		701,
		9
	],
	"./pages/Main/ResultSection/ReportButton/ReportButton": [
		393,
		9
	],
	"./pages/Main/ResultSection/ReportButton/ReportButton.tsx": [
		393,
		9
	],
	"./pages/Main/ResultSection/ResultPopup/ResultPopup": [
		694,
		9
	],
	"./pages/Main/ResultSection/ResultPopup/ResultPopup.scss": [
		1336,
		7
	],
	"./pages/Main/ResultSection/ResultPopup/ResultPopup.tsx": [
		694,
		9
	],
	"./pages/Main/ResultSection/ResultSection": [
		808,
		9
	],
	"./pages/Main/ResultSection/ResultSection.module.scss": [
		339,
		7
	],
	"./pages/Main/ResultSection/ResultSection.tsx": [
		808,
		9
	],
	"./pages/MayorAppeal/MayorAppealPage": [
		593,
		9
	],
	"./pages/MayorAppeal/MayorAppealPage.scss": [
		1170,
		7
	],
	"./pages/MayorAppeal/MayorAppealPage.tsx": [
		593,
		9
	],
	"./pages/NYLanding": [
		892,
		9,
		1,
		8,
		6,
		9,
		19
	],
	"./pages/NYLanding/": [
		892,
		9,
		1,
		8,
		6,
		9,
		19
	],
	"./pages/NYLanding/Buttons/NYLandingButton": [
		853,
		9,
		56
	],
	"./pages/NYLanding/Buttons/NYLandingButton/": [
		853,
		9,
		56
	],
	"./pages/NYLanding/Buttons/NYLandingButton/NYLandingButton": [
		1510,
		9,
		295
	],
	"./pages/NYLanding/Buttons/NYLandingButton/NYLandingButton.scss": [
		2709,
		7,
		582
	],
	"./pages/NYLanding/Buttons/NYLandingButton/NYLandingButton.tsx": [
		1510,
		9,
		295
	],
	"./pages/NYLanding/Buttons/NYLandingButton/NYLandingButton.types": [
		1813,
		9,
		400
	],
	"./pages/NYLanding/Buttons/NYLandingButton/NYLandingButton.types.ts": [
		1813,
		9,
		400
	],
	"./pages/NYLanding/Buttons/NYLandingButton/index": [
		853,
		9,
		56
	],
	"./pages/NYLanding/Buttons/NYLandingButton/index.tsx": [
		853,
		9,
		56
	],
	"./pages/NYLanding/Buttons/NYLandingButtonClose": [
		854,
		9,
		51
	],
	"./pages/NYLanding/Buttons/NYLandingButtonClose/": [
		854,
		9,
		51
	],
	"./pages/NYLanding/Buttons/NYLandingButtonClose/NYLandingButtonClose": [
		1513,
		9,
		252
	],
	"./pages/NYLanding/Buttons/NYLandingButtonClose/NYLandingButtonClose.scss": [
		2711,
		7,
		583
	],
	"./pages/NYLanding/Buttons/NYLandingButtonClose/NYLandingButtonClose.tsx": [
		1513,
		9,
		252
	],
	"./pages/NYLanding/Buttons/NYLandingButtonClose/index": [
		854,
		9,
		51
	],
	"./pages/NYLanding/Buttons/NYLandingButtonClose/index.tsx": [
		854,
		9,
		51
	],
	"./pages/NYLanding/Buttons/NYLandingButtonNav": [
		859,
		9,
		50
	],
	"./pages/NYLanding/Buttons/NYLandingButtonNav/": [
		859,
		9,
		50
	],
	"./pages/NYLanding/Buttons/NYLandingButtonNav/NYLandingButtonNav": [
		1519,
		9,
		251
	],
	"./pages/NYLanding/Buttons/NYLandingButtonNav/NYLandingButtonNav.scss": [
		2718,
		7,
		584
	],
	"./pages/NYLanding/Buttons/NYLandingButtonNav/NYLandingButtonNav.tsx": [
		1519,
		9,
		251
	],
	"./pages/NYLanding/Buttons/NYLandingButtonNav/NYLandingButtonNav.types": [
		1814,
		9,
		401
	],
	"./pages/NYLanding/Buttons/NYLandingButtonNav/NYLandingButtonNav.types.tsx": [
		1814,
		9,
		401
	],
	"./pages/NYLanding/Buttons/NYLandingButtonNav/index": [
		859,
		9,
		50
	],
	"./pages/NYLanding/Buttons/NYLandingButtonNav/index.tsx": [
		859,
		9,
		50
	],
	"./pages/NYLanding/Buttons/NYLandingButtonRound": [
		856,
		9,
		58
	],
	"./pages/NYLanding/Buttons/NYLandingButtonRound/": [
		856,
		9,
		58
	],
	"./pages/NYLanding/Buttons/NYLandingButtonRound/NYLandingButtonRound": [
		1509,
		9,
		297
	],
	"./pages/NYLanding/Buttons/NYLandingButtonRound/NYLandingButtonRound.scss": [
		2708,
		7,
		585
	],
	"./pages/NYLanding/Buttons/NYLandingButtonRound/NYLandingButtonRound.tsx": [
		1509,
		9,
		297
	],
	"./pages/NYLanding/Buttons/NYLandingButtonRound/index": [
		856,
		9,
		58
	],
	"./pages/NYLanding/Buttons/NYLandingButtonRound/index.tsx": [
		856,
		9,
		58
	],
	"./pages/NYLanding/NYLandingAsideFinish": [
		870,
		9,
		34
	],
	"./pages/NYLanding/NYLandingAsideFinish/": [
		870,
		9,
		34
	],
	"./pages/NYLanding/NYLandingAsideFinish/NYLandingAsideFinish": [
		1546,
		9,
		218
	],
	"./pages/NYLanding/NYLandingAsideFinish/NYLandingAsideFinish.scss": [
		2753,
		7,
		586
	],
	"./pages/NYLanding/NYLandingAsideFinish/NYLandingAsideFinish.tsx": [
		1546,
		9,
		218
	],
	"./pages/NYLanding/NYLandingAsideFinish/index": [
		870,
		9,
		34
	],
	"./pages/NYLanding/NYLandingAsideFinish/index.tsx": [
		870,
		9,
		34
	],
	"./pages/NYLanding/NYLandingBgWrapper": [
		857,
		9,
		59
	],
	"./pages/NYLanding/NYLandingBgWrapper/": [
		857,
		9,
		59
	],
	"./pages/NYLanding/NYLandingBgWrapper/NYLandingBgWrapper": [
		1522,
		9,
		298
	],
	"./pages/NYLanding/NYLandingBgWrapper/NYLandingBgWrapper.scss": [
		2721,
		7,
		587
	],
	"./pages/NYLanding/NYLandingBgWrapper/NYLandingBgWrapper.tsx": [
		1522,
		9,
		298
	],
	"./pages/NYLanding/NYLandingBgWrapper/NYLandingBgWrapper.types": [
		1815,
		9,
		402
	],
	"./pages/NYLanding/NYLandingBgWrapper/NYLandingBgWrapper.types.ts": [
		1815,
		9,
		402
	],
	"./pages/NYLanding/NYLandingBgWrapper/index": [
		857,
		9,
		59
	],
	"./pages/NYLanding/NYLandingBgWrapper/index.tsx": [
		857,
		9,
		59
	],
	"./pages/NYLanding/NYLandingBootstrap/NYLandingBootstrap": [
		1816,
		9,
		1,
		8,
		6,
		9,
		115
	],
	"./pages/NYLanding/NYLandingBootstrap/NYLandingBootstrap.scss": [
		2839,
		7,
		555
	],
	"./pages/NYLanding/NYLandingBootstrap/NYLandingBootstrap.tsx": [
		1816,
		9,
		1,
		8,
		6,
		9,
		115
	],
	"./pages/NYLanding/NYLandingChangeDeviceStub/NYLandingChangeDeviceStub": [
		1642,
		9,
		200
	],
	"./pages/NYLanding/NYLandingChangeDeviceStub/NYLandingChangeDeviceStub.scss": [
		2769,
		7,
		588
	],
	"./pages/NYLanding/NYLandingChangeDeviceStub/NYLandingChangeDeviceStub.tsx": [
		1642,
		9,
		200
	],
	"./pages/NYLanding/NYLandingFAQ": [
		883,
		9,
		15,
		57
	],
	"./pages/NYLanding/NYLandingFAQ/": [
		883,
		9,
		15,
		57
	],
	"./pages/NYLanding/NYLandingFAQ/NYLandingFAQ": [
		1669,
		9,
		15,
		296
	],
	"./pages/NYLanding/NYLandingFAQ/NYLandingFAQ.scss": [
		2822,
		7,
		589
	],
	"./pages/NYLanding/NYLandingFAQ/NYLandingFAQ.tsx": [
		1669,
		9,
		15,
		296
	],
	"./pages/NYLanding/NYLandingFAQ/index": [
		883,
		9,
		15,
		57
	],
	"./pages/NYLanding/NYLandingFAQ/index.tsx": [
		883,
		9,
		15,
		57
	],
	"./pages/NYLanding/NYLandingFAQ/utils": [
		1713,
		9,
		403
	],
	"./pages/NYLanding/NYLandingFAQ/utils.tsx": [
		1713,
		9,
		403
	],
	"./pages/NYLanding/NYLandingFooter": [
		863,
		9,
		60
	],
	"./pages/NYLanding/NYLandingFooter/": [
		863,
		9,
		60
	],
	"./pages/NYLanding/NYLandingFooter/NYLandingFooter": [
		1538,
		9,
		299
	],
	"./pages/NYLanding/NYLandingFooter/NYLandingFooter.scss": [
		2740,
		7,
		590
	],
	"./pages/NYLanding/NYLandingFooter/NYLandingFooter.tsx": [
		1538,
		9,
		299
	],
	"./pages/NYLanding/NYLandingFooter/NYLandingFooterProgress/NYLandingFooterProgress": [
		1638,
		9,
		300
	],
	"./pages/NYLanding/NYLandingFooter/NYLandingFooterProgress/NYLandingFooterProgress.scss": [
		2765,
		7,
		591
	],
	"./pages/NYLanding/NYLandingFooter/NYLandingFooterProgress/NYLandingFooterProgress.tsx": [
		1638,
		9,
		300
	],
	"./pages/NYLanding/NYLandingFooter/NYLandingFooterProgress/NYLandingFooterProgress.types": [
		1817,
		9,
		404
	],
	"./pages/NYLanding/NYLandingFooter/NYLandingFooterProgress/NYLandingFooterProgress.types.ts": [
		1817,
		9,
		404
	],
	"./pages/NYLanding/NYLandingFooter/index": [
		863,
		9,
		60
	],
	"./pages/NYLanding/NYLandingFooter/index.tsx": [
		863,
		9,
		60
	],
	"./pages/NYLanding/NYLandingHeader": [
		864,
		9,
		61
	],
	"./pages/NYLanding/NYLandingHeader/": [
		864,
		9,
		61
	],
	"./pages/NYLanding/NYLandingHeader/NYHeaderAuth/NYHeaderAuth": [
		1641,
		9,
		235
	],
	"./pages/NYLanding/NYLandingHeader/NYHeaderAuth/NYHeaderAuth.scss": [
		2768,
		7,
		592
	],
	"./pages/NYLanding/NYLandingHeader/NYHeaderAuth/NYHeaderAuth.tsx": [
		1641,
		9,
		235
	],
	"./pages/NYLanding/NYLandingHeader/NYHeaderBack/NYHeaderBack": [
		1592,
		9,
		217
	],
	"./pages/NYLanding/NYLandingHeader/NYHeaderBack/NYHeaderBack.scss": [
		2758,
		7,
		593
	],
	"./pages/NYLanding/NYLandingHeader/NYHeaderBack/NYHeaderBack.tsx": [
		1592,
		9,
		217
	],
	"./pages/NYLanding/NYLandingHeader/NYHeaderBack/NYHeaderBack.types": [
		1818,
		9,
		405
	],
	"./pages/NYLanding/NYLandingHeader/NYHeaderBack/NYHeaderBack.types.ts": [
		1818,
		9,
		405
	],
	"./pages/NYLanding/NYLandingHeader/NYHeaderBirds/NYHeaderBirds": [
		1640,
		9,
		301
	],
	"./pages/NYLanding/NYLandingHeader/NYHeaderBirds/NYHeaderBirds.scss": [
		2767,
		7,
		594
	],
	"./pages/NYLanding/NYLandingHeader/NYHeaderBirds/NYHeaderBirds.tsx": [
		1640,
		9,
		301
	],
	"./pages/NYLanding/NYLandingHeader/NYHeaderLogo/NYHeaderLogo": [
		1639,
		9,
		260
	],
	"./pages/NYLanding/NYLandingHeader/NYHeaderLogo/NYHeaderLogo.scss": [
		2766,
		7,
		595
	],
	"./pages/NYLanding/NYLandingHeader/NYHeaderLogo/NYHeaderLogo.tsx": [
		1639,
		9,
		260
	],
	"./pages/NYLanding/NYLandingHeader/NYLandingHeader": [
		1525,
		9,
		302
	],
	"./pages/NYLanding/NYLandingHeader/NYLandingHeader.scss": [
		2741,
		7,
		596
	],
	"./pages/NYLanding/NYLandingHeader/NYLandingHeader.tsx": [
		1525,
		9,
		302
	],
	"./pages/NYLanding/NYLandingHeader/index": [
		864,
		9,
		61
	],
	"./pages/NYLanding/NYLandingHeader/index.tsx": [
		864,
		9,
		61
	],
	"./pages/NYLanding/NYLandingLoading": [
		873,
		9,
		62
	],
	"./pages/NYLanding/NYLandingLoading/": [
		873,
		9,
		62
	],
	"./pages/NYLanding/NYLandingLoading/NYLandingLoading": [
		1549,
		9,
		303
	],
	"./pages/NYLanding/NYLandingLoading/NYLandingLoading.scss": [
		2755,
		7,
		597
	],
	"./pages/NYLanding/NYLandingLoading/NYLandingLoading.tsx": [
		1549,
		9,
		303
	],
	"./pages/NYLanding/NYLandingLoading/NYLandingLoading.types": [
		1819,
		9,
		406
	],
	"./pages/NYLanding/NYLandingLoading/NYLandingLoading.types.ts": [
		1819,
		9,
		406
	],
	"./pages/NYLanding/NYLandingLoading/index": [
		873,
		9,
		62
	],
	"./pages/NYLanding/NYLandingLoading/index.tsx": [
		873,
		9,
		62
	],
	"./pages/NYLanding/NYLandingLogo": [
		869,
		9,
		72
	],
	"./pages/NYLanding/NYLandingLogo/": [
		869,
		9,
		72
	],
	"./pages/NYLanding/NYLandingLogo/NYLandingLogo": [
		1539,
		9,
		407
	],
	"./pages/NYLanding/NYLandingLogo/NYLandingLogo.tsx": [
		1539,
		9,
		407
	],
	"./pages/NYLanding/NYLandingLogo/NYLandingLogo.types": [
		1820,
		9,
		408
	],
	"./pages/NYLanding/NYLandingLogo/NYLandingLogo.types.ts": [
		1820,
		9,
		408
	],
	"./pages/NYLanding/NYLandingLogo/index": [
		869,
		9,
		72
	],
	"./pages/NYLanding/NYLandingLogo/index.tsx": [
		869,
		9,
		72
	],
	"./pages/NYLanding/NYLandingObject": [
		875,
		9,
		63
	],
	"./pages/NYLanding/NYLandingObject/": [
		875,
		9,
		63
	],
	"./pages/NYLanding/NYLandingObject/NYLandingObject": [
		1551,
		9,
		304
	],
	"./pages/NYLanding/NYLandingObject/NYLandingObject.scss": [
		2757,
		7,
		598
	],
	"./pages/NYLanding/NYLandingObject/NYLandingObject.tsx": [
		1551,
		9,
		304
	],
	"./pages/NYLanding/NYLandingObject/NYLandingObject.types": [
		1821,
		9,
		409
	],
	"./pages/NYLanding/NYLandingObject/NYLandingObject.types.ts": [
		1821,
		9,
		409
	],
	"./pages/NYLanding/NYLandingObject/index": [
		875,
		9,
		63
	],
	"./pages/NYLanding/NYLandingObject/index.tsx": [
		875,
		9,
		63
	],
	"./pages/NYLanding/NYLandingPage": [
		1670,
		9,
		1,
		8,
		6,
		9,
		116
	],
	"./pages/NYLanding/NYLandingPage.scss": [
		2786,
		7,
		599
	],
	"./pages/NYLanding/NYLandingPage.slides": [
		1637,
		9,
		1,
		8,
		9,
		117
	],
	"./pages/NYLanding/NYLandingPage.slides.tsx": [
		1637,
		9,
		1,
		8,
		9,
		117
	],
	"./pages/NYLanding/NYLandingPage.tsx": [
		1670,
		9,
		1,
		8,
		6,
		9,
		116
	],
	"./pages/NYLanding/NYLandingPopup": [
		860,
		9,
		46
	],
	"./pages/NYLanding/NYLandingPopup/": [
		860,
		9,
		46
	],
	"./pages/NYLanding/NYLandingPopup/NYLandingPopup": [
		1540,
		9,
		240
	],
	"./pages/NYLanding/NYLandingPopup/NYLandingPopup.scss": [
		2742,
		7,
		600
	],
	"./pages/NYLanding/NYLandingPopup/NYLandingPopup.tsx": [
		1540,
		9,
		240
	],
	"./pages/NYLanding/NYLandingPopup/NYLandingPopup.types": [
		1822,
		9,
		410
	],
	"./pages/NYLanding/NYLandingPopup/NYLandingPopup.types.ts": [
		1822,
		9,
		410
	],
	"./pages/NYLanding/NYLandingPopup/index": [
		860,
		9,
		46
	],
	"./pages/NYLanding/NYLandingPopup/index.tsx": [
		860,
		9,
		46
	],
	"./pages/NYLanding/NYLandingResultList": [
		874,
		9,
		47
	],
	"./pages/NYLanding/NYLandingResultList/": [
		874,
		9,
		47
	],
	"./pages/NYLanding/NYLandingResultList/NYLandingResultItem": [
		862,
		9,
		64
	],
	"./pages/NYLanding/NYLandingResultList/NYLandingResultItem/": [
		862,
		9,
		64
	],
	"./pages/NYLanding/NYLandingResultList/NYLandingResultItem/NYLandingResultItem": [
		1530,
		9,
		305
	],
	"./pages/NYLanding/NYLandingResultList/NYLandingResultItem/NYLandingResultItem.scss": [
		2725,
		7,
		601
	],
	"./pages/NYLanding/NYLandingResultList/NYLandingResultItem/NYLandingResultItem.tsx": [
		1530,
		9,
		305
	],
	"./pages/NYLanding/NYLandingResultList/NYLandingResultItem/NYLandingResultItem.types": [
		1823,
		9,
		411
	],
	"./pages/NYLanding/NYLandingResultList/NYLandingResultItem/NYLandingResultItem.types.ts": [
		1823,
		9,
		411
	],
	"./pages/NYLanding/NYLandingResultList/NYLandingResultItem/index": [
		862,
		9,
		64
	],
	"./pages/NYLanding/NYLandingResultList/NYLandingResultItem/index.tsx": [
		862,
		9,
		64
	],
	"./pages/NYLanding/NYLandingResultList/NYLandingResultList": [
		1550,
		9,
		241
	],
	"./pages/NYLanding/NYLandingResultList/NYLandingResultList.scss": [
		2756,
		7,
		602
	],
	"./pages/NYLanding/NYLandingResultList/NYLandingResultList.tsx": [
		1550,
		9,
		241
	],
	"./pages/NYLanding/NYLandingResultList/NYLandingResultList.types": [
		1824,
		9,
		412
	],
	"./pages/NYLanding/NYLandingResultList/NYLandingResultList.types.ts": [
		1824,
		9,
		412
	],
	"./pages/NYLanding/NYLandingResultList/index": [
		874,
		9,
		47
	],
	"./pages/NYLanding/NYLandingResultList/index.tsx": [
		874,
		9,
		47
	],
	"./pages/NYLanding/NYLandingSlider": [
		871,
		9,
		1,
		41
	],
	"./pages/NYLanding/NYLandingSlider/": [
		871,
		9,
		1,
		41
	],
	"./pages/NYLanding/NYLandingSlider/Components/FullScreenPopup/FullScreenPopup": [
		1517,
		9,
		219
	],
	"./pages/NYLanding/NYLandingSlider/Components/FullScreenPopup/FullScreenPopup.scss": [
		2714,
		7,
		603
	],
	"./pages/NYLanding/NYLandingSlider/Components/FullScreenPopup/FullScreenPopup.tsx": [
		1517,
		9,
		219
	],
	"./pages/NYLanding/NYLandingSlider/Components/SliderContentArrow": [
		855,
		9,
		45
	],
	"./pages/NYLanding/NYLandingSlider/Components/SliderContentArrow/": [
		855,
		9,
		45
	],
	"./pages/NYLanding/NYLandingSlider/Components/SliderContentArrow/SliderContentArrow": [
		1516,
		9,
		239
	],
	"./pages/NYLanding/NYLandingSlider/Components/SliderContentArrow/SliderContentArrow.scss": [
		2712,
		7,
		604
	],
	"./pages/NYLanding/NYLandingSlider/Components/SliderContentArrow/SliderContentArrow.tsx": [
		1516,
		9,
		239
	],
	"./pages/NYLanding/NYLandingSlider/Components/SliderContentArrow/index": [
		855,
		9,
		45
	],
	"./pages/NYLanding/NYLandingSlider/Components/SliderContentArrow/index.tsx": [
		855,
		9,
		45
	],
	"./pages/NYLanding/NYLandingSlider/NYLandingSlider": [
		1547,
		9,
		1,
		223
	],
	"./pages/NYLanding/NYLandingSlider/NYLandingSlider.scss": [
		2754,
		7,
		605
	],
	"./pages/NYLanding/NYLandingSlider/NYLandingSlider.tsx": [
		1547,
		9,
		1,
		223
	],
	"./pages/NYLanding/NYLandingSlider/NYLandingSlider.types": [
		1825,
		9,
		413
	],
	"./pages/NYLanding/NYLandingSlider/NYLandingSlider.types.ts": [
		1825,
		9,
		413
	],
	"./pages/NYLanding/NYLandingSlider/Slides/AgProjectsSlide/AgProjectCard/AgProjectCard": [
		1709,
		9,
		306
	],
	"./pages/NYLanding/NYLandingSlider/Slides/AgProjectsSlide/AgProjectCard/AgProjectCard.scss": [
		2791,
		7,
		606
	],
	"./pages/NYLanding/NYLandingSlider/Slides/AgProjectsSlide/AgProjectCard/AgProjectCard.tsx": [
		1709,
		9,
		306
	],
	"./pages/NYLanding/NYLandingSlider/Slides/AgProjectsSlide/AgProjectsSlide": [
		1742,
		9,
		205
	],
	"./pages/NYLanding/NYLandingSlider/Slides/AgProjectsSlide/AgProjectsSlide.scss": [
		2820,
		7,
		607
	],
	"./pages/NYLanding/NYLandingSlider/Slides/AgProjectsSlide/AgProjectsSlide.tsx": [
		1742,
		9,
		205
	],
	"./pages/NYLanding/NYLandingSlider/Slides/AgVictorines/AgVictorines": [
		1743,
		9,
		180
	],
	"./pages/NYLanding/NYLandingSlider/Slides/AgVictorines/AgVictorines.scss": [
		2821,
		7,
		608
	],
	"./pages/NYLanding/NYLandingSlider/Slides/AgVictorines/AgVictorines.tsx": [
		1743,
		9,
		180
	],
	"./pages/NYLanding/NYLandingSlider/Slides/AgVictorines/AgVictorinesCard/AgVictorinesCard": [
		1710,
		9,
		236
	],
	"./pages/NYLanding/NYLandingSlider/Slides/AgVictorines/AgVictorinesCard/AgVictorinesCard.scss": [
		2792,
		7,
		609
	],
	"./pages/NYLanding/NYLandingSlider/Slides/AgVictorines/AgVictorinesCard/AgVictorinesCard.tsx": [
		1710,
		9,
		236
	],
	"./pages/NYLanding/NYLandingSlider/Slides/AgVictorines/AgVictorinesMobileCard/AgVictorinesMobileCard": [
		1711,
		9,
		307
	],
	"./pages/NYLanding/NYLandingSlider/Slides/AgVictorines/AgVictorinesMobileCard/AgVictorinesMobileCard.scss": [
		2793,
		7,
		610
	],
	"./pages/NYLanding/NYLandingSlider/Slides/AgVictorines/AgVictorinesMobileCard/AgVictorinesMobileCard.tsx": [
		1711,
		9,
		307
	],
	"./pages/NYLanding/NYLandingSlider/Slides/AgVictorines/AgVictorinesPopupCard/AgVictorinesPopupCard": [
		1712,
		9,
		237
	],
	"./pages/NYLanding/NYLandingSlider/Slides/AgVictorines/AgVictorinesPopupCard/AgVictorinesPopupCard.scss": [
		2794,
		7,
		611
	],
	"./pages/NYLanding/NYLandingSlider/Slides/AgVictorines/AgVictorinesPopupCard/AgVictorinesPopupCard.tsx": [
		1712,
		9,
		237
	],
	"./pages/NYLanding/NYLandingSlider/Slides/CardListSlide": [
		882,
		9,
		21
	],
	"./pages/NYLanding/NYLandingSlider/Slides/CardListSlide/": [
		882,
		9,
		21
	],
	"./pages/NYLanding/NYLandingSlider/Slides/CardListSlide/CardListSlide": [
		1636,
		9,
		188
	],
	"./pages/NYLanding/NYLandingSlider/Slides/CardListSlide/CardListSlide.scss": [
		2795,
		7,
		612
	],
	"./pages/NYLanding/NYLandingSlider/Slides/CardListSlide/CardListSlide.tsx": [
		1636,
		9,
		188
	],
	"./pages/NYLanding/NYLandingSlider/Slides/CardListSlide/index": [
		882,
		9,
		21
	],
	"./pages/NYLanding/NYLandingSlider/Slides/CardListSlide/index.tsx": [
		882,
		9,
		21
	],
	"./pages/NYLanding/NYLandingSlider/Slides/Content/AG/data": [
		1607,
		9,
		1,
		160
	],
	"./pages/NYLanding/NYLandingSlider/Slides/Content/AG/data.ts": [
		1607,
		9,
		1,
		160
	],
	"./pages/NYLanding/NYLandingSlider/Slides/Content/CROWD/data": [
		1606,
		9,
		1,
		8,
		154
	],
	"./pages/NYLanding/NYLandingSlider/Slides/Content/CROWD/data.ts": [
		1606,
		9,
		1,
		8,
		154
	],
	"./pages/NYLanding/NYLandingSlider/Slides/Content/ED/data": [
		1608,
		9,
		1,
		9,
		181
	],
	"./pages/NYLanding/NYLandingSlider/Slides/Content/ED/data.ts": [
		1608,
		9,
		1,
		9,
		181
	],
	"./pages/NYLanding/NYLandingSlider/Slides/GiftsSlide": [
		881,
		9,
		23
	],
	"./pages/NYLanding/NYLandingSlider/Slides/GiftsSlide/": [
		881,
		9,
		23
	],
	"./pages/NYLanding/NYLandingSlider/Slides/GiftsSlide/GiftsSlide": [
		1635,
		9,
		197
	],
	"./pages/NYLanding/NYLandingSlider/Slides/GiftsSlide/GiftsSlide.scss": [
		2790,
		7,
		613
	],
	"./pages/NYLanding/NYLandingSlider/Slides/GiftsSlide/GiftsSlide.tsx": [
		1635,
		9,
		197
	],
	"./pages/NYLanding/NYLandingSlider/Slides/GiftsSlide/index": [
		881,
		9,
		23
	],
	"./pages/NYLanding/NYLandingSlider/Slides/GiftsSlide/index.tsx": [
		881,
		9,
		23
	],
	"./pages/NYLanding/NYLandingSlider/Slides/IdeasSlide/IdeaCard": [
		878,
		9,
		65
	],
	"./pages/NYLanding/NYLandingSlider/Slides/IdeasSlide/IdeaCard/": [
		878,
		9,
		65
	],
	"./pages/NYLanding/NYLandingSlider/Slides/IdeasSlide/IdeaCard/IdeaCard": [
		1590,
		9,
		308
	],
	"./pages/NYLanding/NYLandingSlider/Slides/IdeasSlide/IdeaCard/IdeaCard.scss": [
		2762,
		7,
		614
	],
	"./pages/NYLanding/NYLandingSlider/Slides/IdeasSlide/IdeaCard/IdeaCard.tsx": [
		1590,
		9,
		308
	],
	"./pages/NYLanding/NYLandingSlider/Slides/IdeasSlide/IdeaCard/IdeaCard.types": [
		1826,
		9,
		414
	],
	"./pages/NYLanding/NYLandingSlider/Slides/IdeasSlide/IdeaCard/IdeaCard.types.ts": [
		1826,
		9,
		414
	],
	"./pages/NYLanding/NYLandingSlider/Slides/IdeasSlide/IdeaCard/index": [
		878,
		9,
		65
	],
	"./pages/NYLanding/NYLandingSlider/Slides/IdeasSlide/IdeaCard/index.tsx": [
		878,
		9,
		65
	],
	"./pages/NYLanding/NYLandingSlider/Slides/IdeasSlide/IdeasSlide": [
		1736,
		9,
		201
	],
	"./pages/NYLanding/NYLandingSlider/Slides/IdeasSlide/IdeasSlide.scss": [
		2814,
		7,
		615
	],
	"./pages/NYLanding/NYLandingSlider/Slides/IdeasSlide/IdeasSlide.tsx": [
		1736,
		9,
		201
	],
	"./pages/NYLanding/NYLandingSlider/Slides/JoinSlide/JoinSlide": [
		1740,
		9,
		238
	],
	"./pages/NYLanding/NYLandingSlider/Slides/JoinSlide/JoinSlide.scss": [
		2818,
		7,
		616
	],
	"./pages/NYLanding/NYLandingSlider/Slides/JoinSlide/JoinSlide.tsx": [
		1740,
		9,
		238
	],
	"./pages/NYLanding/NYLandingSlider/Slides/MapSlide/MapSlide": [
		1734,
		9,
		189
	],
	"./pages/NYLanding/NYLandingSlider/Slides/MapSlide/MapSlide.scss": [
		2812,
		7,
		617
	],
	"./pages/NYLanding/NYLandingSlider/Slides/MapSlide/MapSlide.tsx": [
		1734,
		9,
		189
	],
	"./pages/NYLanding/NYLandingSlider/Slides/NYSlideContent": [
		1524,
		9,
		1
	],
	"./pages/NYLanding/NYLandingSlider/Slides/NYSlideContent.scss": [
		2840,
		7,
		618
	],
	"./pages/NYLanding/NYLandingSlider/Slides/NYSlideContent.tsx": [
		1524,
		9,
		1
	],
	"./pages/NYLanding/NYLandingSlider/Slides/ParticipantsSlide/ParticipantCard": [
		877,
		9,
		66
	],
	"./pages/NYLanding/NYLandingSlider/Slides/ParticipantsSlide/ParticipantCard/": [
		877,
		9,
		66
	],
	"./pages/NYLanding/NYLandingSlider/Slides/ParticipantsSlide/ParticipantCard/ParticipantCard": [
		1589,
		9,
		309
	],
	"./pages/NYLanding/NYLandingSlider/Slides/ParticipantsSlide/ParticipantCard/ParticipantCard.scss": [
		2761,
		7,
		619
	],
	"./pages/NYLanding/NYLandingSlider/Slides/ParticipantsSlide/ParticipantCard/ParticipantCard.tsx": [
		1589,
		9,
		309
	],
	"./pages/NYLanding/NYLandingSlider/Slides/ParticipantsSlide/ParticipantCard/ParticipantCard.types": [
		1827,
		9,
		415
	],
	"./pages/NYLanding/NYLandingSlider/Slides/ParticipantsSlide/ParticipantCard/ParticipantCard.types.ts": [
		1827,
		9,
		415
	],
	"./pages/NYLanding/NYLandingSlider/Slides/ParticipantsSlide/ParticipantCard/index": [
		877,
		9,
		66
	],
	"./pages/NYLanding/NYLandingSlider/Slides/ParticipantsSlide/ParticipantCard/index.tsx": [
		877,
		9,
		66
	],
	"./pages/NYLanding/NYLandingSlider/Slides/ParticipantsSlide/ParticipantsSlide": [
		1735,
		9,
		202
	],
	"./pages/NYLanding/NYLandingSlider/Slides/ParticipantsSlide/ParticipantsSlide.scss": [
		2813,
		7,
		620
	],
	"./pages/NYLanding/NYLandingSlider/Slides/ParticipantsSlide/ParticipantsSlide.tsx": [
		1735,
		9,
		202
	],
	"./pages/NYLanding/NYLandingSlider/Slides/PhotosSlide/PhotosSlide": [
		1738,
		9,
		186
	],
	"./pages/NYLanding/NYLandingSlider/Slides/PhotosSlide/PhotosSlide.scss": [
		2816,
		7,
		621
	],
	"./pages/NYLanding/NYLandingSlider/Slides/PhotosSlide/PhotosSlide.tsx": [
		1738,
		9,
		186
	],
	"./pages/NYLanding/NYLandingSlider/Slides/PhotosSlide/PhotosSlidePopup/PhotosSlidePopup": [
		1707,
		9,
		190
	],
	"./pages/NYLanding/NYLandingSlider/Slides/PhotosSlide/PhotosSlidePopup/PhotosSlidePopup.scss": [
		2788,
		7,
		622
	],
	"./pages/NYLanding/NYLandingSlider/Slides/PhotosSlide/PhotosSlidePopup/PhotosSlidePopup.tsx": [
		1707,
		9,
		190
	],
	"./pages/NYLanding/NYLandingSlider/Slides/ProjectsSlide/ProjectCard": [
		879,
		9,
		67
	],
	"./pages/NYLanding/NYLandingSlider/Slides/ProjectsSlide/ProjectCard/": [
		879,
		9,
		67
	],
	"./pages/NYLanding/NYLandingSlider/Slides/ProjectsSlide/ProjectCard/ProjectCard": [
		1591,
		9,
		310
	],
	"./pages/NYLanding/NYLandingSlider/Slides/ProjectsSlide/ProjectCard/ProjectCard.scss": [
		2763,
		7,
		623
	],
	"./pages/NYLanding/NYLandingSlider/Slides/ProjectsSlide/ProjectCard/ProjectCard.tsx": [
		1591,
		9,
		310
	],
	"./pages/NYLanding/NYLandingSlider/Slides/ProjectsSlide/ProjectCard/ProjectCard.types": [
		1828,
		9,
		416
	],
	"./pages/NYLanding/NYLandingSlider/Slides/ProjectsSlide/ProjectCard/ProjectCard.types.ts": [
		1828,
		9,
		416
	],
	"./pages/NYLanding/NYLandingSlider/Slides/ProjectsSlide/ProjectCard/index": [
		879,
		9,
		67
	],
	"./pages/NYLanding/NYLandingSlider/Slides/ProjectsSlide/ProjectCard/index.tsx": [
		879,
		9,
		67
	],
	"./pages/NYLanding/NYLandingSlider/Slides/ProjectsSlide/ProjectsSlide": [
		1737,
		9,
		203
	],
	"./pages/NYLanding/NYLandingSlider/Slides/ProjectsSlide/ProjectsSlide.scss": [
		2815,
		7,
		624
	],
	"./pages/NYLanding/NYLandingSlider/Slides/ProjectsSlide/ProjectsSlide.tsx": [
		1737,
		9,
		203
	],
	"./pages/NYLanding/NYLandingSlider/Slides/UsersCongratsSlide/Components/UserCard/UserCongratCard": [
		1634,
		9,
		193
	],
	"./pages/NYLanding/NYLandingSlider/Slides/UsersCongratsSlide/Components/UserCard/UserCongratCard.scss": [
		2764,
		7,
		625
	],
	"./pages/NYLanding/NYLandingSlider/Slides/UsersCongratsSlide/Components/UserCard/UserCongratCard.tsx": [
		1634,
		9,
		193
	],
	"./pages/NYLanding/NYLandingSlider/Slides/UsersCongratsSlide/Components/UserCongratList/UserCongratList": [
		1708,
		9,
		183
	],
	"./pages/NYLanding/NYLandingSlider/Slides/UsersCongratsSlide/Components/UserCongratList/UserCongratList.scss": [
		2789,
		7,
		626
	],
	"./pages/NYLanding/NYLandingSlider/Slides/UsersCongratsSlide/Components/UserCongratList/UserCongratList.tsx": [
		1708,
		9,
		183
	],
	"./pages/NYLanding/NYLandingSlider/Slides/UsersCongratsSlide/UserCongratsSlide": [
		1741,
		9,
		182
	],
	"./pages/NYLanding/NYLandingSlider/Slides/UsersCongratsSlide/UserCongratsSlide.scss": [
		2819,
		7,
		627
	],
	"./pages/NYLanding/NYLandingSlider/Slides/UsersCongratsSlide/UserCongratsSlide.tsx": [
		1741,
		9,
		182
	],
	"./pages/NYLanding/NYLandingSlider/Slides/WishSlide/WishSlide": [
		1739,
		9,
		206
	],
	"./pages/NYLanding/NYLandingSlider/Slides/WishSlide/WishSlide.scss": [
		2817,
		7,
		628
	],
	"./pages/NYLanding/NYLandingSlider/Slides/WishSlide/WishSlide.tsx": [
		1739,
		9,
		206
	],
	"./pages/NYLanding/NYLandingSlider/index": [
		871,
		9,
		1,
		41
	],
	"./pages/NYLanding/NYLandingSlider/index.tsx": [
		871,
		9,
		1,
		41
	],
	"./pages/NYLanding/NYLandingSnowfall": [
		872,
		9,
		6,
		73
	],
	"./pages/NYLanding/NYLandingSnowfall/": [
		872,
		9,
		6,
		73
	],
	"./pages/NYLanding/NYLandingSnowfall/NYLandingSnowfall": [
		1548,
		9,
		6,
		417
	],
	"./pages/NYLanding/NYLandingSnowfall/NYLandingSnowfall.scss": [
		2797,
		7,
		6
	],
	"./pages/NYLanding/NYLandingSnowfall/NYLandingSnowfall.tsx": [
		1548,
		9,
		6,
		417
	],
	"./pages/NYLanding/NYLandingSnowfall/NYLandingSnowfall.types": [
		1829,
		9,
		418
	],
	"./pages/NYLanding/NYLandingSnowfall/NYLandingSnowfall.types.ts": [
		1829,
		9,
		418
	],
	"./pages/NYLanding/NYLandingSnowfall/index": [
		872,
		9,
		6,
		73
	],
	"./pages/NYLanding/NYLandingSnowfall/index.tsx": [
		872,
		9,
		6,
		73
	],
	"./pages/NYLanding/Utils/parser/address.parser": [
		1830,
		9,
		349,
		419
	],
	"./pages/NYLanding/Utils/parser/address.parser.js": [
		1830,
		9,
		349,
		419
	],
	"./pages/NYLanding/Utils/parser/addresses/crowd-points.xlsx": [
		2857,
		9,
		716
	],
	"./pages/NYLanding/Utils/parser/addresses/ed-points.xlsx": [
		2858,
		9,
		717
	],
	"./pages/NYLanding/Utils/parser/crowd-points": [
		1667,
		3,
		8
	],
	"./pages/NYLanding/Utils/parser/crowd-points.json": [
		1667,
		3,
		8
	],
	"./pages/NYLanding/Utils/parser/ed-points": [
		1668,
		3,
		9
	],
	"./pages/NYLanding/Utils/parser/ed-points.json": [
		1668,
		3,
		9
	],
	"./pages/NYLanding/Utils/settings": [
		271,
		9
	],
	"./pages/NYLanding/Utils/settings/": [
		271,
		9
	],
	"./pages/NYLanding/Utils/settings/index": [
		271,
		9
	],
	"./pages/NYLanding/Utils/settings/index.ts": [
		271,
		9
	],
	"./pages/NYLanding/Utils/settings/objects/ag": [
		551,
		9
	],
	"./pages/NYLanding/Utils/settings/objects/ag.ts": [
		551,
		9
	],
	"./pages/NYLanding/Utils/settings/objects/crowd": [
		170,
		9
	],
	"./pages/NYLanding/Utils/settings/objects/crowd.ts": [
		170,
		9
	],
	"./pages/NYLanding/Utils/settings/objects/ed": [
		552,
		9
	],
	"./pages/NYLanding/Utils/settings/objects/ed.ts": [
		552,
		9
	],
	"./pages/NYLanding/Utils/settings/types": [
		1831,
		9,
		420
	],
	"./pages/NYLanding/Utils/settings/types.ts": [
		1831,
		9,
		420
	],
	"./pages/NYLanding/index": [
		892,
		9,
		1,
		8,
		6,
		9,
		19
	],
	"./pages/NYLanding/index.tsx": [
		892,
		9,
		1,
		8,
		6,
		9,
		19
	],
	"./pages/NewYear/Components/ExpertsQuotes/NyExpertsQuotes": [
		1744,
		9,
		4,
		268
	],
	"./pages/NewYear/Components/ExpertsQuotes/NyExpertsQuotes.scss": [
		2823,
		7,
		629
	],
	"./pages/NewYear/Components/ExpertsQuotes/NyExpertsQuotes.tsx": [
		1744,
		9,
		4,
		268
	],
	"./pages/NewYear/Components/Footer/NyFooter": [
		1745,
		9,
		229
	],
	"./pages/NewYear/Components/Footer/NyFooter.scss": [
		2824,
		7,
		630
	],
	"./pages/NewYear/Components/Footer/NyFooter.tsx": [
		1745,
		9,
		229
	],
	"./pages/NewYear/Components/Header/NyHeader": [
		1746,
		9,
		4,
		269
	],
	"./pages/NewYear/Components/Header/NyHeader.scss": [
		2825,
		7,
		631
	],
	"./pages/NewYear/Components/Header/NyHeader.tsx": [
		1746,
		9,
		4,
		269
	],
	"./pages/NewYear/Components/NyExpertsQuotes": [
		1832,
		9,
		4,
		230
	],
	"./pages/NewYear/Components/NyExpertsQuotes.tsx": [
		1832,
		9,
		4,
		230
	],
	"./pages/NewYear/Components/NyFooter": [
		1833,
		9,
		253
	],
	"./pages/NewYear/Components/NyFooter.tsx": [
		1833,
		9,
		253
	],
	"./pages/NewYear/Components/NyHeader": [
		1834,
		9,
		4,
		339
	],
	"./pages/NewYear/Components/NyHeader.tsx": [
		1834,
		9,
		4,
		339
	],
	"./pages/NewYear/Components/NyParticipantQuotes": [
		1835,
		9,
		4,
		261
	],
	"./pages/NewYear/Components/NyParticipantQuotes.tsx": [
		1835,
		9,
		4,
		261
	],
	"./pages/NewYear/Components/NyTitle": [
		1836,
		9,
		340
	],
	"./pages/NewYear/Components/NyTitle.tsx": [
		1836,
		9,
		340
	],
	"./pages/NewYear/Components/ParticipantQuotes/NyParticipantQuotes": [
		1747,
		9,
		4,
		242
	],
	"./pages/NewYear/Components/ParticipantQuotes/NyParticipantQuotes.scss": [
		2826,
		7,
		632
	],
	"./pages/NewYear/Components/ParticipantQuotes/NyParticipantQuotes.tsx": [
		1747,
		9,
		4,
		242
	],
	"./pages/NewYear/Components/Sphere/CitySphere": [
		1748,
		9,
		4,
		13,
		311
	],
	"./pages/NewYear/Components/Sphere/CitySphere.scss": [
		2827,
		7,
		633
	],
	"./pages/NewYear/Components/Sphere/CitySphere.tsx": [
		1748,
		9,
		4,
		13,
		311
	],
	"./pages/NewYear/Components/Sphere/CitySphereItem": [
		1749,
		9,
		4,
		13
	],
	"./pages/NewYear/Components/Sphere/CitySphereItem.tsx": [
		1749,
		9,
		4,
		13
	],
	"./pages/NewYear/Components/Sphere/_Ny.models": [
		1837,
		9,
		421
	],
	"./pages/NewYear/Components/Sphere/_Ny.models.ts": [
		1837,
		9,
		421
	],
	"./pages/NewYear/Components/Title/NyTitle": [
		1750,
		9,
		270
	],
	"./pages/NewYear/Components/Title/NyTitle.scss": [
		2828,
		7,
		634
	],
	"./pages/NewYear/Components/Title/NyTitle.tsx": [
		1750,
		9,
		270
	],
	"./pages/NewYear/Components/_Ny.models": [
		1838,
		9,
		422
	],
	"./pages/NewYear/Components/_Ny.models.ts": [
		1838,
		9,
		422
	],
	"./pages/NewYear/NewYear": [
		1839,
		9,
		4,
		13,
		178
	],
	"./pages/NewYear/NewYear.scss": [
		2841,
		7,
		635
	],
	"./pages/NewYear/NewYear.tsx": [
		1839,
		9,
		4,
		13,
		178
	],
	"./pages/NewYear/NewYearRulesPage": [
		630,
		9
	],
	"./pages/NewYear/NewYearRulesPage.tsx": [
		630,
		9
	],
	"./pages/NewYear/data": [
		1552,
		9,
		4
	],
	"./pages/NewYear/data.ts": [
		1552,
		9,
		4
	],
	"./pages/NewYear2023/Components/Buttons/Button": [
		306,
		9
	],
	"./pages/NewYear2023/Components/Buttons/Button.scss": [
		973,
		7
	],
	"./pages/NewYear2023/Components/Buttons/Button.tsx": [
		306,
		9
	],
	"./pages/NewYear2023/Components/Buttons/GameButton": [
		307,
		9
	],
	"./pages/NewYear2023/Components/Buttons/GameButton.tsx": [
		307,
		9
	],
	"./pages/NewYear2023/Components/Buttons/IconButton": [
		718,
		9
	],
	"./pages/NewYear2023/Components/Buttons/IconButton.tsx": [
		718,
		9
	],
	"./pages/NewYear2023/Components/ChristmasBulbs/ChristmasBulbs": [
		736,
		9
	],
	"./pages/NewYear2023/Components/ChristmasBulbs/ChristmasBulbs.helper": [
		737,
		9
	],
	"./pages/NewYear2023/Components/ChristmasBulbs/ChristmasBulbs.helper.tsx": [
		737,
		9
	],
	"./pages/NewYear2023/Components/ChristmasBulbs/ChristmasBulbs.scss": [
		1380,
		7
	],
	"./pages/NewYear2023/Components/ChristmasBulbs/ChristmasBulbs.tsx": [
		736,
		9
	],
	"./pages/NewYear2023/Components/Footer/Footer": [
		716,
		9
	],
	"./pages/NewYear2023/Components/Footer/Footer.scss": [
		1348,
		7
	],
	"./pages/NewYear2023/Components/Footer/Footer.tsx": [
		716,
		9
	],
	"./pages/NewYear2023/Components/Footer/Footer.types": [
		1840,
		9,
		423
	],
	"./pages/NewYear2023/Components/Footer/Footer.types.ts": [
		1840,
		9,
		423
	],
	"./pages/NewYear2023/Components/Garland/Garland": [
		720,
		9
	],
	"./pages/NewYear2023/Components/Garland/Garland.helper": [
		468,
		9
	],
	"./pages/NewYear2023/Components/Garland/Garland.helper.ts": [
		468,
		9
	],
	"./pages/NewYear2023/Components/Garland/Garland.scss": [
		1353,
		7
	],
	"./pages/NewYear2023/Components/Garland/Garland.tsx": [
		720,
		9
	],
	"./pages/NewYear2023/Components/Header/BurgerButton/BurgerButton": [
		719,
		9
	],
	"./pages/NewYear2023/Components/Header/BurgerButton/BurgerButton.scss": [
		1350,
		7
	],
	"./pages/NewYear2023/Components/Header/BurgerButton/BurgerButton.tsx": [
		719,
		9
	],
	"./pages/NewYear2023/Components/Header/CircleButton/CircleButton": [
		1841,
		9,
		312
	],
	"./pages/NewYear2023/Components/Header/CircleButton/CircleButton.scss": [
		2842,
		7,
		636
	],
	"./pages/NewYear2023/Components/Header/CircleButton/CircleButton.tsx": [
		1841,
		9,
		312
	],
	"./pages/NewYear2023/Components/Header/Header": [
		717,
		9
	],
	"./pages/NewYear2023/Components/Header/Header.scss": [
		1349,
		7
	],
	"./pages/NewYear2023/Components/Header/Header.tsx": [
		717,
		9
	],
	"./pages/NewYear2023/Components/Header/Header.types": [
		1842,
		9,
		424
	],
	"./pages/NewYear2023/Components/Header/Header.types.tsx": [
		1842,
		9,
		424
	],
	"./pages/NewYear2023/Components/Header/header.helpers": [
		796,
		9
	],
	"./pages/NewYear2023/Components/Header/header.helpers.ts": [
		796,
		9
	],
	"./pages/NewYear2023/Components/Interactive/Interactive": [
		461,
		9
	],
	"./pages/NewYear2023/Components/Interactive/Interactive.scss": [
		1352,
		7
	],
	"./pages/NewYear2023/Components/Interactive/Interactive.tsx": [
		461,
		9
	],
	"./pages/NewYear2023/Components/Interactive/Interactive.types": [
		1843,
		9,
		425
	],
	"./pages/NewYear2023/Components/Interactive/Interactive.types.ts": [
		1843,
		9,
		425
	],
	"./pages/NewYear2023/Components/MazeGame/Barriers/Barrier": [
		726,
		9
	],
	"./pages/NewYear2023/Components/MazeGame/Barriers/Barrier.tsx": [
		726,
		9
	],
	"./pages/NewYear2023/Components/MazeGame/Barriers/Barriers.scss": [
		1360,
		7
	],
	"./pages/NewYear2023/Components/MazeGame/Game/Game": [
		724,
		9
	],
	"./pages/NewYear2023/Components/MazeGame/Game/Game.helper": [
		725,
		9
	],
	"./pages/NewYear2023/Components/MazeGame/Game/Game.helper.ts": [
		725,
		9
	],
	"./pages/NewYear2023/Components/MazeGame/Game/Game.scss": [
		1359,
		7
	],
	"./pages/NewYear2023/Components/MazeGame/Game/Game.tsx": [
		724,
		9
	],
	"./pages/NewYear2023/Components/MazeGame/Game/Game.types": [
		42,
		9
	],
	"./pages/NewYear2023/Components/MazeGame/Game/Game.types.ts": [
		42,
		9
	],
	"./pages/NewYear2023/Components/MazeGame/MazeGame": [
		804,
		9
	],
	"./pages/NewYear2023/Components/MazeGame/MazeGame.constants": [
		462,
		9
	],
	"./pages/NewYear2023/Components/MazeGame/MazeGame.constants.ts": [
		462,
		9
	],
	"./pages/NewYear2023/Components/MazeGame/MazeGame.scss": [
		1362,
		7
	],
	"./pages/NewYear2023/Components/MazeGame/MazeGame.tsx": [
		804,
		9
	],
	"./pages/NewYear2023/Components/MazeGame/MazeGame.types": [
		1844,
		9,
		426
	],
	"./pages/NewYear2023/Components/MazeGame/MazeGame.types.tsx": [
		1844,
		9,
		426
	],
	"./pages/NewYear2023/Components/MemoryGame/Game/Game": [
		727,
		9
	],
	"./pages/NewYear2023/Components/MemoryGame/Game/Game.helper": [
		308,
		9
	],
	"./pages/NewYear2023/Components/MemoryGame/Game/Game.helper.ts": [
		308,
		9
	],
	"./pages/NewYear2023/Components/MemoryGame/Game/Game.scss": [
		1364,
		7
	],
	"./pages/NewYear2023/Components/MemoryGame/Game/Game.tsx": [
		727,
		9
	],
	"./pages/NewYear2023/Components/MemoryGame/MemoryGame": [
		816,
		9
	],
	"./pages/NewYear2023/Components/MemoryGame/MemoryGame.constants": [
		463,
		9
	],
	"./pages/NewYear2023/Components/MemoryGame/MemoryGame.constants.ts": [
		463,
		9
	],
	"./pages/NewYear2023/Components/MemoryGame/MemoryGame.scss": [
		1365,
		7
	],
	"./pages/NewYear2023/Components/MemoryGame/MemoryGame.tsx": [
		816,
		9
	],
	"./pages/NewYear2023/Components/MemoryGame/MemoryGame.types": [
		1845,
		9,
		427
	],
	"./pages/NewYear2023/Components/MemoryGame/MemoryGame.types.tsx": [
		1845,
		9,
		427
	],
	"./pages/NewYear2023/Components/Modal/Modal": [
		199,
		9
	],
	"./pages/NewYear2023/Components/Modal/Modal.scss": [
		1354,
		7
	],
	"./pages/NewYear2023/Components/Modal/Modal.tsx": [
		199,
		9
	],
	"./pages/NewYear2023/Components/Modal/Modal.types": [
		1846,
		9,
		428
	],
	"./pages/NewYear2023/Components/Modal/Modal.types.ts": [
		1846,
		9,
		428
	],
	"./pages/NewYear2023/Components/ModalFact/ModalFact": [
		722,
		9
	],
	"./pages/NewYear2023/Components/ModalFact/ModalFact.scss": [
		1356,
		7
	],
	"./pages/NewYear2023/Components/ModalFact/ModalFact.tsx": [
		722,
		9
	],
	"./pages/NewYear2023/Components/ModalFact/ModalFact.types": [
		1847,
		9,
		429
	],
	"./pages/NewYear2023/Components/ModalFact/ModalFact.types.ts": [
		1847,
		9,
		429
	],
	"./pages/NewYear2023/Components/ModalFactWin/ModalFactWin": [
		735,
		9
	],
	"./pages/NewYear2023/Components/ModalFactWin/ModalFactWin.scss": [
		1375,
		7
	],
	"./pages/NewYear2023/Components/ModalFactWin/ModalFactWin.tsx": [
		735,
		9
	],
	"./pages/NewYear2023/Components/ModalGame/ModalGame": [
		731,
		9
	],
	"./pages/NewYear2023/Components/ModalGame/ModalGame.scss": [
		1371,
		7
	],
	"./pages/NewYear2023/Components/ModalGame/ModalGame.tsx": [
		731,
		9
	],
	"./pages/NewYear2023/Components/ModalWelcome/ModalWelcome": [
		721,
		9
	],
	"./pages/NewYear2023/Components/ModalWelcome/ModalWelcome.scss": [
		1355,
		7
	],
	"./pages/NewYear2023/Components/ModalWelcome/ModalWelcome.tsx": [
		721,
		9
	],
	"./pages/NewYear2023/Components/PuzzleGame/Game/Game": [
		730,
		9
	],
	"./pages/NewYear2023/Components/PuzzleGame/Game/Game.scss": [
		1370,
		7
	],
	"./pages/NewYear2023/Components/PuzzleGame/Game/Game.tsx": [
		730,
		9
	],
	"./pages/NewYear2023/Components/PuzzleGame/PuzzleGame": [
		818,
		9
	],
	"./pages/NewYear2023/Components/PuzzleGame/PuzzleGame.constants": [
		464,
		9
	],
	"./pages/NewYear2023/Components/PuzzleGame/PuzzleGame.constants.ts": [
		464,
		9
	],
	"./pages/NewYear2023/Components/PuzzleGame/PuzzleGame.scss": [
		2859,
		7,
		637
	],
	"./pages/NewYear2023/Components/PuzzleGame/PuzzleGame.tsx": [
		818,
		9
	],
	"./pages/NewYear2023/Components/QuizGame/Game/Game": [
		733,
		9
	],
	"./pages/NewYear2023/Components/QuizGame/Game/Game.scss": [
		1372,
		7
	],
	"./pages/NewYear2023/Components/QuizGame/Game/Game.tsx": [
		733,
		9
	],
	"./pages/NewYear2023/Components/QuizGame/QuizGame": [
		732,
		9
	],
	"./pages/NewYear2023/Components/QuizGame/QuizGame.scss": [
		1373,
		7
	],
	"./pages/NewYear2023/Components/QuizGame/QuizGame.tsx": [
		732,
		9
	],
	"./pages/NewYear2023/Components/ScreenLoader/ScreenLoader": [
		734,
		9
	],
	"./pages/NewYear2023/Components/ScreenLoader/ScreenLoader.scss": [
		1374,
		7
	],
	"./pages/NewYear2023/Components/ScreenLoader/ScreenLoader.tsx": [
		734,
		9
	],
	"./pages/NewYear2023/Components/ScreenLoader/ScreenLoader.types": [
		1848,
		9,
		430
	],
	"./pages/NewYear2023/Components/ScreenLoader/ScreenLoader.types.ts": [
		1848,
		9,
		430
	],
	"./pages/NewYear2023/Components/ScreenStub/ScreenStub": [
		723,
		9
	],
	"./pages/NewYear2023/Components/ScreenStub/ScreenStub.scss": [
		1357,
		7
	],
	"./pages/NewYear2023/Components/ScreenStub/ScreenStub.tsx": [
		723,
		9
	],
	"./pages/NewYear2023/Components/SudokuGame/Game/Game": [
		729,
		9
	],
	"./pages/NewYear2023/Components/SudokuGame/Game/Game.helper": [
		405,
		9
	],
	"./pages/NewYear2023/Components/SudokuGame/Game/Game.helper.ts": [
		405,
		9
	],
	"./pages/NewYear2023/Components/SudokuGame/Game/Game.scss": [
		1368,
		7
	],
	"./pages/NewYear2023/Components/SudokuGame/Game/Game.tsx": [
		729,
		9
	],
	"./pages/NewYear2023/Components/SudokuGame/SudokuGame": [
		805,
		9
	],
	"./pages/NewYear2023/Components/SudokuGame/SudokuGame.constants": [
		218,
		9
	],
	"./pages/NewYear2023/Components/SudokuGame/SudokuGame.constants.ts": [
		218,
		9
	],
	"./pages/NewYear2023/Components/SudokuGame/SudokuGame.scss": [
		1369,
		7
	],
	"./pages/NewYear2023/Components/SudokuGame/SudokuGame.tsx": [
		805,
		9
	],
	"./pages/NewYear2023/Components/Timer/Timer": [
		237,
		9
	],
	"./pages/NewYear2023/Components/Timer/Timer.scss": [
		1361,
		7
	],
	"./pages/NewYear2023/Components/Timer/Timer.tsx": [
		237,
		9
	],
	"./pages/NewYear2023/Components/Tooltip/Tooltip": [
		532,
		9
	],
	"./pages/NewYear2023/Components/Tooltip/Tooltip.scss": [
		1358,
		7
	],
	"./pages/NewYear2023/Components/Tooltip/Tooltip.tsx": [
		532,
		9
	],
	"./pages/NewYear2023/Components/WishesBall/Ball/Ball": [
		728,
		9
	],
	"./pages/NewYear2023/Components/WishesBall/Ball/Ball.helper": [
		404,
		9
	],
	"./pages/NewYear2023/Components/WishesBall/Ball/Ball.helper.ts": [
		404,
		9
	],
	"./pages/NewYear2023/Components/WishesBall/Ball/Ball.scss": [
		1366,
		7
	],
	"./pages/NewYear2023/Components/WishesBall/Ball/Ball.tsx": [
		728,
		9
	],
	"./pages/NewYear2023/Components/WishesBall/Ball/Ball.types": [
		1849,
		9,
		431
	],
	"./pages/NewYear2023/Components/WishesBall/Ball/Ball.types.ts": [
		1849,
		9,
		431
	],
	"./pages/NewYear2023/Components/WishesBall/WishesBall": [
		817,
		9
	],
	"./pages/NewYear2023/Components/WishesBall/WishesBall.helper": [
		1850,
		9,
		432
	],
	"./pages/NewYear2023/Components/WishesBall/WishesBall.helper.ts": [
		1850,
		9,
		432
	],
	"./pages/NewYear2023/Components/WishesBall/WishesBall.scss": [
		1367,
		7
	],
	"./pages/NewYear2023/Components/WishesBall/WishesBall.tsx": [
		817,
		9
	],
	"./pages/NewYear2023/Components/WishesBall/WishesBall.types": [
		1851,
		9,
		433
	],
	"./pages/NewYear2023/Components/WishesBall/WishesBall.types.tsx": [
		1851,
		9,
		433
	],
	"./pages/NewYear2023/Components/Wrappers/GameWrapper/GameWrapper": [
		238,
		9
	],
	"./pages/NewYear2023/Components/Wrappers/GameWrapper/GameWrapper.scss": [
		1363,
		7
	],
	"./pages/NewYear2023/Components/Wrappers/GameWrapper/GameWrapper.tsx": [
		238,
		9
	],
	"./pages/NewYear2023/Components/Wrappers/GameWrapper/GameWrapper.types": [
		1852,
		9,
		434
	],
	"./pages/NewYear2023/Components/Wrappers/GameWrapper/GameWrapper.types.tsx": [
		1852,
		9,
		434
	],
	"./pages/NewYear2023/NewYear2023Root": [
		714,
		9
	],
	"./pages/NewYear2023/NewYear2023Root.scss": [
		1381,
		7
	],
	"./pages/NewYear2023/NewYear2023Root.tsx": [
		714,
		9
	],
	"./pages/NewYear2023/Pages/MainPage/MainPage": [
		715,
		9
	],
	"./pages/NewYear2023/Pages/MainPage/MainPage.scss": [
		1351,
		7
	],
	"./pages/NewYear2023/Pages/MainPage/MainPage.tsx": [
		715,
		9
	],
	"./pages/NewYear2023/Pages/TestPage/TestPage": [
		1853,
		9,
		313
	],
	"./pages/NewYear2023/Pages/TestPage/TestPage.scss": [
		2843,
		7,
		638
	],
	"./pages/NewYear2023/Pages/TestPage/TestPage.tsx": [
		1853,
		9,
		313
	],
	"./pages/NewYear2023/Services/newyear2023-service": [
		122,
		9
	],
	"./pages/NewYear2023/Services/newyear2023-service.ts": [
		122,
		9
	],
	"./pages/NewYear2023/Utils/constants": [
		29,
		9
	],
	"./pages/NewYear2023/Utils/constants.ts": [
		29,
		9
	],
	"./pages/NewYear2023/Utils/slidesObjects": [
		219,
		9
	],
	"./pages/NewYear2023/Utils/slidesObjects.ts": [
		219,
		9
	],
	"./pages/NewYear2023/hooks/useImagePreload": [
		168,
		9
	],
	"./pages/NewYear2023/hooks/useImagePreload.ts": [
		168,
		9
	],
	"./pages/NewYear2025/NewYear2025": [
		1957,
		9,
		2,
		0,
		3,
		5,
		108
	],
	"./pages/NewYear2025/NewYear2025.interface": [
		1854,
		9,
		435
	],
	"./pages/NewYear2025/NewYear2025.interface.ts": [
		1854,
		9,
		435
	],
	"./pages/NewYear2025/NewYear2025.scss": [
		2829,
		7,
		639
	],
	"./pages/NewYear2025/NewYear2025.tsx": [
		1957,
		9,
		2,
		0,
		3,
		5,
		108
	],
	"./pages/NewYear2025/components/Button/Button": [
		1584,
		9,
		314
	],
	"./pages/NewYear2025/components/Button/Button.module.scss": [
		2744,
		7,
		703
	],
	"./pages/NewYear2025/components/Button/Button.tsx": [
		1584,
		9,
		314
	],
	"./pages/NewYear2025/components/Footer/Footer": [
		1719,
		9,
		254
	],
	"./pages/NewYear2025/components/Footer/Footer.scss": [
		2801,
		7,
		640
	],
	"./pages/NewYear2025/components/Footer/Footer.tsx": [
		1719,
		9,
		254
	],
	"./pages/NewYear2025/components/Games/BuildSnowman": [
		868,
		9,
		42
	],
	"./pages/NewYear2025/components/Games/BuildSnowman/": [
		868,
		9,
		42
	],
	"./pages/NewYear2025/components/Games/BuildSnowman/BuildSnowman.scss": [
		2749,
		7,
		641
	],
	"./pages/NewYear2025/components/Games/BuildSnowman/SnowmanConstructor/SnowmanConstructor": [
		1572,
		9,
		271
	],
	"./pages/NewYear2025/components/Games/BuildSnowman/SnowmanConstructor/SnowmanConstructor.scss": [
		2735,
		7,
		642
	],
	"./pages/NewYear2025/components/Games/BuildSnowman/SnowmanConstructor/SnowmanConstructor.tsx": [
		1572,
		9,
		271
	],
	"./pages/NewYear2025/components/Games/BuildSnowman/WordsBoard/WordsBoard": [
		1573,
		9,
		272
	],
	"./pages/NewYear2025/components/Games/BuildSnowman/WordsBoard/WordsBoard.scss": [
		2736,
		7,
		643
	],
	"./pages/NewYear2025/components/Games/BuildSnowman/WordsBoard/WordsBoard.tsx": [
		1573,
		9,
		272
	],
	"./pages/NewYear2025/components/Games/BuildSnowman/adaptive.scss": [
		2860,
		7,
		644
	],
	"./pages/NewYear2025/components/Games/BuildSnowman/index": [
		868,
		9,
		42
	],
	"./pages/NewYear2025/components/Games/BuildSnowman/index.tsx": [
		868,
		9,
		42
	],
	"./pages/NewYear2025/components/Games/BuildSnowman/snowman.constans": [
		342,
		9
	],
	"./pages/NewYear2025/components/Games/BuildSnowman/snowman.constans.ts": [
		342,
		9
	],
	"./pages/NewYear2025/components/Games/BuildSnowman/snowman.helpers": [
		484,
		9
	],
	"./pages/NewYear2025/components/Games/BuildSnowman/snowman.helpers.ts": [
		484,
		9
	],
	"./pages/NewYear2025/components/Games/BuildSnowman/snowman.images": [
		1604,
		9,
		194
	],
	"./pages/NewYear2025/components/Games/BuildSnowman/snowman.images.ts": [
		1604,
		9,
		194
	],
	"./pages/NewYear2025/components/Games/BuildSnowman/snowman.types": [
		1855,
		9,
		436
	],
	"./pages/NewYear2025/components/Games/BuildSnowman/snowman.types.ts": [
		1855,
		9,
		436
	],
	"./pages/NewYear2025/components/Games/Controller/Controller": [
		1535,
		9,
		243
	],
	"./pages/NewYear2025/components/Games/Controller/Controller.scss": [
		2722,
		7,
		645
	],
	"./pages/NewYear2025/components/Games/Controller/Controller.tsx": [
		1535,
		9,
		243
	],
	"./pages/NewYear2025/components/Games/Controller/ControllerCenter": [
		1541,
		9,
		273
	],
	"./pages/NewYear2025/components/Games/Controller/ControllerCenter.tsx": [
		1541,
		9,
		273
	],
	"./pages/NewYear2025/components/Games/Controller/controller.constants": [
		1527,
		9,
		437
	],
	"./pages/NewYear2025/components/Games/Controller/controller.constants.ts": [
		1527,
		9,
		437
	],
	"./pages/NewYear2025/components/Games/Controller/controller.helpers": [
		1528,
		9,
		438
	],
	"./pages/NewYear2025/components/Games/Controller/controller.helpers.ts": [
		1528,
		9,
		438
	],
	"./pages/NewYear2025/components/Games/Controller/controller.hooks": [
		1536,
		9,
		315
	],
	"./pages/NewYear2025/components/Games/Controller/controller.hooks.ts": [
		1536,
		9,
		315
	],
	"./pages/NewYear2025/components/Games/Controller/controller.images": [
		1613,
		9,
		262
	],
	"./pages/NewYear2025/components/Games/Controller/controller.images.ts": [
		1613,
		9,
		262
	],
	"./pages/NewYear2025/components/Games/ElectronicHouse/ElectronicHouse": [
		1601,
		9,
		176
	],
	"./pages/NewYear2025/components/Games/ElectronicHouse/ElectronicHouse.module.scss": [
		2719,
		7,
		704
	],
	"./pages/NewYear2025/components/Games/ElectronicHouse/ElectronicHouse.tsx": [
		1601,
		9,
		176
	],
	"./pages/NewYear2025/components/Games/ElectronicHouse/StaticObjects": [
		1578,
		9,
		231
	],
	"./pages/NewYear2025/components/Games/ElectronicHouse/StaticObjects.tsx": [
		1578,
		9,
		231
	],
	"./pages/NewYear2025/components/Games/ElectronicHouse/Timer": [
		1579,
		9,
		274
	],
	"./pages/NewYear2025/components/Games/ElectronicHouse/Timer.tsx": [
		1579,
		9,
		274
	],
	"./pages/NewYear2025/components/Games/ElectronicHouse/constants": [
		1577,
		9,
		439
	],
	"./pages/NewYear2025/components/Games/ElectronicHouse/constants.ts": [
		1577,
		9,
		439
	],
	"./pages/NewYear2025/components/Games/ElectronicHouse/electronicHouse.images": [
		1600,
		9,
		187
	],
	"./pages/NewYear2025/components/Games/ElectronicHouse/electronicHouse.images.ts": [
		1600,
		9,
		187
	],
	"./pages/NewYear2025/components/Games/ElectronicHouse/hooks": [
		1533,
		9,
		440
	],
	"./pages/NewYear2025/components/Games/ElectronicHouse/hooks.ts": [
		1533,
		9,
		440
	],
	"./pages/NewYear2025/components/Games/FindPairs": [
		865,
		9,
		52
	],
	"./pages/NewYear2025/components/Games/FindPairs/": [
		865,
		9,
		52
	],
	"./pages/NewYear2025/components/Games/FindPairs/FindPairs.constants": [
		483,
		9
	],
	"./pages/NewYear2025/components/Games/FindPairs/FindPairs.constants.ts": [
		483,
		9
	],
	"./pages/NewYear2025/components/Games/FindPairs/FindPairs.types": [
		1856,
		9,
		441
	],
	"./pages/NewYear2025/components/Games/FindPairs/FindPairs.types.tsx": [
		1856,
		9,
		441
	],
	"./pages/NewYear2025/components/Games/FindPairs/Game/Game": [
		1556,
		9,
		263
	],
	"./pages/NewYear2025/components/Games/FindPairs/Game/Game.helper": [
		553,
		9
	],
	"./pages/NewYear2025/components/Games/FindPairs/Game/Game.helper.ts": [
		553,
		9
	],
	"./pages/NewYear2025/components/Games/FindPairs/Game/Game.tsx": [
		1556,
		9,
		263
	],
	"./pages/NewYear2025/components/Games/FindPairs/Game/Timer": [
		1543,
		9,
		341
	],
	"./pages/NewYear2025/components/Games/FindPairs/Game/Timer.tsx": [
		1543,
		9,
		341
	],
	"./pages/NewYear2025/components/Games/FindPairs/Game/adaptive.scss": [
		2861,
		7,
		646
	],
	"./pages/NewYear2025/components/Games/FindPairs/Game/styles.module.scss": [
		2726,
		7,
		705
	],
	"./pages/NewYear2025/components/Games/FindPairs/findsPairs.images": [
		1605,
		9,
		255
	],
	"./pages/NewYear2025/components/Games/FindPairs/findsPairs.images.ts": [
		1605,
		9,
		255
	],
	"./pages/NewYear2025/components/Games/FindPairs/index": [
		865,
		9,
		52
	],
	"./pages/NewYear2025/components/Games/FindPairs/index.tsx": [
		865,
		9,
		52
	],
	"./pages/NewYear2025/components/Games/GameModal/GameModal": [
		1611,
		9,
		169
	],
	"./pages/NewYear2025/components/Games/GameModal/GameModal.scss": [
		2760,
		7,
		647
	],
	"./pages/NewYear2025/components/Games/GameModal/GameModal.tsx": [
		1611,
		9,
		169
	],
	"./pages/NewYear2025/components/Games/GameModal/gameModal.constants": [
		1526,
		9,
		442
	],
	"./pages/NewYear2025/components/Games/GameModal/gameModal.constants.ts": [
		1526,
		9,
		442
	],
	"./pages/NewYear2025/components/Games/GameModal/gameModal.hooks": [
		1594,
		9,
		342
	],
	"./pages/NewYear2025/components/Games/GameModal/gameModal.hooks.tsx": [
		1594,
		9,
		342
	],
	"./pages/NewYear2025/components/Games/GameModal/gameModal.images": [
		1553,
		9,
		172
	],
	"./pages/NewYear2025/components/Games/GameModal/gameModal.images.ts": [
		1553,
		9,
		172
	],
	"./pages/NewYear2025/components/Games/GameScreen/GameScreen": [
		1644,
		9,
		2,
		3,
		5,
		7,
		112
	],
	"./pages/NewYear2025/components/Games/GameScreen/GameScreen.scss": [
		2779,
		7,
		648
	],
	"./pages/NewYear2025/components/Games/GameScreen/GameScreen.tsx": [
		1644,
		9,
		2,
		3,
		5,
		7,
		112
	],
	"./pages/NewYear2025/components/Games/GameScreen/GameScreenHeader/GameScreenHeader": [
		1610,
		9,
		244
	],
	"./pages/NewYear2025/components/Games/GameScreen/GameScreenHeader/GameScreenHeader.scss": [
		2759,
		7,
		649
	],
	"./pages/NewYear2025/components/Games/GameScreen/GameScreenHeader/GameScreenHeader.tsx": [
		1610,
		9,
		244
	],
	"./pages/NewYear2025/components/Games/GameScreen/gameScreen.constants": [
		1614,
		9,
		2,
		3,
		5,
		7,
		113
	],
	"./pages/NewYear2025/components/Games/GameScreen/gameScreen.constants.ts": [
		1614,
		9,
		2,
		3,
		5,
		7,
		113
	],
	"./pages/NewYear2025/components/Games/GameScreen/gameScreen.images": [
		1612,
		9,
		224
	],
	"./pages/NewYear2025/components/Games/GameScreen/gameScreen.images.ts": [
		1612,
		9,
		224
	],
	"./pages/NewYear2025/components/Games/GiftCards": [
		867,
		9,
		10,
		14,
		20
	],
	"./pages/NewYear2025/components/Games/GiftCards/": [
		867,
		9,
		10,
		14,
		20
	],
	"./pages/NewYear2025/components/Games/GiftCards/ChangeCongratulationsButton/ChangeCongratulationsButton": [
		1569,
		9,
		225
	],
	"./pages/NewYear2025/components/Games/GiftCards/ChangeCongratulationsButton/ChangeCongratulationsButton.tsx": [
		1569,
		9,
		225
	],
	"./pages/NewYear2025/components/Games/GiftCards/CloseButton/CloseButton": [
		1563,
		9,
		256
	],
	"./pages/NewYear2025/components/Games/GiftCards/CloseButton/CloseButton.scss": [
		2728,
		7,
		650
	],
	"./pages/NewYear2025/components/Games/GiftCards/CloseButton/CloseButton.tsx": [
		1563,
		9,
		256
	],
	"./pages/NewYear2025/components/Games/GiftCards/ControlButton/ControlButton": [
		1518,
		9,
		316
	],
	"./pages/NewYear2025/components/Games/GiftCards/ControlButton/ControlButton.scss": [
		2720,
		7,
		651
	],
	"./pages/NewYear2025/components/Games/GiftCards/ControlButton/ControlButton.tsx": [
		1518,
		9,
		316
	],
	"./pages/NewYear2025/components/Games/GiftCards/GiftCardPreview/GiftCardPreview": [
		1566,
		9,
		179
	],
	"./pages/NewYear2025/components/Games/GiftCards/GiftCardPreview/GiftCardPreview.scss": [
		2731,
		7,
		652
	],
	"./pages/NewYear2025/components/Games/GiftCards/GiftCardPreview/GiftCardPreview.tsx": [
		1566,
		9,
		179
	],
	"./pages/NewYear2025/components/Games/GiftCards/GiftCards.constant": [
		1512,
		9,
		275
	],
	"./pages/NewYear2025/components/Games/GiftCards/GiftCards.constant.tsx": [
		1512,
		9,
		275
	],
	"./pages/NewYear2025/components/Games/GiftCards/GiftCards.helpers": [
		1570,
		9,
		264
	],
	"./pages/NewYear2025/components/Games/GiftCards/GiftCards.helpers.ts": [
		1570,
		9,
		264
	],
	"./pages/NewYear2025/components/Games/GiftCards/GiftCards.scss": [
		2747,
		7,
		653
	],
	"./pages/NewYear2025/components/Games/GiftCards/GiftCards.types": [
		1857,
		9,
		443
	],
	"./pages/NewYear2025/components/Games/GiftCards/GiftCards.types.ts": [
		1857,
		9,
		443
	],
	"./pages/NewYear2025/components/Games/GiftCards/GiftCardsConstructor/GiftCardsConstructor": [
		1587,
		9,
		10,
		14,
		547
	],
	"./pages/NewYear2025/components/Games/GiftCards/GiftCardsConstructor/GiftCardsConstructor.tsx": [
		1587,
		9,
		10,
		14,
		547
	],
	"./pages/NewYear2025/components/Games/GiftCards/GiftCardsSlider/GiftCardEntourageSlider/GiftCardEntourageSlide": [
		1544,
		9,
		175
	],
	"./pages/NewYear2025/components/Games/GiftCards/GiftCardsSlider/GiftCardEntourageSlider/GiftCardEntourageSlide.scss": [
		2723,
		7,
		654
	],
	"./pages/NewYear2025/components/Games/GiftCards/GiftCardsSlider/GiftCardEntourageSlider/GiftCardEntourageSlide.tsx": [
		1544,
		9,
		175
	],
	"./pages/NewYear2025/components/Games/GiftCards/GiftCardsSlider/GiftCardEntourageSlider/GiftCardEntourageSlider": [
		1568,
		9,
		171
	],
	"./pages/NewYear2025/components/Games/GiftCards/GiftCardsSlider/GiftCardEntourageSlider/GiftCardEntourageSlider.tsx": [
		1568,
		9,
		171
	],
	"./pages/NewYear2025/components/Games/GiftCards/GiftCardsSlider/GiftCardEntourageSlider/GiftCardsSlider.scss": [
		2733,
		7,
		655
	],
	"./pages/NewYear2025/components/Games/GiftCards/GiftCardsSlider/GiftCardNavigationButtons/GiftCardNavigationButtons": [
		1520,
		9,
		317
	],
	"./pages/NewYear2025/components/Games/GiftCards/GiftCardsSlider/GiftCardNavigationButtons/GiftCardNavigationButtons.scss": [
		2716,
		7,
		656
	],
	"./pages/NewYear2025/components/Games/GiftCards/GiftCardsSlider/GiftCardNavigationButtons/GiftCardNavigationButtons.tsx": [
		1520,
		9,
		317
	],
	"./pages/NewYear2025/components/Games/GiftCards/GiftCardsSlider/GiftCardPersonSlider/GiftCardPersonSlide": [
		1567,
		9,
		184
	],
	"./pages/NewYear2025/components/Games/GiftCards/GiftCardsSlider/GiftCardPersonSlider/GiftCardPersonSlide.scss": [
		2732,
		7,
		657
	],
	"./pages/NewYear2025/components/Games/GiftCards/GiftCardsSlider/GiftCardPersonSlider/GiftCardPersonSlide.tsx": [
		1567,
		9,
		184
	],
	"./pages/NewYear2025/components/Games/GiftCards/GiftCardsSlider/GiftCardPersonSlider/GiftCardPersonSlider": [
		1588,
		9,
		10,
		548
	],
	"./pages/NewYear2025/components/Games/GiftCards/GiftCardsSlider/GiftCardPersonSlider/GiftCardPersonSlider.tsx": [
		1588,
		9,
		10,
		548
	],
	"./pages/NewYear2025/components/Games/GiftCards/GiftCardsSlider/GiftCardPersonSlider/GiftCardsSlider.scss": [
		2748,
		7,
		658
	],
	"./pages/NewYear2025/components/Games/GiftCards/GiftCardsSlider/SlideWrapper": [
		1521,
		9,
		318
	],
	"./pages/NewYear2025/components/Games/GiftCards/GiftCardsSlider/SlideWrapper.scss": [
		2717,
		7,
		659
	],
	"./pages/NewYear2025/components/Games/GiftCards/GiftCardsSlider/SlideWrapper.tsx": [
		1521,
		9,
		318
	],
	"./pages/NewYear2025/components/Games/GiftCards/GiftCardsSlider/slideSizes.scss": [
		2862,
		7,
		660
	],
	"./pages/NewYear2025/components/Games/GiftCards/Loader/Loader": [
		1571,
		9,
		319
	],
	"./pages/NewYear2025/components/Games/GiftCards/Loader/Loader.scss": [
		2734,
		7,
		661
	],
	"./pages/NewYear2025/components/Games/GiftCards/Loader/Loader.tsx": [
		1571,
		9,
		319
	],
	"./pages/NewYear2025/components/Games/GiftCards/Progress/Progress": [
		1564,
		9,
		232
	],
	"./pages/NewYear2025/components/Games/GiftCards/Progress/Progress.scss": [
		2729,
		7,
		662
	],
	"./pages/NewYear2025/components/Games/GiftCards/Progress/Progress.tsx": [
		1564,
		9,
		232
	],
	"./pages/NewYear2025/components/Games/GiftCards/ShareButton/ShareButton": [
		1565,
		9,
		257
	],
	"./pages/NewYear2025/components/Games/GiftCards/ShareButton/ShareButton.scss": [
		2730,
		7,
		663
	],
	"./pages/NewYear2025/components/Games/GiftCards/ShareButton/ShareButton.tsx": [
		1565,
		9,
		257
	],
	"./pages/NewYear2025/components/Games/GiftCards/common.scss": [
		2863,
		7,
		664
	],
	"./pages/NewYear2025/components/Games/GiftCards/giftCards.images": [
		1598,
		9,
		156
	],
	"./pages/NewYear2025/components/Games/GiftCards/giftCards.images.ts": [
		1598,
		9,
		156
	],
	"./pages/NewYear2025/components/Games/GiftCards/index": [
		867,
		9,
		10,
		14,
		20
	],
	"./pages/NewYear2025/components/Games/GiftCards/index.tsx": [
		867,
		9,
		10,
		14,
		20
	],
	"./pages/NewYear2025/components/Games/Maze/Maze": [
		1596,
		9,
		204
	],
	"./pages/NewYear2025/components/Games/Maze/Maze.scss": [
		2746,
		7,
		665
	],
	"./pages/NewYear2025/components/Games/Maze/Maze.tsx": [
		1596,
		9,
		204
	],
	"./pages/NewYear2025/components/Games/Maze/MazeCharacter": [
		1555,
		9,
		320
	],
	"./pages/NewYear2025/components/Games/Maze/MazeCharacter.tsx": [
		1555,
		9,
		320
	],
	"./pages/NewYear2025/components/Games/Maze/MazeTimer": [
		1554,
		9,
		343
	],
	"./pages/NewYear2025/components/Games/Maze/MazeTimer.tsx": [
		1554,
		9,
		343
	],
	"./pages/NewYear2025/components/Games/Maze/maze.constants": [
		120,
		9
	],
	"./pages/NewYear2025/components/Games/Maze/maze.constants.ts": [
		120,
		9
	],
	"./pages/NewYear2025/components/Games/Maze/maze.helpers": [
		481,
		9
	],
	"./pages/NewYear2025/components/Games/Maze/maze.helpers.ts": [
		481,
		9
	],
	"./pages/NewYear2025/components/Games/Maze/maze.hooks": [
		1542,
		9,
		444
	],
	"./pages/NewYear2025/components/Games/Maze/maze.hooks.ts": [
		1542,
		9,
		444
	],
	"./pages/NewYear2025/components/Games/Maze/maze.images": [
		1595,
		9,
		276
	],
	"./pages/NewYear2025/components/Games/Maze/maze.images.ts": [
		1595,
		9,
		276
	],
	"./pages/NewYear2025/components/Games/NgTree/NgTree": [
		1597,
		9,
		5,
		53,
		170
	],
	"./pages/NewYear2025/components/Games/NgTree/NgTree.scss": [
		2750,
		7,
		666
	],
	"./pages/NewYear2025/components/Games/NgTree/NgTree.tsx": [
		1597,
		9,
		5,
		53,
		170
	],
	"./pages/NewYear2025/components/Games/NgTree/Timer/Timer": [
		1576,
		9,
		277
	],
	"./pages/NewYear2025/components/Games/NgTree/Timer/Timer.scss": [
		2737,
		7,
		667
	],
	"./pages/NewYear2025/components/Games/NgTree/Timer/Timer.tsx": [
		1576,
		9,
		277
	],
	"./pages/NewYear2025/components/Games/NgTree/useCollectingObjects": [
		1575,
		9,
		5,
		173
	],
	"./pages/NewYear2025/components/Games/NgTree/useCollectingObjects.tsx": [
		1575,
		9,
		5,
		173
	],
	"./pages/NewYear2025/components/Games/QuizGame/Answer/Answer": [
		1545,
		9,
		258
	],
	"./pages/NewYear2025/components/Games/QuizGame/Answer/Answer.module.scss": [
		2724,
		7,
		706
	],
	"./pages/NewYear2025/components/Games/QuizGame/Answer/Answer.tsx": [
		1545,
		9,
		258
	],
	"./pages/NewYear2025/components/Games/QuizGame/Question/Question": [
		1581,
		9,
		220
	],
	"./pages/NewYear2025/components/Games/QuizGame/Question/Question.module.scss": [
		2738,
		7,
		707
	],
	"./pages/NewYear2025/components/Games/QuizGame/Question/Question.tsx": [
		1581,
		9,
		220
	],
	"./pages/NewYear2025/components/Games/QuizGame/QuizGame": [
		1602,
		9,
		185
	],
	"./pages/NewYear2025/components/Games/QuizGame/QuizGame.module.scss": [
		2752,
		7,
		708
	],
	"./pages/NewYear2025/components/Games/QuizGame/QuizGame.tsx": [
		1602,
		9,
		185
	],
	"./pages/NewYear2025/components/Games/QuizGame/StaticObjects/StaticObjects": [
		1583,
		9,
		221
	],
	"./pages/NewYear2025/components/Games/QuizGame/StaticObjects/StaticObjects.module.scss": [
		2739,
		7,
		709
	],
	"./pages/NewYear2025/components/Games/QuizGame/StaticObjects/StaticObjects.tsx": [
		1583,
		9,
		221
	],
	"./pages/NewYear2025/components/Games/QuizGame/Timer/Timer": [
		1582,
		9,
		344
	],
	"./pages/NewYear2025/components/Games/QuizGame/Timer/Timer.tsx": [
		1582,
		9,
		344
	],
	"./pages/NewYear2025/components/Games/QuizGame/constants": [
		1523,
		9,
		445
	],
	"./pages/NewYear2025/components/Games/QuizGame/constants.ts": [
		1523,
		9,
		445
	],
	"./pages/NewYear2025/components/Games/QuizGame/helpers": [
		1534,
		9,
		446
	],
	"./pages/NewYear2025/components/Games/QuizGame/helpers.ts": [
		1534,
		9,
		446
	],
	"./pages/NewYear2025/components/Games/QuizGame/questions": [
		1580,
		9,
		447
	],
	"./pages/NewYear2025/components/Games/QuizGame/questions.ts": [
		1580,
		9,
		447
	],
	"./pages/NewYear2025/components/Games/QuizGame/quizGame.images": [
		1603,
		9,
		214
	],
	"./pages/NewYear2025/components/Games/QuizGame/quizGame.images.ts": [
		1603,
		9,
		214
	],
	"./pages/NewYear2025/components/Games/Steeplechase": [
		866,
		9,
		2,
		17,
		74
	],
	"./pages/NewYear2025/components/Games/Steeplechase/": [
		866,
		9,
		2,
		17,
		74
	],
	"./pages/NewYear2025/components/Games/Steeplechase/Game/Background/Background": [
		1560,
		9,
		321
	],
	"./pages/NewYear2025/components/Games/Steeplechase/Game/Background/Background.module.scss": [
		2727,
		7,
		710
	],
	"./pages/NewYear2025/components/Games/Steeplechase/Game/Background/Background.tsx": [
		1560,
		9,
		321
	],
	"./pages/NewYear2025/components/Games/Steeplechase/Game/Character/Character": [
		1557,
		9,
		2,
		265
	],
	"./pages/NewYear2025/components/Games/Steeplechase/Game/Character/Character.tsx": [
		1557,
		9,
		2,
		265
	],
	"./pages/NewYear2025/components/Games/Steeplechase/Game/Game": [
		1586,
		9,
		2,
		17,
		549
	],
	"./pages/NewYear2025/components/Games/Steeplechase/Game/Game.module.scss": [
		2710,
		7,
		556
	],
	"./pages/NewYear2025/components/Games/Steeplechase/Game/Game.tsx": [
		1586,
		9,
		2,
		17,
		549
	],
	"./pages/NewYear2025/components/Games/Steeplechase/Game/Gift/Gift": [
		1559,
		9,
		259
	],
	"./pages/NewYear2025/components/Games/Steeplechase/Game/Gift/Gift.tsx": [
		1559,
		9,
		259
	],
	"./pages/NewYear2025/components/Games/Steeplechase/Game/Obstacle/Obstacle": [
		1558,
		9,
		245
	],
	"./pages/NewYear2025/components/Games/Steeplechase/Game/Obstacle/Obstacle.tsx": [
		1558,
		9,
		245
	],
	"./pages/NewYear2025/components/Games/Steeplechase/Game/Score/Score": [
		1561,
		9,
		278
	],
	"./pages/NewYear2025/components/Games/Steeplechase/Game/Score/Score.tsx": [
		1561,
		9,
		278
	],
	"./pages/NewYear2025/components/Games/Steeplechase/Steeplechase.constants": [
		416,
		9
	],
	"./pages/NewYear2025/components/Games/Steeplechase/Steeplechase.constants.ts": [
		416,
		9
	],
	"./pages/NewYear2025/components/Games/Steeplechase/index": [
		866,
		9,
		2,
		17,
		74
	],
	"./pages/NewYear2025/components/Games/Steeplechase/index.tsx": [
		866,
		9,
		2,
		17,
		74
	],
	"./pages/NewYear2025/components/Games/Steeplechase/steeplechase.images": [
		1599,
		9,
		215
	],
	"./pages/NewYear2025/components/Games/Steeplechase/steeplechase.images.ts": [
		1599,
		9,
		215
	],
	"./pages/NewYear2025/components/Games/Steeplechase/steeplechase.utils": [
		1562,
		9,
		448
	],
	"./pages/NewYear2025/components/Games/Steeplechase/steeplechase.utils.ts": [
		1562,
		9,
		448
	],
	"./pages/NewYear2025/components/Header/ButtonSection": [
		876,
		9,
		68
	],
	"./pages/NewYear2025/components/Header/ButtonSection/": [
		876,
		9,
		68
	],
	"./pages/NewYear2025/components/Header/ButtonSection/index": [
		876,
		9,
		68
	],
	"./pages/NewYear2025/components/Header/ButtonSection/index.tsx": [
		876,
		9,
		68
	],
	"./pages/NewYear2025/components/Header/ButtonSection/styles.module.scss": [
		2772,
		7,
		711
	],
	"./pages/NewYear2025/components/Header/Buttons/IconButton": [
		858,
		9,
		69
	],
	"./pages/NewYear2025/components/Header/Buttons/IconButton/": [
		858,
		9,
		69
	],
	"./pages/NewYear2025/components/Header/Buttons/IconButton/index": [
		858,
		9,
		69
	],
	"./pages/NewYear2025/components/Header/Buttons/IconButton/index.tsx": [
		858,
		9,
		69
	],
	"./pages/NewYear2025/components/Header/Buttons/IconButton/styles.module.scss": [
		2715,
		7,
		712
	],
	"./pages/NewYear2025/components/Header/Buttons/LandingNavigationButton/LandingNavigationButton": [
		1687,
		9,
		322
	],
	"./pages/NewYear2025/components/Header/Buttons/LandingNavigationButton/LandingNavigationButton.scss": [
		2774,
		7,
		668
	],
	"./pages/NewYear2025/components/Header/Buttons/LandingNavigationButton/LandingNavigationButton.tsx": [
		1687,
		9,
		322
	],
	"./pages/NewYear2025/components/Header/Buttons/RedirectToProjectButton/RedirectToProjectButton": [
		1715,
		9,
		35,
		550
	],
	"./pages/NewYear2025/components/Header/Buttons/RedirectToProjectButton/RedirectToProjectButton.scss": [
		2799,
		7,
		669
	],
	"./pages/NewYear2025/components/Header/Buttons/RedirectToProjectButton/RedirectToProjectButton.tsx": [
		1715,
		9,
		35,
		550
	],
	"./pages/NewYear2025/components/Header/Buttons/SoundButton/SoundButton": [
		1690,
		9,
		246
	],
	"./pages/NewYear2025/components/Header/Buttons/SoundButton/SoundButton.scss": [
		2778,
		7,
		670
	],
	"./pages/NewYear2025/components/Header/Buttons/SoundButton/SoundButton.tsx": [
		1690,
		9,
		246
	],
	"./pages/NewYear2025/components/Header/Buttons/ToggleFullScreenButton/ToggleFullScreenButton": [
		1688,
		9,
		323
	],
	"./pages/NewYear2025/components/Header/Buttons/ToggleFullScreenButton/ToggleFullScreenButton.scss": [
		2776,
		7,
		671
	],
	"./pages/NewYear2025/components/Header/Buttons/ToggleFullScreenButton/ToggleFullScreenButton.tsx": [
		1688,
		9,
		323
	],
	"./pages/NewYear2025/components/Header/Counter/Counter": [
		1686,
		9,
		324
	],
	"./pages/NewYear2025/components/Header/Counter/Counter.scss": [
		2773,
		7,
		672
	],
	"./pages/NewYear2025/components/Header/Counter/Counter.tsx": [
		1686,
		9,
		324
	],
	"./pages/NewYear2025/components/Header/Header": [
		1718,
		9,
		35,
		174
	],
	"./pages/NewYear2025/components/Header/Header.scss": [
		2800,
		7,
		673
	],
	"./pages/NewYear2025/components/Header/Header.tsx": [
		1718,
		9,
		35,
		174
	],
	"./pages/NewYear2025/components/Header/ProjectsPopup/ProjectsPopup": [
		1689,
		9,
		208
	],
	"./pages/NewYear2025/components/Header/ProjectsPopup/ProjectsPopup.scss": [
		2777,
		7,
		674
	],
	"./pages/NewYear2025/components/Header/ProjectsPopup/ProjectsPopup.tsx": [
		1689,
		9,
		208
	],
	"./pages/NewYear2025/components/HeaderTooltip/HeaderTooltip": [
		1609,
		9,
		325
	],
	"./pages/NewYear2025/components/HeaderTooltip/HeaderTooltip.scss": [
		2775,
		7,
		675
	],
	"./pages/NewYear2025/components/HeaderTooltip/HeaderTooltip.tsx": [
		1609,
		9,
		325
	],
	"./pages/NewYear2025/components/Objects/Bench/Bench": [
		1505,
		9,
		209
	],
	"./pages/NewYear2025/components/Objects/Bench/Bench.tsx": [
		1505,
		9,
		209
	],
	"./pages/NewYear2025/components/Objects/Bird/Bird": [
		1503,
		9,
		210
	],
	"./pages/NewYear2025/components/Objects/Bird/Bird.tsx": [
		1503,
		9,
		210
	],
	"./pages/NewYear2025/components/Objects/Bush/Bush": [
		1499,
		9,
		195
	],
	"./pages/NewYear2025/components/Objects/Bush/Bush.tsx": [
		1499,
		9,
		195
	],
	"./pages/NewYear2025/components/Objects/CollectedObject/CollectedObject": [
		1504,
		9,
		0,
		216
	],
	"./pages/NewYear2025/components/Objects/CollectedObject/CollectedObject.tsx": [
		1504,
		9,
		0,
		216
	],
	"./pages/NewYear2025/components/Objects/Garland/Garland": [
		1502,
		9,
		191
	],
	"./pages/NewYear2025/components/Objects/Garland/Garland.constants": [
		1507,
		9,
		198
	],
	"./pages/NewYear2025/components/Objects/Garland/Garland.constants.ts": [
		1507,
		9,
		198
	],
	"./pages/NewYear2025/components/Objects/Garland/Garland.tsx": [
		1502,
		9,
		191
	],
	"./pages/NewYear2025/components/Objects/GraphicObject/GraphicObject": [
		1491,
		9,
		226
	],
	"./pages/NewYear2025/components/Objects/GraphicObject/GraphicObject.scss": [
		2704,
		7,
		676
	],
	"./pages/NewYear2025/components/Objects/GraphicObject/GraphicObject.tsx": [
		1491,
		9,
		226
	],
	"./pages/NewYear2025/components/Objects/Interactive/Interactive": [
		1506,
		9,
		212
	],
	"./pages/NewYear2025/components/Objects/Interactive/Interactive.scss": [
		2706,
		7,
		677
	],
	"./pages/NewYear2025/components/Objects/Interactive/Interactive.tsx": [
		1506,
		9,
		212
	],
	"./pages/NewYear2025/components/Objects/Lantern/Lantern": [
		1493,
		9,
		199
	],
	"./pages/NewYear2025/components/Objects/Lantern/Lantern.tsx": [
		1493,
		9,
		199
	],
	"./pages/NewYear2025/components/Objects/NgTree/NgTree": [
		1497,
		9,
		227
	],
	"./pages/NewYear2025/components/Objects/NgTree/NgTree.tsx": [
		1497,
		9,
		227
	],
	"./pages/NewYear2025/components/Objects/Tree/Tree": [
		1494,
		9,
		196
	],
	"./pages/NewYear2025/components/Objects/Tree/Tree.tsx": [
		1494,
		9,
		196
	],
	"./pages/NewYear2025/components/PageConstructor/PageConstructor": [
		1495,
		9,
		213
	],
	"./pages/NewYear2025/components/PageConstructor/PageConstructor.scss": [
		2705,
		7,
		678
	],
	"./pages/NewYear2025/components/PageConstructor/PageConstructor.tsx": [
		1495,
		9,
		213
	],
	"./pages/NewYear2025/components/PageLoader/PageLoader": [
		1725,
		9,
		3,
		5,
		7,
		12,
		211
	],
	"./pages/NewYear2025/components/PageLoader/PageLoader.scss": [
		2803,
		7,
		679
	],
	"./pages/NewYear2025/components/PageLoader/PageLoader.tsx": [
		1725,
		9,
		3,
		5,
		7,
		12,
		211
	],
	"./pages/NewYear2025/components/PageSlider/PageSlider": [
		1514,
		9,
		0,
		279
	],
	"./pages/NewYear2025/components/PageSlider/PageSlider.scss": [
		2713,
		7,
		680
	],
	"./pages/NewYear2025/components/PageSlider/PageSlider.tsx": [
		1514,
		9,
		0,
		279
	],
	"./pages/NewYear2025/components/PopUp/PopUp": [
		1498,
		9,
		0
	],
	"./pages/NewYear2025/components/PopUp/PopUp.module.scss": [
		2830,
		7,
		713
	],
	"./pages/NewYear2025/components/PopUp/PopUp.tsx": [
		1498,
		9,
		0
	],
	"./pages/NewYear2025/components/PopUp/popUp.images": [
		1722,
		9,
		177
	],
	"./pages/NewYear2025/components/PopUp/popUp.images.ts": [
		1722,
		9,
		177
	],
	"./pages/NewYear2025/components/ScreenLoader/ScreenLoader": [
		1585,
		9,
		3,
		5,
		7,
		12,
		266
	],
	"./pages/NewYear2025/components/ScreenLoader/ScreenLoader.scss": [
		2745,
		7,
		681
	],
	"./pages/NewYear2025/components/ScreenLoader/ScreenLoader.tsx": [
		1585,
		9,
		3,
		5,
		7,
		12,
		266
	],
	"./pages/NewYear2025/components/ScreenSecondaryLoader/ScreenSecondaryLoader": [
		1700,
		9,
		326
	],
	"./pages/NewYear2025/components/ScreenSecondaryLoader/ScreenSecondaryLoader.scss": [
		2780,
		7,
		682
	],
	"./pages/NewYear2025/components/ScreenSecondaryLoader/ScreenSecondaryLoader.tsx": [
		1700,
		9,
		326
	],
	"./pages/NewYear2025/components/ScreenStub/ScreenStub": [
		1723,
		9,
		327
	],
	"./pages/NewYear2025/components/ScreenStub/ScreenStub.scss": [
		2802,
		7,
		683
	],
	"./pages/NewYear2025/components/ScreenStub/ScreenStub.tsx": [
		1723,
		9,
		327
	],
	"./pages/NewYear2025/components/Snowfall/Snowfall": [
		1574,
		9,
		53,
		551
	],
	"./pages/NewYear2025/components/Snowfall/Snowfall.scss": [
		2751,
		7,
		684
	],
	"./pages/NewYear2025/components/Snowfall/Snowfall.tsx": [
		1574,
		9,
		53,
		551
	],
	"./pages/NewYear2025/components/Timer/Timer": [
		1858,
		9,
		449
	],
	"./pages/NewYear2025/components/Timer/Timer.tsx": [
		1858,
		9,
		449
	],
	"./pages/NewYear2025/components/Tooltip/Tooltip": [
		1593,
		9,
		328
	],
	"./pages/NewYear2025/components/Tooltip/Tooltip.scss": [
		2743,
		7,
		685
	],
	"./pages/NewYear2025/components/Tooltip/Tooltip.tsx": [
		1593,
		9,
		328
	],
	"./pages/NewYear2025/components/Welcome/Welcome": [
		1685,
		9,
		329
	],
	"./pages/NewYear2025/components/Welcome/Welcome.scss": [
		2771,
		7,
		686
	],
	"./pages/NewYear2025/components/Welcome/Welcome.tsx": [
		1685,
		9,
		329
	],
	"./pages/NewYear2025/constants": [
		124,
		9
	],
	"./pages/NewYear2025/constants/": [
		124,
		9
	],
	"./pages/NewYear2025/constants/collectedObjectsData": [
		1508,
		9,
		450
	],
	"./pages/NewYear2025/constants/collectedObjectsData.tsx": [
		1508,
		9,
		450
	],
	"./pages/NewYear2025/constants/images": [
		1537,
		9,
		3,
		5,
		7,
		12,
		350
	],
	"./pages/NewYear2025/constants/images.ts": [
		1537,
		9,
		3,
		5,
		7,
		12,
		350
	],
	"./pages/NewYear2025/constants/index": [
		124,
		9
	],
	"./pages/NewYear2025/constants/index.ts": [
		124,
		9
	],
	"./pages/NewYear2025/constants/projects": [
		1532,
		9,
		228
	],
	"./pages/NewYear2025/constants/projects.ts": [
		1532,
		9,
		228
	],
	"./pages/NewYear2025/constants/sounds": [
		1727,
		9,
		345
	],
	"./pages/NewYear2025/constants/sounds.ts": [
		1727,
		9,
		345
	],
	"./pages/NewYear2025/constants/vars.scss": [
		2864,
		7,
		687
	],
	"./pages/NewYear2025/context/NY2025AudioContext": [
		1666,
		9,
		451
	],
	"./pages/NewYear2025/context/NY2025AudioContext.ts": [
		1666,
		9,
		451
	],
	"./pages/NewYear2025/context/NewYear2025PageContext": [
		1496,
		9,
		452
	],
	"./pages/NewYear2025/context/NewYear2025PageContext.ts": [
		1496,
		9,
		452
	],
	"./pages/NewYear2025/hooks/useAfterAuth": [
		1726,
		9,
		453
	],
	"./pages/NewYear2025/hooks/useAfterAuth.tsx": [
		1726,
		9,
		453
	],
	"./pages/NewYear2025/hooks/useAudioContext": [
		1724,
		9,
		330
	],
	"./pages/NewYear2025/hooks/useAudioContext.ts": [
		1724,
		9,
		330
	],
	"./pages/NewYear2025/hooks/useGoToProject": [
		1515,
		9,
		454
	],
	"./pages/NewYear2025/hooks/useGoToProject.ts": [
		1515,
		9,
		454
	],
	"./pages/NewYear2025/hooks/useIsSilentMode": [
		1492,
		9,
		280
	],
	"./pages/NewYear2025/hooks/useIsSilentMode.ts": [
		1492,
		9,
		280
	],
	"./pages/NewYear2025/hooks/usePageContext": [
		1500,
		9,
		346
	],
	"./pages/NewYear2025/hooks/usePageContext.ts": [
		1500,
		9,
		346
	],
	"./pages/NewYear2025/hooks/usePageParams": [
		1511,
		9,
		455
	],
	"./pages/NewYear2025/hooks/usePageParams.ts": [
		1511,
		9,
		455
	],
	"./pages/NewYear2025/hooks/useSlideId": [
		1501,
		9,
		347
	],
	"./pages/NewYear2025/hooks/useSlideId.ts": [
		1501,
		9,
		347
	],
	"./pages/NewYear2025/pages/AgKidsPage/AgKidsPage": [
		1692,
		9,
		0,
		24,
		37,
		31,
		126
	],
	"./pages/NewYear2025/pages/AgKidsPage/AgKidsPage.tsx": [
		1692,
		9,
		0,
		24,
		37,
		31,
		126
	],
	"./pages/NewYear2025/pages/AgKidsPage/Slides/Slide1": [
		1648,
		9,
		0,
		37,
		167
	],
	"./pages/NewYear2025/pages/AgKidsPage/Slides/Slide1.tsx": [
		1648,
		9,
		0,
		37,
		167
	],
	"./pages/NewYear2025/pages/AgKidsPage/Slides/Slide2": [
		1617,
		9,
		0,
		140
	],
	"./pages/NewYear2025/pages/AgKidsPage/Slides/Slide2.tsx": [
		1617,
		9,
		0,
		140
	],
	"./pages/NewYear2025/pages/AgKidsPage/Slides/Slide3": [
		1618,
		9,
		0,
		150
	],
	"./pages/NewYear2025/pages/AgKidsPage/Slides/Slide3.tsx": [
		1618,
		9,
		0,
		150
	],
	"./pages/NewYear2025/pages/AgKidsPage/Slides/Slide4": [
		1649,
		9,
		0,
		24,
		164
	],
	"./pages/NewYear2025/pages/AgKidsPage/Slides/Slide4.tsx": [
		1649,
		9,
		0,
		24,
		164
	],
	"./pages/NewYear2025/pages/AgKidsPage/Slides/Slide5": [
		1650,
		9,
		0,
		31,
		168
	],
	"./pages/NewYear2025/pages/AgKidsPage/Slides/Slide5.tsx": [
		1650,
		9,
		0,
		31,
		168
	],
	"./pages/NewYear2025/pages/AgPage/AgPage": [
		1693,
		9,
		0,
		36,
		44,
		54,
		120
	],
	"./pages/NewYear2025/pages/AgPage/AgPage.tsx": [
		1693,
		9,
		0,
		36,
		44,
		54,
		120
	],
	"./pages/NewYear2025/pages/AgPage/Slides/Slide1": [
		1619,
		9,
		0,
		124
	],
	"./pages/NewYear2025/pages/AgPage/Slides/Slide1.tsx": [
		1619,
		9,
		0,
		124
	],
	"./pages/NewYear2025/pages/AgPage/Slides/Slide2": [
		1651,
		9,
		0,
		36,
		152
	],
	"./pages/NewYear2025/pages/AgPage/Slides/Slide2.tsx": [
		1651,
		9,
		0,
		36,
		152
	],
	"./pages/NewYear2025/pages/AgPage/Slides/Slide3": [
		1620,
		9,
		0,
		125
	],
	"./pages/NewYear2025/pages/AgPage/Slides/Slide3.tsx": [
		1620,
		9,
		0,
		125
	],
	"./pages/NewYear2025/pages/AgPage/Slides/Slide4": [
		1652,
		9,
		0,
		44,
		131
	],
	"./pages/NewYear2025/pages/AgPage/Slides/Slide4.tsx": [
		1652,
		9,
		0,
		44,
		131
	],
	"./pages/NewYear2025/pages/AgPage/Slides/Slide5": [
		1653,
		9,
		0,
		54,
		162
	],
	"./pages/NewYear2025/pages/AgPage/Slides/Slide5.tsx": [
		1653,
		9,
		0,
		54,
		162
	],
	"./pages/NewYear2025/pages/EdPage/EdPage": [
		1699,
		9,
		0,
		25,
		27,
		38,
		118
	],
	"./pages/NewYear2025/pages/EdPage/EdPage.tsx": [
		1699,
		9,
		0,
		25,
		27,
		38,
		118
	],
	"./pages/NewYear2025/pages/EdPage/Slides/Slide1": [
		1663,
		9,
		0,
		38,
		163
	],
	"./pages/NewYear2025/pages/EdPage/Slides/Slide1.tsx": [
		1663,
		9,
		0,
		38,
		163
	],
	"./pages/NewYear2025/pages/EdPage/Slides/Slide2": [
		1664,
		9,
		0,
		25,
		137
	],
	"./pages/NewYear2025/pages/EdPage/Slides/Slide2.tsx": [
		1664,
		9,
		0,
		25,
		137
	],
	"./pages/NewYear2025/pages/EdPage/Slides/Slide3": [
		1665,
		9,
		0,
		27,
		135
	],
	"./pages/NewYear2025/pages/EdPage/Slides/Slide3.tsx": [
		1665,
		9,
		0,
		27,
		135
	],
	"./pages/NewYear2025/pages/EdPage/Slides/Slide4": [
		1631,
		9,
		0,
		130
	],
	"./pages/NewYear2025/pages/EdPage/Slides/Slide4.tsx": [
		1631,
		9,
		0,
		130
	],
	"./pages/NewYear2025/pages/EdPage/Slides/Slide5": [
		1632,
		9,
		0,
		132
	],
	"./pages/NewYear2025/pages/EdPage/Slides/Slide5.tsx": [
		1632,
		9,
		0,
		132
	],
	"./pages/NewYear2025/pages/GiPage/GiPage": [
		1691,
		9,
		0,
		22,
		32,
		48,
		122
	],
	"./pages/NewYear2025/pages/GiPage/GiPage.tsx": [
		1691,
		9,
		0,
		22,
		32,
		48,
		122
	],
	"./pages/NewYear2025/pages/GiPage/Slides/Slide1": [
		1645,
		9,
		0,
		48,
		136
	],
	"./pages/NewYear2025/pages/GiPage/Slides/Slide1.tsx": [
		1645,
		9,
		0,
		48,
		136
	],
	"./pages/NewYear2025/pages/GiPage/Slides/Slide2": [
		1646,
		9,
		0,
		22,
		147
	],
	"./pages/NewYear2025/pages/GiPage/Slides/Slide2.tsx": [
		1646,
		9,
		0,
		22,
		147
	],
	"./pages/NewYear2025/pages/GiPage/Slides/Slide3": [
		1615,
		9,
		0,
		144
	],
	"./pages/NewYear2025/pages/GiPage/Slides/Slide3.tsx": [
		1615,
		9,
		0,
		144
	],
	"./pages/NewYear2025/pages/GiPage/Slides/Slide4": [
		1647,
		9,
		0,
		32,
		138
	],
	"./pages/NewYear2025/pages/GiPage/Slides/Slide4.tsx": [
		1647,
		9,
		0,
		32,
		138
	],
	"./pages/NewYear2025/pages/GiPage/Slides/Slide5": [
		1616,
		9,
		0,
		133
	],
	"./pages/NewYear2025/pages/GiPage/Slides/Slide5.tsx": [
		1616,
		9,
		0,
		133
	],
	"./pages/NewYear2025/pages/GzPage/GzPage": [
		1694,
		9,
		0,
		16,
		43,
		39,
		121
	],
	"./pages/NewYear2025/pages/GzPage/GzPage.tsx": [
		1694,
		9,
		0,
		16,
		43,
		39,
		121
	],
	"./pages/NewYear2025/pages/GzPage/Slides/Slide1": [
		1654,
		9,
		0,
		43,
		143
	],
	"./pages/NewYear2025/pages/GzPage/Slides/Slide1.tsx": [
		1654,
		9,
		0,
		43,
		143
	],
	"./pages/NewYear2025/pages/GzPage/Slides/Slide2": [
		1621,
		9,
		0,
		127
	],
	"./pages/NewYear2025/pages/GzPage/Slides/Slide2.tsx": [
		1621,
		9,
		0,
		127
	],
	"./pages/NewYear2025/pages/GzPage/Slides/Slide3": [
		1655,
		9,
		0,
		39,
		158
	],
	"./pages/NewYear2025/pages/GzPage/Slides/Slide3.tsx": [
		1655,
		9,
		0,
		39,
		158
	],
	"./pages/NewYear2025/pages/GzPage/Slides/Slide4": [
		1695,
		9,
		0,
		16,
		148
	],
	"./pages/NewYear2025/pages/GzPage/Slides/Slide4.tsx": [
		1695,
		9,
		0,
		16,
		148
	],
	"./pages/NewYear2025/pages/GzPage/Slides/Slide5": [
		1622,
		9,
		0,
		134
	],
	"./pages/NewYear2025/pages/GzPage/Slides/Slide5.tsx": [
		1622,
		9,
		0,
		134
	],
	"./pages/NewYear2025/pages/MpPage/MpPage": [
		1698,
		9,
		0,
		26,
		49,
		40,
		129
	],
	"./pages/NewYear2025/pages/MpPage/MpPage.tsx": [
		1698,
		9,
		0,
		26,
		49,
		40,
		129
	],
	"./pages/NewYear2025/pages/MpPage/Slides/Slide1": [
		1660,
		9,
		0,
		49,
		166
	],
	"./pages/NewYear2025/pages/MpPage/Slides/Slide1.tsx": [
		1660,
		9,
		0,
		49,
		166
	],
	"./pages/NewYear2025/pages/MpPage/Slides/Slide2": [
		1661,
		9,
		0,
		40,
		161
	],
	"./pages/NewYear2025/pages/MpPage/Slides/Slide2.tsx": [
		1661,
		9,
		0,
		40,
		161
	],
	"./pages/NewYear2025/pages/MpPage/Slides/Slide3": [
		1662,
		9,
		0,
		26,
		165
	],
	"./pages/NewYear2025/pages/MpPage/Slides/Slide3.tsx": [
		1662,
		9,
		0,
		26,
		165
	],
	"./pages/NewYear2025/pages/MpPage/Slides/Slide4": [
		1629,
		9,
		0,
		146
	],
	"./pages/NewYear2025/pages/MpPage/Slides/Slide4.tsx": [
		1629,
		9,
		0,
		146
	],
	"./pages/NewYear2025/pages/MpPage/Slides/Slide5": [
		1630,
		9,
		0,
		153
	],
	"./pages/NewYear2025/pages/MpPage/Slides/Slide5.tsx": [
		1630,
		9,
		0,
		153
	],
	"./pages/NewYear2025/pages/MyIdPage/MyIdPage": [
		1696,
		9,
		0,
		3,
		30,
		28,
		157
	],
	"./pages/NewYear2025/pages/MyIdPage/MyIdPage.tsx": [
		1696,
		9,
		0,
		3,
		30,
		28,
		157
	],
	"./pages/NewYear2025/pages/MyIdPage/Slides/Slide1": [
		1656,
		9,
		0,
		28,
		159
	],
	"./pages/NewYear2025/pages/MyIdPage/Slides/Slide1.tsx": [
		1656,
		9,
		0,
		28,
		159
	],
	"./pages/NewYear2025/pages/MyIdPage/Slides/Slide2": [
		1623,
		9,
		0,
		3,
		192
	],
	"./pages/NewYear2025/pages/MyIdPage/Slides/Slide2.tsx": [
		1623,
		9,
		0,
		3,
		192
	],
	"./pages/NewYear2025/pages/MyIdPage/Slides/Slide3": [
		1624,
		9,
		0,
		139
	],
	"./pages/NewYear2025/pages/MyIdPage/Slides/Slide3.tsx": [
		1624,
		9,
		0,
		139
	],
	"./pages/NewYear2025/pages/MyIdPage/Slides/Slide4": [
		1657,
		9,
		0,
		30,
		155
	],
	"./pages/NewYear2025/pages/MyIdPage/Slides/Slide4.tsx": [
		1657,
		9,
		0,
		30,
		155
	],
	"./pages/NewYear2025/pages/MyIdPage/Slides/Slide5": [
		1625,
		9,
		0,
		145
	],
	"./pages/NewYear2025/pages/MyIdPage/Slides/Slide5.tsx": [
		1625,
		9,
		0,
		145
	],
	"./pages/NewYear2025/pages/NgPage/NgPage": [
		1697,
		9,
		0,
		11,
		29,
		33,
		119
	],
	"./pages/NewYear2025/pages/NgPage/NgPage.tsx": [
		1697,
		9,
		0,
		11,
		29,
		33,
		119
	],
	"./pages/NewYear2025/pages/NgPage/Slides/Slide1": [
		1626,
		9,
		0,
		11,
		149
	],
	"./pages/NewYear2025/pages/NgPage/Slides/Slide1.tsx": [
		1626,
		9,
		0,
		11,
		149
	],
	"./pages/NewYear2025/pages/NgPage/Slides/Slide2": [
		1627,
		9,
		0,
		123
	],
	"./pages/NewYear2025/pages/NgPage/Slides/Slide2.tsx": [
		1627,
		9,
		0,
		123
	],
	"./pages/NewYear2025/pages/NgPage/Slides/Slide3": [
		1658,
		9,
		0,
		29,
		141
	],
	"./pages/NewYear2025/pages/NgPage/Slides/Slide3.tsx": [
		1658,
		9,
		0,
		29,
		141
	],
	"./pages/NewYear2025/pages/NgPage/Slides/Slide4": [
		1659,
		9,
		0,
		33,
		142
	],
	"./pages/NewYear2025/pages/NgPage/Slides/Slide4.tsx": [
		1659,
		9,
		0,
		33,
		142
	],
	"./pages/NewYear2025/pages/NgPage/Slides/Slide5": [
		1628,
		9,
		0,
		128
	],
	"./pages/NewYear2025/pages/NgPage/Slides/Slide5.tsx": [
		1628,
		9,
		0,
		128
	],
	"./pages/NewYear2025/pages/PageWrapper/PageWrapper": [
		1721,
		9,
		0,
		3,
		11,
		16,
		114
	],
	"./pages/NewYear2025/pages/PageWrapper/PageWrapper.tsx": [
		1721,
		9,
		0,
		3,
		11,
		16,
		114
	],
	"./pages/NewYear2025/pages/StartPage/StartPage": [
		1717,
		9,
		7,
		11,
		151
	],
	"./pages/NewYear2025/pages/StartPage/StartPage.scss": [
		2798,
		7,
		688
	],
	"./pages/NewYear2025/pages/StartPage/StartPage.tsx": [
		1717,
		9,
		7,
		11,
		151
	],
	"./pages/NewYear2025/pages/TestPage/TestPage": [
		1720,
		9,
		2,
		3,
		5,
		7,
		111
	],
	"./pages/NewYear2025/pages/TestPage/TestPage.tsx": [
		1720,
		9,
		2,
		3,
		5,
		7,
		111
	],
	"./pages/News/NewsPage": [
		575,
		9
	],
	"./pages/News/NewsPage.scss": [
		1141,
		7
	],
	"./pages/News/NewsPage.tsx": [
		575,
		9
	],
	"./pages/NewsDetails/NewsDetailsPage": [
		581,
		9
	],
	"./pages/NewsDetails/NewsDetailsPage.module.scss": [
		208,
		7
	],
	"./pages/NewsDetails/NewsDetailsPage.tsx": [
		581,
		9
	],
	"./pages/NewsDetails/NewsDetailsVideo/NewsDetailsVideo": [
		582,
		9
	],
	"./pages/NewsDetails/NewsDetailsVideo/NewsDetailsVideo.module.scss": [
		410,
		7
	],
	"./pages/NewsDetails/NewsDetailsVideo/NewsDetailsVideo.tsx": [
		582,
		9
	],
	"./pages/NotExist/NotExistPage": [
		806,
		9
	],
	"./pages/NotExist/NotExistPage.scss": [
		1219,
		7
	],
	"./pages/NotExist/NotExistPage.tsx": [
		806,
		9
	],
	"./pages/NotFound/NotFoundPage": [
		631,
		9
	],
	"./pages/NotFound/NotFoundPage.scss": [
		1218,
		7
	],
	"./pages/NotFound/NotFoundPage.tsx": [
		631,
		9
	],
	"./pages/Photos/PhotosPage": [
		589,
		9
	],
	"./pages/Photos/PhotosPage.scss": [
		1167,
		7
	],
	"./pages/Photos/PhotosPage.tsx": [
		589,
		9
	],
	"./pages/PointsRules/PointsRulesPage": [
		702,
		9
	],
	"./pages/PointsRules/PointsRulesPage.scss": [
		1337,
		7
	],
	"./pages/PointsRules/PointsRulesPage.tsx": [
		702,
		9
	],
	"./pages/ProposeIdea/Birthday10Banner/Birthday10Banner": [
		802,
		9
	],
	"./pages/ProposeIdea/Birthday10Banner/Birthday10Banner.scss": [
		1184,
		7
	],
	"./pages/ProposeIdea/Birthday10Banner/Birthday10Banner.tsx": [
		802,
		9
	],
	"./pages/ProposeIdea/ProposeIdeaPage": [
		596,
		9
	],
	"./pages/ProposeIdea/ProposeIdeaPage.scss": [
		1178,
		7
	],
	"./pages/ProposeIdea/ProposeIdeaPage.tsx": [
		596,
		9
	],
	"./pages/ProposeIdeaDetails/DistrictSelector/DistrictSelector": [
		605,
		9
	],
	"./pages/ProposeIdeaDetails/DistrictSelector/DistrictSelector.helper": [
		606,
		9
	],
	"./pages/ProposeIdeaDetails/DistrictSelector/DistrictSelector.helper.ts": [
		606,
		9
	],
	"./pages/ProposeIdeaDetails/DistrictSelector/DistrictSelector.scss": [
		1189,
		7
	],
	"./pages/ProposeIdeaDetails/DistrictSelector/DistrictSelector.tsx": [
		605,
		9
	],
	"./pages/ProposeIdeaDetails/IdeaDetailsCardsList/IdeaDetailsCardsList": [
		600,
		9
	],
	"./pages/ProposeIdeaDetails/IdeaDetailsCardsList/IdeaDetailsCardsList.tsx": [
		600,
		9
	],
	"./pages/ProposeIdeaDetails/IdeaDetailsCardsList/IdeaDetailsCardsProps": [
		1859,
		9,
		456
	],
	"./pages/ProposeIdeaDetails/IdeaDetailsCardsList/IdeaDetailsCardsProps.ts": [
		1859,
		9,
		456
	],
	"./pages/ProposeIdeaDetails/ProposeIdeaDetailsPage": [
		599,
		9
	],
	"./pages/ProposeIdeaDetails/ProposeIdeaDetailsPage.scss": [
		1188,
		7
	],
	"./pages/ProposeIdeaDetails/ProposeIdeaDetailsPage.tsx": [
		599,
		9
	],
	"./pages/PublicationDetails/PublicationDetailsPage": [
		585,
		9
	],
	"./pages/PublicationDetails/PublicationDetailsPage.scss": [
		1151,
		7
	],
	"./pages/PublicationDetails/PublicationDetailsPage.tsx": [
		585,
		9
	],
	"./pages/Publications/PublicationsPage": [
		583,
		9
	],
	"./pages/Publications/PublicationsPage.scss": [
		1150,
		7
	],
	"./pages/Publications/PublicationsPage.tsx": [
		583,
		9
	],
	"./pages/SomethingWentWrong/SomethingWentWrong": [
		713,
		9
	],
	"./pages/SomethingWentWrong/SomethingWentWrong.scss": [
		1346,
		7
	],
	"./pages/SomethingWentWrong/SomethingWentWrong.tsx": [
		713,
		9
	],
	"./pages/SpecialProjects/SpecialProjects": [
		622,
		9
	],
	"./pages/SpecialProjects/SpecialProjects.scss": [
		1211,
		7
	],
	"./pages/SpecialProjects/SpecialProjects.tsx": [
		622,
		9
	],
	"./pages/SpecialProjects/components/SpecialProjectsCard/SpecialProjectsCard": [
		623,
		9
	],
	"./pages/SpecialProjects/components/SpecialProjectsCard/SpecialProjectsCard.scss": [
		1210,
		7
	],
	"./pages/SpecialProjects/components/SpecialProjectsCard/SpecialProjectsCard.tsx": [
		623,
		9
	],
	"./pages/SpecialProjects/components/SpecialProjectsImages/SpecialProjectsImages": [
		624,
		9
	],
	"./pages/SpecialProjects/components/SpecialProjectsImages/SpecialProjectsImages.tsx": [
		624,
		9
	],
	"./pages/SpecialProjects/constants/constants": [
		467,
		9
	],
	"./pages/SpecialProjects/constants/constants.ts": [
		467,
		9
	],
	"./pages/SpecialProjects/types/types": [
		1860,
		9,
		457
	],
	"./pages/SpecialProjects/types/types.ts": [
		1860,
		9,
		457
	],
	"./pages/SuccessEmailConfirmation/SuccessEmailConfirmation": [
		595,
		9
	],
	"./pages/SuccessEmailConfirmation/SuccessEmailConfirmation.scss": [
		1176,
		7
	],
	"./pages/SuccessEmailConfirmation/SuccessEmailConfirmation.tsx": [
		595,
		9
	],
	"./pages/TeamLogin/TeamLoginPage": [
		1732,
		9,
		247
	],
	"./pages/TeamLogin/TeamLoginPage.scss": [
		2809,
		7,
		689
	],
	"./pages/TeamLogin/TeamLoginPage.tsx": [
		1732,
		9,
		247
	],
	"./pages/Video/VideoPage": [
		812,
		9
	],
	"./pages/Video/VideoPage.scss": [
		1172,
		7
	],
	"./pages/Video/VideoPage.tsx": [
		812,
		9
	],
	"./pages/WorkResult/WorkResult.helper": [
		183,
		9
	],
	"./pages/WorkResult/WorkResult.helper.scss": [
		2865,
		7,
		690
	],
	"./pages/WorkResult/WorkResult.helper.ts": [
		183,
		9
	],
	"./pages/WorkResult/WorkResultPage": [
		201,
		9
	],
	"./pages/WorkResult/WorkResultPage.scss": [
		1196,
		7
	],
	"./pages/WorkResult/WorkResultPage.tsx": [
		201,
		9
	],
	"./pages/WorkResultDetailed/WorkResultDetailedPage": [
		611,
		9
	],
	"./pages/WorkResultDetailed/WorkResultDetailedPage.scss": [
		1197,
		7
	],
	"./pages/WorkResultDetailed/WorkResultDetailedPage.tsx": [
		611,
		9
	],
	"./presentational/AcceptCookie/AcceptCookie": [
		711,
		9
	],
	"./presentational/AcceptCookie/AcceptCookie.module.scss": [
		412,
		7
	],
	"./presentational/AcceptCookie/AcceptCookie.tsx": [
		711,
		9
	],
	"./presentational/AgVideoWidget/AgVideoWidget": [
		689,
		9
	],
	"./presentational/AgVideoWidget/AgVideoWidget.interface": [
		1861,
		9,
		458
	],
	"./presentational/AgVideoWidget/AgVideoWidget.interface.ts": [
		1861,
		9,
		458
	],
	"./presentational/AgVideoWidget/AgVideoWidget.tsx": [
		689,
		9
	],
	"./presentational/BookView/BookView": [
		704,
		9
	],
	"./presentational/BookView/BookView.scss": [
		1338,
		7
	],
	"./presentational/BookView/BookView.tsx": [
		704,
		9
	],
	"./presentational/BookView/classes/BookViewBase": [
		298,
		9
	],
	"./presentational/BookView/classes/BookViewBase.tsx": [
		298,
		9
	],
	"./presentational/BookView/classes/FlipBook": [
		706,
		9
	],
	"./presentational/BookView/classes/FlipBook.tsx": [
		706,
		9
	],
	"./presentational/BookView/classes/FullPage": [
		705,
		9
	],
	"./presentational/BookView/classes/FullPage.tsx": [
		705,
		9
	],
	"./presentational/BookView/classes/NotAvailable": [
		815,
		9
	],
	"./presentational/BookView/classes/NotAvailable.tsx": [
		815,
		9
	],
	"./presentational/CaptchaMosRu/CaptchaMosRu": [
		636,
		9
	],
	"./presentational/CaptchaMosRu/CaptchaMosRu.scss": [
		1220,
		7
	],
	"./presentational/CaptchaMosRu/CaptchaMosRu.tsx": [
		636,
		9
	],
	"./presentational/CardGridPageGenerate/CardGridPageGenerate": [
		291,
		9
	],
	"./presentational/CardGridPageGenerate/CardGridPageGenerate.interface": [
		1862,
		9,
		459
	],
	"./presentational/CardGridPageGenerate/CardGridPageGenerate.interface.ts": [
		1862,
		9,
		459
	],
	"./presentational/CardGridPageGenerate/CardGridPageGenerate.scss": [
		1147,
		7
	],
	"./presentational/CardGridPageGenerate/CardGridPageGenerate.tsx": [
		291,
		9
	],
	"./presentational/Cards/ContentCard/ContentCard": [
		607,
		9
	],
	"./presentational/Cards/ContentCard/ContentCard.scss": [
		1191,
		7
	],
	"./presentational/Cards/ContentCard/ContentCard.tsx": [
		607,
		9
	],
	"./presentational/Cards/FlippableCard/FlippableCard": [
		604,
		9
	],
	"./presentational/Cards/FlippableCard/FlippableCard.scss": [
		1187,
		7
	],
	"./presentational/Cards/FlippableCard/FlippableCard.tsx": [
		604,
		9
	],
	"./presentational/Cards/IdeaCard/IdeaCard": [
		388,
		9
	],
	"./presentational/Cards/IdeaCard/IdeaCard.scss": [
		1331,
		7
	],
	"./presentational/Cards/IdeaCard/IdeaCard.tsx": [
		388,
		9
	],
	"./presentational/Cards/IdeaDetailsCard/IdeaDetailsCard": [
		603,
		9
	],
	"./presentational/Cards/IdeaDetailsCard/IdeaDetailsCard.scss": [
		1186,
		7
	],
	"./presentational/Cards/IdeaDetailsCard/IdeaDetailsCard.tsx": [
		603,
		9
	],
	"./presentational/Cards/IdeaPhotoCard/IdeaPhotoCard": [
		217,
		9
	],
	"./presentational/Cards/IdeaPhotoCard/IdeaPhotoCard.module.scss": [
		79,
		7
	],
	"./presentational/Cards/IdeaPhotoCard/IdeaPhotoCard.tsx": [
		217,
		9
	],
	"./presentational/Cards/IdeaResultCard/IdeaResultCard": [
		1863,
		9,
		331
	],
	"./presentational/Cards/IdeaResultCard/IdeaResultCard.scss": [
		2844,
		7,
		691
	],
	"./presentational/Cards/IdeaResultCard/IdeaResultCard.tsx": [
		1863,
		9,
		331
	],
	"./presentational/Cards/InProgressCard/InProgressCard": [
		608,
		9
	],
	"./presentational/Cards/InProgressCard/InProgressCard.scss": [
		1192,
		7
	],
	"./presentational/Cards/InProgressCard/InProgressCard.tsx": [
		608,
		9
	],
	"./presentational/Cards/InfoCard/InfoCard": [
		752,
		9
	],
	"./presentational/Cards/InfoCard/InfoCard.scss": [
		1413,
		7
	],
	"./presentational/Cards/InfoCard/InfoCard.tsx": [
		752,
		9
	],
	"./presentational/Cards/NewsCard/NewsCard": [
		576,
		9
	],
	"./presentational/Cards/NewsCard/NewsCard.module.scss": [
		268,
		7
	],
	"./presentational/Cards/NewsCard/NewsCard.tsx": [
		576,
		9
	],
	"./presentational/Cards/PhotoCard/PhotoCard": [
		590,
		9
	],
	"./presentational/Cards/PhotoCard/PhotoCard.scss": [
		1154,
		7
	],
	"./presentational/Cards/PhotoCard/PhotoCard.tsx": [
		590,
		9
	],
	"./presentational/Cards/ProjectFlipcard/ProjectFlipcard": [
		215,
		9
	],
	"./presentational/Cards/ProjectFlipcard/ProjectFlipcard.scss": [
		1105,
		7
	],
	"./presentational/Cards/ProjectFlipcard/ProjectFlipcard.tsx": [
		215,
		9
	],
	"./presentational/Cards/PublicationCard/PublicationCard": [
		584,
		9
	],
	"./presentational/Cards/PublicationCard/PublicationCard.scss": [
		1149,
		7
	],
	"./presentational/Cards/PublicationCard/PublicationCard.tsx": [
		584,
		9
	],
	"./presentational/Cards/SphereCard/SphereCard": [
		598,
		9
	],
	"./presentational/Cards/SphereCard/SphereCard.scss": [
		1182,
		7
	],
	"./presentational/Cards/SphereCard/SphereCard.tsx": [
		598,
		9
	],
	"./presentational/Cards/TagsCard/TagsCard": [
		290,
		9
	],
	"./presentational/Cards/TagsCard/TagsCard.interface": [
		1864,
		9,
		460
	],
	"./presentational/Cards/TagsCard/TagsCard.interface.ts": [
		1864,
		9,
		460
	],
	"./presentational/Cards/TagsCard/TagsCard.scss": [
		1139,
		7
	],
	"./presentational/Cards/TagsCard/TagsCard.tsx": [
		290,
		9
	],
	"./presentational/Cards/UserIdeaInfoCard/UserIdeaInfoCard": [
		1865,
		9,
		332
	],
	"./presentational/Cards/UserIdeaInfoCard/UserIdeaInfoCard.scss": [
		2845,
		7,
		692
	],
	"./presentational/Cards/UserIdeaInfoCard/UserIdeaInfoCard.tsx": [
		1865,
		9,
		332
	],
	"./presentational/Cards/VideoCard/VideoCard": [
		378,
		9
	],
	"./presentational/Cards/VideoCard/VideoCard.scss": [
		1171,
		7
	],
	"./presentational/Cards/VideoCard/VideoCard.tsx": [
		378,
		9
	],
	"./presentational/Cards/WorkResultCard/WorkResultCard": [
		382,
		9
	],
	"./presentational/Cards/WorkResultCard/WorkResultCard.scss": [
		1193,
		7
	],
	"./presentational/Cards/WorkResultCard/WorkResultCard.tsx": [
		382,
		9
	],
	"./presentational/Chat/Chat": [
		792,
		9
	],
	"./presentational/Chat/Chat.scss": [
		1456,
		7
	],
	"./presentational/Chat/Chat.tsx": [
		792,
		9
	],
	"./presentational/Controls/AppLink/AppLink": [
		195,
		9
	],
	"./presentational/Controls/AppLink/AppLink.module.scss": [
		267,
		7
	],
	"./presentational/Controls/AppLink/AppLink.tsx": [
		195,
		9
	],
	"./presentational/Controls/ArrowBack/ArrowBack": [
		232,
		9
	],
	"./presentational/Controls/ArrowBack/ArrowBack.scss": [
		1110,
		7
	],
	"./presentational/Controls/ArrowBack/ArrowBack.tsx": [
		232,
		9
	],
	"./presentational/Controls/Button/Button": [
		26,
		9
	],
	"./presentational/Controls/Button/Button.scss": [
		1085,
		7
	],
	"./presentational/Controls/Button/Button.tsx": [
		26,
		9
	],
	"./presentational/Controls/Checkbox/Checkbox": [
		179,
		9
	],
	"./presentational/Controls/Checkbox/Checkbox.scss": [
		1162,
		7
	],
	"./presentational/Controls/Checkbox/Checkbox.tsx": [
		179,
		9
	],
	"./presentational/Controls/DynamoList/DynamoList": [
		377,
		9
	],
	"./presentational/Controls/DynamoList/DynamoList.scss": [
		1166,
		7
	],
	"./presentational/Controls/DynamoList/DynamoList.tsx": [
		377,
		9
	],
	"./presentational/Controls/FileSelector/FilePreview/FilePreview": [
		591,
		9
	],
	"./presentational/Controls/FileSelector/FilePreview/FilePreview.scss": [
		1160,
		7
	],
	"./presentational/Controls/FileSelector/FilePreview/FilePreview.tsx": [
		591,
		9
	],
	"./presentational/Controls/FileSelector/FileSelector": [
		198,
		9
	],
	"./presentational/Controls/FileSelector/FileSelector.scss": [
		1161,
		7
	],
	"./presentational/Controls/FileSelector/FileSelector.tsx": [
		198,
		9
	],
	"./presentational/Controls/IconButton/IconButton": [
		312,
		9
	],
	"./presentational/Controls/IconButton/IconButton.scss": [
		1103,
		7
	],
	"./presentational/Controls/IconButton/IconButton.tsx": [
		312,
		9
	],
	"./presentational/Controls/Input/Input": [
		69,
		9
	],
	"./presentational/Controls/Input/Input.scss": [
		1157,
		7
	],
	"./presentational/Controls/Input/Input.tsx": [
		69,
		9
	],
	"./presentational/Controls/Like/Like": [
		616,
		9
	],
	"./presentational/Controls/Like/Like.module.scss": [
		840,
		7
	],
	"./presentational/Controls/Like/Like.tsx": [
		616,
		9
	],
	"./presentational/Controls/Pagination/Pagination": [
		233,
		9
	],
	"./presentational/Controls/Pagination/Pagination.scss": [
		1146,
		7
	],
	"./presentational/Controls/Pagination/Pagination.tsx": [
		233,
		9
	],
	"./presentational/Controls/Radio/Radio": [
		303,
		9
	],
	"./presentational/Controls/Radio/Radio.scss": [
		1177,
		7
	],
	"./presentational/Controls/Radio/Radio.tsx": [
		303,
		9
	],
	"./presentational/Controls/ScrollTopButton/ScrollTopButton": [
		791,
		9
	],
	"./presentational/Controls/ScrollTopButton/ScrollTopButton.scss": [
		1455,
		7
	],
	"./presentational/Controls/ScrollTopButton/ScrollTopButton.tsx": [
		791,
		9
	],
	"./presentational/Controls/Search/Search": [
		200,
		9
	],
	"./presentational/Controls/Search/Search.scss": [
		1143,
		7
	],
	"./presentational/Controls/Search/Search.tsx": [
		200,
		9
	],
	"./presentational/Controls/Search/SearchList/SearchList": [
		577,
		9
	],
	"./presentational/Controls/Search/SearchList/SearchList.scss": [
		1144,
		7
	],
	"./presentational/Controls/Search/SearchList/SearchList.tsx": [
		577,
		9
	],
	"./presentational/Controls/Select/Select": [
		119,
		9
	],
	"./presentational/Controls/Select/Select.interface": [
		1866,
		9,
		461
	],
	"./presentational/Controls/Select/Select.interface.ts": [
		1866,
		9,
		461
	],
	"./presentational/Controls/Select/Select.scss": [
		1158,
		7
	],
	"./presentational/Controls/Select/Select.tsx": [
		119,
		9
	],
	"./presentational/Controls/TextAreaEditor/TextAreaEditor": [
		820,
		9
	],
	"./presentational/Controls/TextAreaEditor/TextAreaEditor.scss": [
		1421,
		7
	],
	"./presentational/Controls/TextAreaEditor/TextAreaEditor.tsx": [
		820,
		9
	],
	"./presentational/Controls/Textarea/Textarea": [
		234,
		9
	],
	"./presentational/Controls/Textarea/Textarea.scss": [
		1159,
		7
	],
	"./presentational/Controls/Textarea/Textarea.tsx": [
		234,
		9
	],
	"./presentational/Controls/Tooltip/Tooltip": [
		98,
		9
	],
	"./presentational/Controls/Tooltip/Tooltip.interface": [
		1867,
		9,
		462
	],
	"./presentational/Controls/Tooltip/Tooltip.interface.ts": [
		1867,
		9,
		462
	],
	"./presentational/Controls/Tooltip/Tooltip.scss": [
		1094,
		7
	],
	"./presentational/Controls/Tooltip/Tooltip.tsx": [
		98,
		9
	],
	"./presentational/CrowdLoader/CrowdLoader": [
		1868,
		9,
		333
	],
	"./presentational/CrowdLoader/CrowdLoader.scss": [
		2846,
		7,
		693
	],
	"./presentational/CrowdLoader/CrowdLoader.tsx": [
		1868,
		9,
		333
	],
	"./presentational/Delayed": [
		861,
		9,
		75
	],
	"./presentational/Delayed/": [
		861,
		9,
		75
	],
	"./presentational/Delayed/Delayed": [
		1529,
		9,
		463
	],
	"./presentational/Delayed/Delayed.tsx": [
		1529,
		9,
		463
	],
	"./presentational/Delayed/Delayed.types": [
		1869,
		9,
		464
	],
	"./presentational/Delayed/Delayed.types.ts": [
		1869,
		9,
		464
	],
	"./presentational/Delayed/index": [
		861,
		9,
		75
	],
	"./presentational/Delayed/index.tsx": [
		861,
		9,
		75
	],
	"./presentational/DirtyWordsChecker/DirtyWordsChecker": [
		465,
		9
	],
	"./presentational/DirtyWordsChecker/DirtyWordsChecker.scss": [
		1420,
		7
	],
	"./presentational/DirtyWordsChecker/DirtyWordsChecker.tsx": [
		465,
		9
	],
	"./presentational/ElementObserver/ElementObserver": [
		633,
		9
	],
	"./presentational/ElementObserver/ElementObserver.interface": [
		1870,
		9,
		465
	],
	"./presentational/ElementObserver/ElementObserver.interface.ts": [
		1870,
		9,
		465
	],
	"./presentational/ElementObserver/ElementObserver.scss": [
		2866,
		7,
		694
	],
	"./presentational/ElementObserver/ElementObserver.tsx": [
		633,
		9
	],
	"./presentational/ElementObserver/ElementObserverItem/ElementObserverItem": [
		634,
		9
	],
	"./presentational/ElementObserver/ElementObserverItem/ElementObserverItem.tsx": [
		634,
		9
	],
	"./presentational/FadeIn/FadeIn": [
		82,
		9
	],
	"./presentational/FadeIn/FadeIn.scss": [
		1107,
		7
	],
	"./presentational/FadeIn/FadeIn.tsx": [
		82,
		9
	],
	"./presentational/Flipcard/FlipCard": [
		1871,
		9,
		334
	],
	"./presentational/Flipcard/FlipCard.scss": [
		2847,
		7,
		695
	],
	"./presentational/Flipcard/FlipCard.tsx": [
		1871,
		9,
		334
	],
	"./presentational/Game/Game": [
		1643,
		9,
		281
	],
	"./presentational/Game/Game.helper": [
		1872,
		9,
		348
	],
	"./presentational/Game/Game.helper.ts": [
		1872,
		9,
		348
	],
	"./presentational/Game/Game.interface": [
		117,
		9
	],
	"./presentational/Game/Game.interface.ts": [
		117,
		9
	],
	"./presentational/Game/Game.scss": [
		2770,
		7,
		696
	],
	"./presentational/Game/Game.tsx": [
		1643,
		9,
		281
	],
	"./presentational/GridBlock/GridBlock": [
		458,
		9
	],
	"./presentational/GridBlock/GridBlock.module.scss": [
		137,
		7
	],
	"./presentational/GridBlock/GridBlock.tsx": [
		458,
		9
	],
	"./presentational/GridView/GridView": [
		578,
		9
	],
	"./presentational/GridView/GridView.scss": [
		1145,
		7
	],
	"./presentational/GridView/GridView.tsx": [
		578,
		9
	],
	"./presentational/GridView/classes/GridBase": [
		374,
		9
	],
	"./presentational/GridView/classes/GridBase.tsx": [
		374,
		9
	],
	"./presentational/GridView/classes/RestGrid": [
		580,
		9
	],
	"./presentational/GridView/classes/RestGrid.tsx": [
		580,
		9
	],
	"./presentational/GridView/classes/SimpleGrid": [
		579,
		9
	],
	"./presentational/GridView/classes/SimpleGrid.tsx": [
		579,
		9
	],
	"./presentational/Icon": [
		880,
		9,
		70
	],
	"./presentational/Icon/": [
		880,
		9,
		70
	],
	"./presentational/Icon/IconCompleted": [
		1633,
		9,
		466
	],
	"./presentational/Icon/IconCompleted.tsx": [
		1633,
		9,
		466
	],
	"./presentational/Icon/index": [
		880,
		9,
		70
	],
	"./presentational/Icon/index.interface": [
		1873,
		9,
		467
	],
	"./presentational/Icon/index.interface.ts": [
		1873,
		9,
		467
	],
	"./presentational/Icon/index.tsx": [
		880,
		9,
		70
	],
	"./presentational/Image/Image": [
		240,
		9
	],
	"./presentational/Image/Image.tsx": [
		240,
		9
	],
	"./presentational/LinkPopup/LinkPopup": [
		758,
		9
	],
	"./presentational/LinkPopup/LinkPopup.scss": [
		1423,
		7
	],
	"./presentational/LinkPopup/LinkPopup.tsx": [
		758,
		9
	],
	"./presentational/Loaders/FourColumnLoader/FourColumnLoader": [
		129,
		9
	],
	"./presentational/Loaders/FourColumnLoader/FourColumnLoader.scss": [
		1108,
		7
	],
	"./presentational/Loaders/FourColumnLoader/FourColumnLoader.tsx": [
		129,
		9
	],
	"./presentational/Loaders/GenericProjectLoader/GenericProjectLoader": [
		372,
		9
	],
	"./presentational/Loaders/GenericProjectLoader/GenericProjectLoader.scss": [
		2867,
		7,
		697
	],
	"./presentational/Loaders/GenericProjectLoader/GenericProjectLoader.tsx": [
		372,
		9
	],
	"./presentational/Loaders/Loader/Loader": [
		63,
		9
	],
	"./presentational/Loaders/Loader/Loader.scss": [
		1101,
		7
	],
	"./presentational/Loaders/Loader/Loader.tsx": [
		63,
		9
	],
	"./presentational/Loaders/MainPageLoader/MainPageLoader": [
		685,
		9
	],
	"./presentational/Loaders/MainPageLoader/MainPageLoader.tsx": [
		685,
		9
	],
	"./presentational/Loaders/ProfileLoader/ProfileLoader": [
		1874,
		9,
		335
	],
	"./presentational/Loaders/ProfileLoader/ProfileLoader.scss": [
		2848,
		7,
		698
	],
	"./presentational/Loaders/ProfileLoader/ProfileLoader.tsx": [
		1874,
		9,
		335
	],
	"./presentational/Map/FSMap/FSMap": [
		1706,
		9,
		207
	],
	"./presentational/Map/FSMap/FSMap.scss": [
		2787,
		7,
		699
	],
	"./presentational/Map/FSMap/FSMap.tsx": [
		1706,
		9,
		207
	],
	"./presentational/Map/Map": [
		273,
		9
	],
	"./presentational/Map/Map.scss": [
		1165,
		7
	],
	"./presentational/Map/Map.tsx": [
		273,
		9
	],
	"./presentational/MetaDecorator/MetaDecorator": [
		54,
		9
	],
	"./presentational/MetaDecorator/MetaDecorator.tsx": [
		54,
		9
	],
	"./presentational/Modals/NextModal/NextModal": [
		193,
		9
	],
	"./presentational/Modals/NextModal/NextModal.scss": [
		1173,
		7
	],
	"./presentational/Modals/NextModal/NextModal.tsx": [
		193,
		9
	],
	"./presentational/Motivation/Motivation": [
		1876,
		9,
		469
	],
	"./presentational/Motivation/Motivation.interface": [
		1875,
		9,
		468
	],
	"./presentational/Motivation/Motivation.interface.ts": [
		1875,
		9,
		468
	],
	"./presentational/Motivation/Motivation.tsx": [
		1876,
		9,
		469
	],
	"./presentational/OpenLayersMap/OpenLayersMap": [
		692,
		9
	],
	"./presentational/OpenLayersMap/OpenLayersMap.helper": [
		402,
		9
	],
	"./presentational/OpenLayersMap/OpenLayersMap.helper.tsx": [
		402,
		9
	],
	"./presentational/OpenLayersMap/OpenLayersMap.scss": [
		1334,
		7
	],
	"./presentational/OpenLayersMap/OpenLayersMap.tsx": [
		692,
		9
	],
	"./presentational/OpenLayersMap/OpenLayersMapLoader/OpenLayersMapLoader": [
		693,
		9
	],
	"./presentational/OpenLayersMap/OpenLayersMapLoader/OpenLayersMapLoader.scss": [
		1335,
		7
	],
	"./presentational/OpenLayersMap/OpenLayersMapLoader/OpenLayersMapLoader.tsx": [
		693,
		9
	],
	"./presentational/PageDescription/PageDescription": [
		154,
		9
	],
	"./presentational/PageDescription/PageDescription.scss": [
		1148,
		7
	],
	"./presentational/PageDescription/PageDescription.tsx": [
		154,
		9
	],
	"./presentational/PageHeading/PageHeading": [
		617,
		9
	],
	"./presentational/PageHeading/PageHeading.module.scss": [
		979,
		7
	],
	"./presentational/PageHeading/PageHeading.tsx": [
		617,
		9
	],
	"./presentational/PageTitle/PageTitle": [
		139,
		9
	],
	"./presentational/PageTitle/PageTitle.scss": [
		1142,
		7
	],
	"./presentational/PageTitle/PageTitle.tsx": [
		139,
		9
	],
	"./presentational/ProfilePic/ProfilePic": [
		230,
		9
	],
	"./presentational/ProfilePic/ProfilePic.scss": [
		1093,
		7
	],
	"./presentational/ProfilePic/ProfilePic.tsx": [
		230,
		9
	],
	"./presentational/ProgressBar/ProgressBar": [
		609,
		9
	],
	"./presentational/ProgressBar/ProgressBar.scss": [
		1194,
		7
	],
	"./presentational/ProgressBar/ProgressBar.tsx": [
		609,
		9
	],
	"./presentational/ProgressCounter/ProgressCounter": [
		610,
		9
	],
	"./presentational/ProgressCounter/ProgressCounter.scss": [
		1195,
		7
	],
	"./presentational/ProgressCounter/ProgressCounter.tsx": [
		610,
		9
	],
	"./presentational/ScrollIntersectionController": [
		354,
		9
	],
	"./presentational/ScrollIntersectionController/": [
		354,
		9
	],
	"./presentational/ScrollIntersectionController/ScrollIntersectionController": [
		524,
		9
	],
	"./presentational/ScrollIntersectionController/ScrollIntersectionController.tsx": [
		524,
		9
	],
	"./presentational/ScrollIntersectionController/ScrollIntersectionController.types": [
		1877,
		9,
		470
	],
	"./presentational/ScrollIntersectionController/ScrollIntersectionController.types.ts": [
		1877,
		9,
		470
	],
	"./presentational/ScrollIntersectionController/index": [
		354,
		9
	],
	"./presentational/ScrollIntersectionController/index.tsx": [
		354,
		9
	],
	"./presentational/Share/Share": [
		113,
		9
	],
	"./presentational/Share/Share.scss": [
		1140,
		7
	],
	"./presentational/Share/Share.tsx": [
		113,
		9
	],
	"./presentational/Sliders/CommonSlider/CommonSlider": [
		61,
		9
	],
	"./presentational/Sliders/CommonSlider/CommonSlider.scss": [
		1169,
		7
	],
	"./presentational/Sliders/CommonSlider/CommonSlider.tsx": [
		61,
		9
	],
	"./presentational/Sliders/FlipsterSlider/FlipsterSlider": [
		1878,
		9,
		336
	],
	"./presentational/Sliders/FlipsterSlider/FlipsterSlider.scss": [
		2849,
		7,
		700
	],
	"./presentational/Sliders/FlipsterSlider/FlipsterSlider.tsx": [
		1878,
		9,
		336
	],
	"./presentational/Sliders/Slider/Slider": [
		236,
		9
	],
	"./presentational/Sliders/Slider/Slider.interface": [
		1879,
		9,
		471
	],
	"./presentational/Sliders/Slider/Slider.interface.ts": [
		1879,
		9,
		471
	],
	"./presentational/Sliders/Slider/Slider.module.scss": [
		476,
		7
	],
	"./presentational/Sliders/Slider/Slider.tsx": [
		236,
		9
	],
	"./presentational/Sliders/SliderArrows/SliderArrows": [
		235,
		9
	],
	"./presentational/Sliders/SliderArrows/SliderArrows.module.scss": [
		314,
		7
	],
	"./presentational/Sliders/SliderArrows/SliderArrows.tsx": [
		235,
		9
	],
	"./presentational/Sliders/TrioSlider/Slide/Slide": [
		683,
		9
	],
	"./presentational/Sliders/TrioSlider/Slide/Slide.tsx": [
		683,
		9
	],
	"./presentational/Sliders/TrioSlider/TrioSlider": [
		684,
		9
	],
	"./presentational/Sliders/TrioSlider/TrioSlider.module.scss": [
		209,
		7
	],
	"./presentational/Sliders/TrioSlider/TrioSlider.tsx": [
		684,
		9
	],
	"./presentational/StaticDescriptions/AGN": [
		893,
		9,
		78
	],
	"./presentational/StaticDescriptions/AGN/": [
		893,
		9,
		78
	],
	"./presentational/StaticDescriptions/AGN/ideas": [
		1880,
		9,
		472
	],
	"./presentational/StaticDescriptions/AGN/ideas.tsx": [
		1880,
		9,
		472
	],
	"./presentational/StaticDescriptions/AGN/index": [
		893,
		9,
		78
	],
	"./presentational/StaticDescriptions/AGN/index.tsx": [
		893,
		9,
		78
	],
	"./presentational/StaticDescriptions/AGN/plan": [
		1881,
		9,
		473
	],
	"./presentational/StaticDescriptions/AGN/plan.tsx": [
		1881,
		9,
		473
	],
	"./presentational/StaticDescriptions/aktivnoe_dolgoletie": [
		894,
		9,
		79
	],
	"./presentational/StaticDescriptions/aktivnoe_dolgoletie/": [
		894,
		9,
		79
	],
	"./presentational/StaticDescriptions/aktivnoe_dolgoletie/ideas": [
		1882,
		9,
		474
	],
	"./presentational/StaticDescriptions/aktivnoe_dolgoletie/ideas.tsx": [
		1882,
		9,
		474
	],
	"./presentational/StaticDescriptions/aktivnoe_dolgoletie/index": [
		894,
		9,
		79
	],
	"./presentational/StaticDescriptions/aktivnoe_dolgoletie/index.tsx": [
		894,
		9,
		79
	],
	"./presentational/StaticDescriptions/aktivnoe_dolgoletie/plan": [
		1883,
		9,
		475
	],
	"./presentational/StaticDescriptions/aktivnoe_dolgoletie/plan.tsx": [
		1883,
		9,
		475
	],
	"./presentational/StaticDescriptions/children-clinics": [
		895,
		9,
		80
	],
	"./presentational/StaticDescriptions/children-clinics/": [
		895,
		9,
		80
	],
	"./presentational/StaticDescriptions/children-clinics/ideas": [
		1884,
		9,
		476
	],
	"./presentational/StaticDescriptions/children-clinics/ideas.tsx": [
		1884,
		9,
		476
	],
	"./presentational/StaticDescriptions/children-clinics/index": [
		895,
		9,
		80
	],
	"./presentational/StaticDescriptions/children-clinics/index.tsx": [
		895,
		9,
		80
	],
	"./presentational/StaticDescriptions/children-clinics/plan": [
		1885,
		9,
		477
	],
	"./presentational/StaticDescriptions/children-clinics/plan.tsx": [
		1885,
		9,
		477
	],
	"./presentational/StaticDescriptions/children-rest": [
		896,
		9,
		81
	],
	"./presentational/StaticDescriptions/children-rest/": [
		896,
		9,
		81
	],
	"./presentational/StaticDescriptions/children-rest/ideas": [
		1886,
		9,
		478
	],
	"./presentational/StaticDescriptions/children-rest/ideas.tsx": [
		1886,
		9,
		478
	],
	"./presentational/StaticDescriptions/children-rest/index": [
		896,
		9,
		81
	],
	"./presentational/StaticDescriptions/children-rest/index.tsx": [
		896,
		9,
		81
	],
	"./presentational/StaticDescriptions/children-rest/plan": [
		1887,
		9,
		479
	],
	"./presentational/StaticDescriptions/children-rest/plan.tsx": [
		1887,
		9,
		479
	],
	"./presentational/StaticDescriptions/clinics": [
		897,
		9,
		82
	],
	"./presentational/StaticDescriptions/clinics/": [
		897,
		9,
		82
	],
	"./presentational/StaticDescriptions/clinics/ideas": [
		1888,
		9,
		480
	],
	"./presentational/StaticDescriptions/clinics/ideas.tsx": [
		1888,
		9,
		480
	],
	"./presentational/StaticDescriptions/clinics/index": [
		897,
		9,
		82
	],
	"./presentational/StaticDescriptions/clinics/index.tsx": [
		897,
		9,
		82
	],
	"./presentational/StaticDescriptions/clinics/plan": [
		1889,
		9,
		481
	],
	"./presentational/StaticDescriptions/clinics/plan.tsx": [
		1889,
		9,
		481
	],
	"./presentational/StaticDescriptions/cmy/plan": [
		1890,
		9,
		482
	],
	"./presentational/StaticDescriptions/cmy/plan.tsx": [
		1890,
		9,
		482
	],
	"./presentational/StaticDescriptions/cult/plan": [
		1891,
		9,
		483
	],
	"./presentational/StaticDescriptions/cult/plan.tsx": [
		1891,
		9,
		483
	],
	"./presentational/StaticDescriptions/cult_online": [
		898,
		9,
		83
	],
	"./presentational/StaticDescriptions/cult_online/": [
		898,
		9,
		83
	],
	"./presentational/StaticDescriptions/cult_online/ideas": [
		1892,
		9,
		484
	],
	"./presentational/StaticDescriptions/cult_online/ideas.tsx": [
		1892,
		9,
		484
	],
	"./presentational/StaticDescriptions/cult_online/index": [
		898,
		9,
		83
	],
	"./presentational/StaticDescriptions/cult_online/index.tsx": [
		898,
		9,
		83
	],
	"./presentational/StaticDescriptions/cult_online/plan": [
		1893,
		9,
		485
	],
	"./presentational/StaticDescriptions/cult_online/plan.tsx": [
		1893,
		9,
		485
	],
	"./presentational/StaticDescriptions/ecology": [
		899,
		9,
		84
	],
	"./presentational/StaticDescriptions/ecology/": [
		899,
		9,
		84
	],
	"./presentational/StaticDescriptions/ecology/ideas": [
		1894,
		9,
		486
	],
	"./presentational/StaticDescriptions/ecology/ideas.tsx": [
		1894,
		9,
		486
	],
	"./presentational/StaticDescriptions/ecology/index": [
		899,
		9,
		84
	],
	"./presentational/StaticDescriptions/ecology/index.tsx": [
		899,
		9,
		84
	],
	"./presentational/StaticDescriptions/ecology/plan": [
		1895,
		9,
		487
	],
	"./presentational/StaticDescriptions/ecology/plan.tsx": [
		1895,
		9,
		487
	],
	"./presentational/StaticDescriptions/el_uslugi": [
		900,
		9,
		85
	],
	"./presentational/StaticDescriptions/el_uslugi/": [
		900,
		9,
		85
	],
	"./presentational/StaticDescriptions/el_uslugi/ideas": [
		1896,
		9,
		488
	],
	"./presentational/StaticDescriptions/el_uslugi/ideas.tsx": [
		1896,
		9,
		488
	],
	"./presentational/StaticDescriptions/el_uslugi/index": [
		900,
		9,
		85
	],
	"./presentational/StaticDescriptions/el_uslugi/index.tsx": [
		900,
		9,
		85
	],
	"./presentational/StaticDescriptions/el_uslugi/plan": [
		1897,
		9,
		489
	],
	"./presentational/StaticDescriptions/el_uslugi/plan.tsx": [
		1897,
		9,
		489
	],
	"./presentational/StaticDescriptions/el_zhkkh/ideas": [
		1898,
		9,
		490
	],
	"./presentational/StaticDescriptions/el_zhkkh/ideas.tsx": [
		1898,
		9,
		490
	],
	"./presentational/StaticDescriptions/el_zhkkh/plan": [
		1899,
		9,
		491
	],
	"./presentational/StaticDescriptions/el_zhkkh/plan.tsx": [
		1899,
		9,
		491
	],
	"./presentational/StaticDescriptions/elektronnyj_dom": [
		901,
		9,
		86
	],
	"./presentational/StaticDescriptions/elektronnyj_dom/": [
		901,
		9,
		86
	],
	"./presentational/StaticDescriptions/elektronnyj_dom/ideas": [
		1900,
		9,
		492
	],
	"./presentational/StaticDescriptions/elektronnyj_dom/ideas.tsx": [
		1900,
		9,
		492
	],
	"./presentational/StaticDescriptions/elektronnyj_dom/index": [
		901,
		9,
		86
	],
	"./presentational/StaticDescriptions/elektronnyj_dom/index.tsx": [
		901,
		9,
		86
	],
	"./presentational/StaticDescriptions/elektronnyj_dom/plan": [
		1901,
		9,
		493
	],
	"./presentational/StaticDescriptions/elektronnyj_dom/plan.tsx": [
		1901,
		9,
		493
	],
	"./presentational/StaticDescriptions/gmst/ideas": [
		1902,
		9,
		494
	],
	"./presentational/StaticDescriptions/gmst/ideas.tsx": [
		1902,
		9,
		494
	],
	"./presentational/StaticDescriptions/gmst/plan": [
		1903,
		9,
		495
	],
	"./presentational/StaticDescriptions/gmst/plan.tsx": [
		1903,
		9,
		495
	],
	"./presentational/StaticDescriptions/gorod_idei": [
		902,
		9,
		87
	],
	"./presentational/StaticDescriptions/gorod_idei/": [
		902,
		9,
		87
	],
	"./presentational/StaticDescriptions/gorod_idei/ideas": [
		1904,
		9,
		496
	],
	"./presentational/StaticDescriptions/gorod_idei/ideas.tsx": [
		1904,
		9,
		496
	],
	"./presentational/StaticDescriptions/gorod_idei/index": [
		902,
		9,
		87
	],
	"./presentational/StaticDescriptions/gorod_idei/index.tsx": [
		902,
		9,
		87
	],
	"./presentational/StaticDescriptions/gorod_idei/plan": [
		1905,
		9,
		497
	],
	"./presentational/StaticDescriptions/gorod_idei/plan.tsx": [
		1905,
		9,
		497
	],
	"./presentational/StaticDescriptions/highload_proj": [
		903,
		9,
		88
	],
	"./presentational/StaticDescriptions/highload_proj/": [
		903,
		9,
		88
	],
	"./presentational/StaticDescriptions/highload_proj/ideas": [
		1906,
		9,
		498
	],
	"./presentational/StaticDescriptions/highload_proj/ideas.tsx": [
		1906,
		9,
		498
	],
	"./presentational/StaticDescriptions/highload_proj/index": [
		903,
		9,
		88
	],
	"./presentational/StaticDescriptions/highload_proj/index.tsx": [
		903,
		9,
		88
	],
	"./presentational/StaticDescriptions/highload_proj/plan": [
		1907,
		9,
		499
	],
	"./presentational/StaticDescriptions/highload_proj/plan.tsx": [
		1907,
		9,
		499
	],
	"./presentational/StaticDescriptions/libraries": [
		904,
		9,
		89
	],
	"./presentational/StaticDescriptions/libraries/": [
		904,
		9,
		89
	],
	"./presentational/StaticDescriptions/libraries/ideas": [
		1908,
		9,
		500
	],
	"./presentational/StaticDescriptions/libraries/ideas.tsx": [
		1908,
		9,
		500
	],
	"./presentational/StaticDescriptions/libraries/index": [
		904,
		9,
		89
	],
	"./presentational/StaticDescriptions/libraries/index.tsx": [
		904,
		9,
		89
	],
	"./presentational/StaticDescriptions/libraries/plan": [
		1909,
		9,
		501
	],
	"./presentational/StaticDescriptions/libraries/plan.tsx": [
		1909,
		9,
		501
	],
	"./presentational/StaticDescriptions/mcd": [
		905,
		9,
		90
	],
	"./presentational/StaticDescriptions/mcd/": [
		905,
		9,
		90
	],
	"./presentational/StaticDescriptions/mcd/ideas": [
		1910,
		9,
		502
	],
	"./presentational/StaticDescriptions/mcd/ideas.tsx": [
		1910,
		9,
		502
	],
	"./presentational/StaticDescriptions/mcd/index": [
		905,
		9,
		90
	],
	"./presentational/StaticDescriptions/mcd/index.tsx": [
		905,
		9,
		90
	],
	"./presentational/StaticDescriptions/mcd/plan": [
		1911,
		9,
		503
	],
	"./presentational/StaticDescriptions/mcd/plan.tsx": [
		1911,
		9,
		503
	],
	"./presentational/StaticDescriptions/mic/plan": [
		1912,
		9,
		504
	],
	"./presentational/StaticDescriptions/mic/plan.tsx": [
		1912,
		9,
		504
	],
	"./presentational/StaticDescriptions/ml/plan": [
		1913,
		9,
		505
	],
	"./presentational/StaticDescriptions/ml/plan.tsx": [
		1913,
		9,
		505
	],
	"./presentational/StaticDescriptions/moi_park": [
		906,
		9,
		91
	],
	"./presentational/StaticDescriptions/moi_park/": [
		906,
		9,
		91
	],
	"./presentational/StaticDescriptions/moi_park/ideas": [
		1914,
		9,
		506
	],
	"./presentational/StaticDescriptions/moi_park/ideas.tsx": [
		1914,
		9,
		506
	],
	"./presentational/StaticDescriptions/moi_park/index": [
		906,
		9,
		91
	],
	"./presentational/StaticDescriptions/moi_park/index.tsx": [
		906,
		9,
		91
	],
	"./presentational/StaticDescriptions/moi_park/plan": [
		1915,
		9,
		507
	],
	"./presentational/StaticDescriptions/moi_park/plan.tsx": [
		1915,
		9,
		507
	],
	"./presentational/StaticDescriptions/moscowdc": [
		907,
		9,
		92
	],
	"./presentational/StaticDescriptions/moscowdc/": [
		907,
		9,
		92
	],
	"./presentational/StaticDescriptions/moscowdc/ideas": [
		1916,
		9,
		508
	],
	"./presentational/StaticDescriptions/moscowdc/ideas.tsx": [
		1916,
		9,
		508
	],
	"./presentational/StaticDescriptions/moscowdc/index": [
		907,
		9,
		92
	],
	"./presentational/StaticDescriptions/moscowdc/index.tsx": [
		907,
		9,
		92
	],
	"./presentational/StaticDescriptions/moscowdc/plan": [
		1917,
		9,
		509
	],
	"./presentational/StaticDescriptions/moscowdc/plan.tsx": [
		1917,
		9,
		509
	],
	"./presentational/StaticDescriptions/museums": [
		908,
		9,
		93
	],
	"./presentational/StaticDescriptions/museums/": [
		908,
		9,
		93
	],
	"./presentational/StaticDescriptions/museums/ideas": [
		1918,
		9,
		510
	],
	"./presentational/StaticDescriptions/museums/ideas.tsx": [
		1918,
		9,
		510
	],
	"./presentational/StaticDescriptions/museums/index": [
		908,
		9,
		93
	],
	"./presentational/StaticDescriptions/museums/index.tsx": [
		908,
		9,
		93
	],
	"./presentational/StaticDescriptions/museums/plan": [
		1919,
		9,
		511
	],
	"./presentational/StaticDescriptions/museums/plan.tsx": [
		1919,
		9,
		511
	],
	"./presentational/StaticDescriptions/my-office": [
		909,
		9,
		94
	],
	"./presentational/StaticDescriptions/my-office/": [
		909,
		9,
		94
	],
	"./presentational/StaticDescriptions/my-office/ideas": [
		1920,
		9,
		512
	],
	"./presentational/StaticDescriptions/my-office/ideas.tsx": [
		1920,
		9,
		512
	],
	"./presentational/StaticDescriptions/my-office/index": [
		909,
		9,
		94
	],
	"./presentational/StaticDescriptions/my-office/index.tsx": [
		909,
		9,
		94
	],
	"./presentational/StaticDescriptions/my-office/plan": [
		1921,
		9,
		513
	],
	"./presentational/StaticDescriptions/my-office/plan.tsx": [
		1921,
		9,
		513
	],
	"./presentational/StaticDescriptions/mymos": [
		910,
		9,
		95
	],
	"./presentational/StaticDescriptions/mymos/": [
		910,
		9,
		95
	],
	"./presentational/StaticDescriptions/mymos/ideas": [
		1922,
		9,
		514
	],
	"./presentational/StaticDescriptions/mymos/ideas.tsx": [
		1922,
		9,
		514
	],
	"./presentational/StaticDescriptions/mymos/index": [
		910,
		9,
		95
	],
	"./presentational/StaticDescriptions/mymos/index.tsx": [
		910,
		9,
		95
	],
	"./presentational/StaticDescriptions/mymos/plan": [
		1923,
		9,
		515
	],
	"./presentational/StaticDescriptions/mymos/plan.tsx": [
		1923,
		9,
		515
	],
	"./presentational/StaticDescriptions/nashgorod2": [
		911,
		9,
		96
	],
	"./presentational/StaticDescriptions/nashgorod2/": [
		911,
		9,
		96
	],
	"./presentational/StaticDescriptions/nashgorod2/ideas": [
		1924,
		9,
		516
	],
	"./presentational/StaticDescriptions/nashgorod2/ideas.tsx": [
		1924,
		9,
		516
	],
	"./presentational/StaticDescriptions/nashgorod2/index": [
		911,
		9,
		96
	],
	"./presentational/StaticDescriptions/nashgorod2/index.tsx": [
		911,
		9,
		96
	],
	"./presentational/StaticDescriptions/nashgorod2/plan": [
		1925,
		9,
		517
	],
	"./presentational/StaticDescriptions/nashgorod2/plan.tsx": [
		1925,
		9,
		517
	],
	"./presentational/StaticDescriptions/nb": [
		912,
		9,
		97
	],
	"./presentational/StaticDescriptions/nb/": [
		912,
		9,
		97
	],
	"./presentational/StaticDescriptions/nb/ideas": [
		1926,
		9,
		518
	],
	"./presentational/StaticDescriptions/nb/ideas.tsx": [
		1926,
		9,
		518
	],
	"./presentational/StaticDescriptions/nb/index": [
		912,
		9,
		97
	],
	"./presentational/StaticDescriptions/nb/index.tsx": [
		912,
		9,
		97
	],
	"./presentational/StaticDescriptions/nb/plan": [
		1927,
		9,
		519
	],
	"./presentational/StaticDescriptions/nb/plan.tsx": [
		1927,
		9,
		519
	],
	"./presentational/StaticDescriptions/novayaplatforma": [
		913,
		9,
		98
	],
	"./presentational/StaticDescriptions/novayaplatforma/": [
		913,
		9,
		98
	],
	"./presentational/StaticDescriptions/novayaplatforma/ideas": [
		1928,
		9,
		520
	],
	"./presentational/StaticDescriptions/novayaplatforma/ideas.tsx": [
		1928,
		9,
		520
	],
	"./presentational/StaticDescriptions/novayaplatforma/index": [
		913,
		9,
		98
	],
	"./presentational/StaticDescriptions/novayaplatforma/index.tsx": [
		913,
		9,
		98
	],
	"./presentational/StaticDescriptions/novayaplatforma/plan": [
		1929,
		9,
		521
	],
	"./presentational/StaticDescriptions/novayaplatforma/plan.tsx": [
		1929,
		9,
		521
	],
	"./presentational/StaticDescriptions/our-city": [
		914,
		9,
		99
	],
	"./presentational/StaticDescriptions/our-city/": [
		914,
		9,
		99
	],
	"./presentational/StaticDescriptions/our-city/ideas": [
		1930,
		9,
		522
	],
	"./presentational/StaticDescriptions/our-city/ideas.tsx": [
		1930,
		9,
		522
	],
	"./presentational/StaticDescriptions/our-city/index": [
		914,
		9,
		99
	],
	"./presentational/StaticDescriptions/our-city/index.tsx": [
		914,
		9,
		99
	],
	"./presentational/StaticDescriptions/our-city/plan": [
		1931,
		9,
		523
	],
	"./presentational/StaticDescriptions/our-city/plan.tsx": [
		1931,
		9,
		523
	],
	"./presentational/StaticDescriptions/our-routes": [
		915,
		9,
		100
	],
	"./presentational/StaticDescriptions/our-routes/": [
		915,
		9,
		100
	],
	"./presentational/StaticDescriptions/our-routes/ideas": [
		1932,
		9,
		524
	],
	"./presentational/StaticDescriptions/our-routes/ideas.tsx": [
		1932,
		9,
		524
	],
	"./presentational/StaticDescriptions/our-routes/index": [
		915,
		9,
		100
	],
	"./presentational/StaticDescriptions/our-routes/index.tsx": [
		915,
		9,
		100
	],
	"./presentational/StaticDescriptions/our-routes/plan": [
		1933,
		9,
		525
	],
	"./presentational/StaticDescriptions/our-routes/plan.tsx": [
		1933,
		9,
		525
	],
	"./presentational/StaticDescriptions/project_sport": [
		916,
		9,
		101
	],
	"./presentational/StaticDescriptions/project_sport/": [
		916,
		9,
		101
	],
	"./presentational/StaticDescriptions/project_sport/ideas": [
		1934,
		9,
		526
	],
	"./presentational/StaticDescriptions/project_sport/ideas.tsx": [
		1934,
		9,
		526
	],
	"./presentational/StaticDescriptions/project_sport/index": [
		916,
		9,
		101
	],
	"./presentational/StaticDescriptions/project_sport/index.tsx": [
		916,
		9,
		101
	],
	"./presentational/StaticDescriptions/project_sport/plan": [
		1935,
		9,
		527
	],
	"./presentational/StaticDescriptions/project_sport/plan.tsx": [
		1935,
		9,
		527
	],
	"./presentational/StaticDescriptions/school-board": [
		917,
		9,
		102
	],
	"./presentational/StaticDescriptions/school-board/": [
		917,
		9,
		102
	],
	"./presentational/StaticDescriptions/school-board/ideas": [
		1936,
		9,
		528
	],
	"./presentational/StaticDescriptions/school-board/ideas.tsx": [
		1936,
		9,
		528
	],
	"./presentational/StaticDescriptions/school-board/index": [
		917,
		9,
		102
	],
	"./presentational/StaticDescriptions/school-board/index.tsx": [
		917,
		9,
		102
	],
	"./presentational/StaticDescriptions/school-board/plan": [
		1937,
		9,
		529
	],
	"./presentational/StaticDescriptions/school-board/plan.tsx": [
		1937,
		9,
		529
	],
	"./presentational/StaticDescriptions/smart_city2030": [
		918,
		9,
		103
	],
	"./presentational/StaticDescriptions/smart_city2030/": [
		918,
		9,
		103
	],
	"./presentational/StaticDescriptions/smart_city2030/ideas": [
		1938,
		9,
		530
	],
	"./presentational/StaticDescriptions/smart_city2030/ideas.tsx": [
		1938,
		9,
		530
	],
	"./presentational/StaticDescriptions/smart_city2030/index": [
		918,
		9,
		103
	],
	"./presentational/StaticDescriptions/smart_city2030/index.tsx": [
		918,
		9,
		103
	],
	"./presentational/StaticDescriptions/smart_city2030/plan": [
		1939,
		9,
		531
	],
	"./presentational/StaticDescriptions/smart_city2030/plan.tsx": [
		1939,
		9,
		531
	],
	"./presentational/StaticDescriptions/technograd/ideas": [
		1940,
		9,
		532
	],
	"./presentational/StaticDescriptions/technograd/ideas.tsx": [
		1940,
		9,
		532
	],
	"./presentational/StaticDescriptions/technograd/plan": [
		1941,
		9,
		533
	],
	"./presentational/StaticDescriptions/technograd/plan.tsx": [
		1941,
		9,
		533
	],
	"./presentational/StaticDescriptions/um": [
		919,
		9,
		104
	],
	"./presentational/StaticDescriptions/um/": [
		919,
		9,
		104
	],
	"./presentational/StaticDescriptions/um/ideas": [
		1942,
		9,
		534
	],
	"./presentational/StaticDescriptions/um/ideas.tsx": [
		1942,
		9,
		534
	],
	"./presentational/StaticDescriptions/um/index": [
		919,
		9,
		104
	],
	"./presentational/StaticDescriptions/um/index.tsx": [
		919,
		9,
		104
	],
	"./presentational/StaticDescriptions/um/plan": [
		1943,
		9,
		535
	],
	"./presentational/StaticDescriptions/um/plan.tsx": [
		1943,
		9,
		535
	],
	"./presentational/StaticDescriptions/uslugi": [
		920,
		9,
		105
	],
	"./presentational/StaticDescriptions/uslugi/": [
		920,
		9,
		105
	],
	"./presentational/StaticDescriptions/uslugi/ideas": [
		1944,
		9,
		536
	],
	"./presentational/StaticDescriptions/uslugi/ideas.tsx": [
		1944,
		9,
		536
	],
	"./presentational/StaticDescriptions/uslugi/index": [
		920,
		9,
		105
	],
	"./presentational/StaticDescriptions/uslugi/index.tsx": [
		920,
		9,
		105
	],
	"./presentational/StaticDescriptions/uslugi/plan": [
		1945,
		9,
		537
	],
	"./presentational/StaticDescriptions/uslugi/plan.tsx": [
		1945,
		9,
		537
	],
	"./presentational/StaticDescriptions/vm/ideas": [
		1946,
		9,
		538
	],
	"./presentational/StaticDescriptions/vm/ideas.tsx": [
		1946,
		9,
		538
	],
	"./presentational/StaticDescriptions/vm/plan": [
		1947,
		9,
		539
	],
	"./presentational/StaticDescriptions/vm/plan.tsx": [
		1947,
		9,
		539
	],
	"./presentational/StaticDescriptions/vp": [
		921,
		9,
		106
	],
	"./presentational/StaticDescriptions/vp/": [
		921,
		9,
		106
	],
	"./presentational/StaticDescriptions/vp/ideas": [
		1948,
		9,
		540
	],
	"./presentational/StaticDescriptions/vp/ideas.tsx": [
		1948,
		9,
		540
	],
	"./presentational/StaticDescriptions/vp/index": [
		921,
		9,
		106
	],
	"./presentational/StaticDescriptions/vp/index.tsx": [
		921,
		9,
		106
	],
	"./presentational/StaticDescriptions/vp/plan": [
		1949,
		9,
		541
	],
	"./presentational/StaticDescriptions/vp/plan.tsx": [
		1949,
		9,
		541
	],
	"./presentational/StaticDescriptions/wild-animals": [
		922,
		9,
		71
	],
	"./presentational/StaticDescriptions/wild-animals/": [
		922,
		9,
		71
	],
	"./presentational/StaticDescriptions/wild-animals/ideas": [
		1950,
		9,
		337
	],
	"./presentational/StaticDescriptions/wild-animals/ideas.tsx": [
		1950,
		9,
		337
	],
	"./presentational/StaticDescriptions/wild-animals/index": [
		922,
		9,
		71
	],
	"./presentational/StaticDescriptions/wild-animals/index.tsx": [
		922,
		9,
		71
	],
	"./presentational/StaticDescriptions/wild-animals/plan": [
		1951,
		9,
		338
	],
	"./presentational/StaticDescriptions/wild-animals/plan.tsx": [
		1951,
		9,
		338
	],
	"./presentational/StaticDescriptions/wild-animals/styles.scss": [
		2796,
		7,
		701
	],
	"./presentational/StaticDescriptions/zm": [
		923,
		9,
		107
	],
	"./presentational/StaticDescriptions/zm/": [
		923,
		9,
		107
	],
	"./presentational/StaticDescriptions/zm/ideas": [
		1952,
		9,
		542
	],
	"./presentational/StaticDescriptions/zm/ideas.tsx": [
		1952,
		9,
		542
	],
	"./presentational/StaticDescriptions/zm/index": [
		923,
		9,
		107
	],
	"./presentational/StaticDescriptions/zm/index.tsx": [
		923,
		9,
		107
	],
	"./presentational/StaticDescriptions/zm/plan": [
		1953,
		9,
		543
	],
	"./presentational/StaticDescriptions/zm/plan.tsx": [
		1953,
		9,
		543
	],
	"./presentational/Timer/Timer": [
		644,
		9
	],
	"./presentational/Timer/Timer.scss": [
		2868,
		7,
		702
	],
	"./presentational/Timer/Timer.tsx": [
		644,
		9
	],
	"./presentational/Typography/Base": [
		288,
		9
	],
	"./presentational/Typography/Base/": [
		288,
		9
	],
	"./presentational/Typography/Base/Base": [
		514,
		9
	],
	"./presentational/Typography/Base/Base.module.scss": [
		207,
		7
	],
	"./presentational/Typography/Base/Base.tsx": [
		514,
		9
	],
	"./presentational/Typography/Base/Base.types": [
		1954,
		9,
		544
	],
	"./presentational/Typography/Base/Base.types.ts": [
		1954,
		9,
		544
	],
	"./presentational/Typography/Base/index": [
		288,
		9
	],
	"./presentational/Typography/Base/index.tsx": [
		288,
		9
	],
	"./presentational/Typography/Heading": [
		94,
		9
	],
	"./presentational/Typography/Heading/": [
		94,
		9
	],
	"./presentational/Typography/Heading/Heading": [
		523,
		9
	],
	"./presentational/Typography/Heading/Heading.module.scss": [
		336,
		7
	],
	"./presentational/Typography/Heading/Heading.tsx": [
		523,
		9
	],
	"./presentational/Typography/Heading/Heading.types": [
		1955,
		9,
		545
	],
	"./presentational/Typography/Heading/Heading.types.ts": [
		1955,
		9,
		545
	],
	"./presentational/Typography/Heading/index": [
		94,
		9
	],
	"./presentational/Typography/Heading/index.tsx": [
		94,
		9
	],
	"./presentational/Typography/Text": [
		33,
		9
	],
	"./presentational/Typography/Text/": [
		33,
		9
	],
	"./presentational/Typography/Text/Text": [
		513,
		9
	],
	"./presentational/Typography/Text/Text.module.scss": [
		334,
		7
	],
	"./presentational/Typography/Text/Text.tsx": [
		513,
		9
	],
	"./presentational/Typography/Text/Text.types": [
		1956,
		9,
		546
	],
	"./presentational/Typography/Text/Text.types.ts": [
		1956,
		9,
		546
	],
	"./presentational/Typography/Text/index": [
		33,
		9
	],
	"./presentational/Typography/Text/index.tsx": [
		33,
		9
	],
	"./presentational/UserAvatar/UserAvatar": [
		255,
		9
	],
	"./presentational/UserAvatar/UserAvatar.scss": [
		1409,
		7
	],
	"./presentational/UserAvatar/UserAvatar.tsx": [
		255,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2342;
module.exports = webpackAsyncContext;